export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  Currency: { input: string; output: string }
  Date: { input: string; output: string }
  DateTime: { input: string; output: string }
  DateTimeOffset: { input: string; output: string }
  Decimal: { input: number; output: number }
  Long: { input: number; output: number }
  Milliseconds: { input: number; output: number }
  Seconds: { input: number; output: number }
}

export type Action = CustomAction | LinkAction

export type ActivateDigitalGift = {
  __typename: 'ActivateDigitalGift'
  _?: Maybe<Scalars['Boolean']['output']>
}

export type ActivateRedemptionInput = {
  id: Scalars['ID']['input']
}

export type AddAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  country: Scalars['String']['input']
  extraAddressLine?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  houseNumber?: InputMaybe<Scalars['String']['input']>
  houseNumberExtension?: InputMaybe<Scalars['String']['input']>
  isMyAddress: Scalars['Boolean']['input']
  lastName: Scalars['String']['input']
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  streetName: Scalars['String']['input']
}

export type AddAddressRequestAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  country: Scalars['String']['input']
  extraAddressLine?: InputMaybe<Scalars['String']['input']>
  houseNumber?: InputMaybe<Scalars['String']['input']>
  houseNumberExtension?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  streetName: Scalars['String']['input']
}

export type AddAddressRequestAddressResult =
  | AddAddressRequestAddressSuccess
  | AddressError
  | AddressRequestNotFoundError
  | AddressRequestProcessedError

export type AddAddressRequestAddressSuccess = {
  __typename: 'AddAddressRequestAddressSuccess'
  message: Scalars['String']['output']
}

export type AddAddressResult = AddAddressSuccess | AddressError

export type AddAddressSuccess = {
  __typename: 'AddAddressSuccess'
  address: ShippingAddress
  addressBook?: Maybe<AddressBook>
}

export type AddAddressesError = Error & {
  __typename: 'AddAddressesError'
  addressErrors: Array<KeyedAddAddressesError>
  message: Scalars['String']['output']
}

export type AddAddressesInput = {
  addresses: Array<AddAddressesItemInput>
}

export type AddAddressesItemInput = {
  city?: InputMaybe<Scalars['String']['input']>
  country: Scalars['String']['input']
  extraAddressLine?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  houseNumber?: InputMaybe<Scalars['String']['input']>
  houseNumberExtension?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  lastName: Scalars['String']['input']
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  streetName: Scalars['String']['input']
}

export type AddAddressesResult = AddAddressesError | AddAddressesSuccess

export type AddAddressesSuccess = {
  __typename: 'AddAddressesSuccess'
  addressBook?: Maybe<AddressBook>
  addresses: Array<ShippingAddress>
}

export type AddCardAndDigitalGiftResult =
  | Basket
  | ConcurrentModificationError
  | ProductNotFoundError

export type AddCardAndDigitalGiftToBasketInput = {
  cardSku: Scalars['String']['input']
  designId: Scalars['ID']['input']
  digitalGiftSku: Scalars['String']['input']
}

export type AddCreditsInput = {
  authCode: Scalars['String']['input']
  expiryDate?: InputMaybe<Scalars['String']['input']>
  initialBalance: Scalars['Int']['input']
  reason: Scalars['String']['input']
}

export type AddCreditsResult = {
  __typename: 'AddCreditsResult'
  accounts?: Maybe<Array<Maybe<CreditAccount>>>
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type AddCustomerAddressInvalidCountry = Error & {
  __typename: 'AddCustomerAddressInvalidCountry'
  message: Scalars['String']['output']
}

export type AddCustomerAddressInvalidError = Error & {
  __typename: 'AddCustomerAddressInvalidError'
  message: Scalars['String']['output']
}

export type AddCustomerAddressResult =
  | AddCustomerAddressInvalidCountry
  | AddCustomerAddressInvalidError
  | ConcurrentModificationError
  | Customer
  | UserInputError

export type AddCustomerAddressesInvalidError = Error & {
  __typename: 'AddCustomerAddressesInvalidError'
  addressErrors: Array<KeyedCustomerAddressErrorMessage>
  message: Scalars['String']['output']
}

export type AddCustomerAddressesResult =
  | AddCustomerAddressInvalidError
  | AddCustomerAddressesInvalidError
  | ConcurrentModificationError
  | Customer
  | UserInputError

export type AddDesignToBasketInput = {
  /** Defaults to [] */
  addons?: InputMaybe<Array<DesignAddonInput>>
  designId: Scalars['ID']['input']
  /** Defaults to 1 */
  quantity?: InputMaybe<Scalars['Int']['input']>
  sku: Scalars['String']['input']
}

export type AddDesignToBasketResult =
  | DesignAddedToBasket
  | DesignAuthorizationError
  | DesignNotFoundError
  | DesignProductNotFoundError
  | DesignServiceError
  | DesignTemplatesServiceError
  | DesignValidationError

export type AddDigitalGiftToBasketInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  parentLineItemId: Scalars['ID']['input']
  sku: Scalars['String']['input']
}

export type AddDigitalGiftToBasketResult =
  | Basket
  | BasketNotFoundError
  | LineItemNotFoundError
  | ProductNotFoundError

export type AddMembershipToBasketAction = {
  __typename: 'AddMembershipToBasketAction'
  membershipType: MembershipType
}

export type AddMembershipToBasketInput = {
  discountCode?: InputMaybe<Scalars['String']['input']>
  /** @deprecated No longer necessary */
  id?: InputMaybe<Scalars['ID']['input']>
  membershipType: MembershipType
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type AddMembershipToBasketResult =
  | Basket
  | ConcurrentModificationError
  | MembershipUnavailableError
  | MembershipVoucherError

export type AddMessageStateResult =
  | GroupCardProjectClosedState
  | GroupCardProjectFullState
  | GroupCardProjectOpenAuthenticatedState
  | GroupCardProjectOpenState
  | GroupCardServiceError

export type AddMessageStateResultV2 =
  | GroupCardProjectArchivedState
  | GroupCardProjectClosedStateV2
  | GroupCardProjectFullStateV2
  | GroupCardProjectOpenAuthenticatedStateV2
  | GroupCardProjectOpenStateV2
  | GroupCardServiceError

export type AddToBasketAndSplitInput = {
  addons?: InputMaybe<Array<AddonInput>>
  quantity: Scalars['Int']['input']
  sku: Scalars['String']['input']
}

export type AddToBasketAndSplitResult =
  | Basket
  | ConcurrentModificationError
  | ProductNotFoundError

export enum AddToBasketFlow {
  DIGITAL = 'DIGITAL',
  STANDARD = 'STANDARD',
}

export type AddToBasketInput = {
  addons?: InputMaybe<Array<AddonInput>>
  /** @deprecated No longer in use, please provide designId */
  customisationId?: InputMaybe<Scalars['String']['input']>
  designId?: InputMaybe<Scalars['ID']['input']>
  quantity: Scalars['Int']['input']
  sku: Scalars['String']['input']
  store?: InputMaybe<Store>
}

export type AddToBasketResult =
  | Basket
  | ConcurrentModificationError
  | ProductNotFoundError

export type AddToFavouritesList = {
  __typename: 'AddToFavouritesList'
  products: Array<Maybe<Product>>
}

export type Addon = {
  __typename: 'Addon'
  description: Scalars['String']['output']
  image: Image
  inStock: Scalars['Boolean']['output']
  price: Money
  sku: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type AddonInput = {
  sku: Scalars['String']['input']
}

export enum AddressActionType {
  CAN_HAVE_MULTIPLE = 'CAN_HAVE_MULTIPLE',
  COMPLETE = 'COMPLETE',
  REQUIRES_MULTIPLE = 'REQUIRES_MULTIPLE',
  REQUIRES_SINGLE = 'REQUIRES_SINGLE',
}

export type AddressBook = {
  __typename: 'AddressBook'
  addresses: Array<ShippingAddress>
}

export type AddressCountrySchema = AddressSchema & {
  __typename: 'AddressCountrySchema'
  country: Scalars['String']['output']
  fieldGroups: Array<AddressFieldGroup>
}

export type AddressDefaultSchema = AddressSchema & {
  __typename: 'AddressDefaultSchema'
  fieldGroups: Array<AddressFieldGroup>
}

export type AddressError = Error & {
  __typename: 'AddressError'
  message: Scalars['String']['output']
}

export type AddressField = {
  key: Scalars['String']['output']
  label: Scalars['String']['output']
}

export type AddressFieldConstraint = {
  message: Scalars['String']['output']
}

export type AddressFieldGroup = {
  __typename: 'AddressFieldGroup'
  fields: Array<AddressField>
}

export type AddressFieldOption = {
  __typename: 'AddressFieldOption'
  label: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type AddressInvalidErrors = Errors & {
  __typename: 'AddressInvalidErrors'
  id: Scalars['String']['output']
  messages: Array<Scalars['String']['output']>
}

export type AddressLookupError = Error & {
  __typename: 'AddressLookupError'
  message: Scalars['String']['output']
}

export type AddressLookupInput = {
  country: Scalars['String']['input']
  houseNumber?: InputMaybe<Scalars['String']['input']>
  houseNumberExtension?: InputMaybe<Scalars['String']['input']>
  postalCode: Scalars['String']['input']
}

export type AddressLookupResult = AddressLookupError | AddressLookupSuccess

export type AddressLookupSuccess = {
  __typename: 'AddressLookupSuccess'
  addresses: Array<LookupAddress>
}

export type AddressMaxLengthConstraint = AddressFieldConstraint & {
  __typename: 'AddressMaxLengthConstraint'
  max: Scalars['Int']['output']
  message: Scalars['String']['output']
}

export type AddressNotFoundError = Error & {
  __typename: 'AddressNotFoundError'
  message: Scalars['String']['output']
}

export type AddressPatternConstraint = AddressFieldConstraint & {
  __typename: 'AddressPatternConstraint'
  message: Scalars['String']['output']
  regex: Scalars['String']['output']
}

export type AddressRequest = {
  __typename: 'AddressRequest'
  expiryMessage: Scalars['String']['output']
  id: Scalars['String']['output']
  recipientFirstName: Scalars['String']['output']
  recipientLastName: Scalars['String']['output']
  shareableMessage: Scalars['String']['output']
  webUrl: Scalars['String']['output']
}

export type AddressRequestInputError = Error & {
  __typename: 'AddressRequestInputError'
  message: Scalars['String']['output']
}

export type AddressRequestNotFoundError = Error & {
  __typename: 'AddressRequestNotFoundError'
  message: Scalars['String']['output']
}

export type AddressRequestProcessedError = Error & {
  __typename: 'AddressRequestProcessedError'
  message: Scalars['String']['output']
}

export type AddressRequestResult =
  | AddressRequestNotFoundError
  | AddressRequestProcessedError
  | AddressRequestResultSuccess

export type AddressRequestResultSuccess = {
  __typename: 'AddressRequestResultSuccess'
  customerFirstName: Scalars['String']['output']
  customerLastName: Scalars['String']['output']
  dateCreated: Scalars['String']['output']
  dateProcessed?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  recipientFirstName: Scalars['String']['output']
  recipientLastName: Scalars['String']['output']
}

export type AddressRequests = {
  __typename: 'AddressRequests'
  count: Scalars['Int']['output']
  items: Array<AddressRequest>
}

export type AddressRequiredConstraint = AddressFieldConstraint & {
  __typename: 'AddressRequiredConstraint'
  message: Scalars['String']['output']
}

export type AddressSchema = {
  fieldGroups: Array<AddressFieldGroup>
}

export type AddressSchemasResult = {
  __typename: 'AddressSchemasResult'
  countrySchemas: Array<AddressCountrySchema>
  countrySelect: AddressSelectField
  defaultSchema: AddressDefaultSchema
}

export type AddressSelectField = AddressField & {
  __typename: 'AddressSelectField'
  key: Scalars['String']['output']
  label: Scalars['String']['output']
  options: Array<AddressFieldOption>
}

export type AddressTextField = AddressField & {
  __typename: 'AddressTextField'
  constraints?: Maybe<AddressTextFieldConstraints>
  key: Scalars['String']['output']
  label: Scalars['String']['output']
  placeholder?: Maybe<Scalars['String']['output']>
}

export type AddressTextFieldConstraints = {
  __typename: 'AddressTextFieldConstraints'
  maxLength?: Maybe<AddressMaxLengthConstraint>
  pattern?: Maybe<AddressPatternConstraint>
  required?: Maybe<AddressRequiredConstraint>
}

export type AlternativeSearchDepartmentCount = {
  __typename: 'AlternativeSearchDepartmentCount'
  count: Scalars['Int']['output']
  department: DepartmentsEnum
  label: Scalars['String']['output']
}

export enum AmendErrorCode {
  DELIVERY_NOT_FOUND = 'DELIVERY_NOT_FOUND',
  LINE_ITEM_NOT_FOUND = 'LINE_ITEM_NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
}

export type AmendResult = {
  message: Scalars['String']['output']
}

export type Announcement = {
  __typename: 'Announcement'
  cta: CTA
  detail: Scalars['String']['output']
  heading: Scalars['String']['output']
  id: Scalars['ID']['output']
  image: ContentImage
  title: Scalars['String']['output']
}

export type AppBanner = {
  __typename: 'AppBanner'
  /** @deprecated rating is depricated. Please use reviews.stars field instead */
  rating: Scalars['Float']['output']
  reviews: AppBannerReviews
  shouldFormat: Scalars['Boolean']['output']
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
  /** @deprecated totalRatings is depricated. Please use reviews.count field instead */
  totalRatings: Scalars['String']['output']
  url: Scalars['String']['output']
  voucherCode?: Maybe<Scalars['String']['output']>
}

export type AppBannerReviews = {
  __typename: 'AppBannerReviews'
  count: Scalars['Int']['output']
  stars: Scalars['Float']['output']
}

export type ApplicableFilter = FilterFacet | InvertedToggleFilter | ToggleFilter

export type AppliedDiscount = {
  __typename: 'AppliedDiscount'
  code: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
}

export type AppliedIntent = {
  __typename: 'AppliedIntent'
  intentId: Scalars['String']['output']
  ordinal?: Maybe<Scalars['String']['output']>
  value: Scalars['String']['output']
}

export type AppliedIntentInput = {
  intentId: Scalars['String']['input']
  ordinal?: InputMaybe<Scalars['String']['input']>
  value: Scalars['String']['input']
}

export type ApplyAutoPromoError = Error & {
  __typename: 'ApplyAutoPromoError'
  message: Scalars['String']['output']
}

export type ApplyAutoPromoInput = {
  autoPromoId: Scalars['ID']['input']
  id: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type ApplyAutoPromoResult =
  | ApplyAutoPromoError
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError

export type ApplyPromoError = Error & {
  __typename: 'ApplyPromoError'
  message: Scalars['String']['output']
}

export type ApplyPromoInput = {
  id: Scalars['ID']['input']
  promoId: Scalars['ID']['input']
}

export type ApplyPromoResult =
  | ApplyPromoError
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError

export type AssignABTestVariantInput = {
  id: Scalars['ID']['input']
  variant: Scalars['String']['input']
  version: Scalars['Long']['input']
}

export type AssignABTestVariantResult =
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError

export type AssignBasketAddressInput = {
  addressId: Scalars['String']['input']
  id: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type AssignBasketAddressResult =
  | AddressNotFoundError
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryAddressInvalidError
  | DeliveryCountryInvalidError
  | DeliveryRestrictedError

export type AssignBasketVoucherError = Error & {
  __typename: 'AssignBasketVoucherError'
  message: Scalars['String']['output']
}

export type AssignBasketVoucherInput = {
  code: Scalars['String']['input']
  id: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type AssignBasketVoucherResult =
  | AssignBasketVoucherError
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError

export type AssignBillingAddressFailed = Error & {
  __typename: 'AssignBillingAddressFailed'
  message: Scalars['String']['output']
}

export type AssignBillingAddressResult = AssignBillingAddressFailed | Customer

export type AssignDeliveryAddressInput = {
  addressId: Scalars['String']['input']
  basketId: Scalars['ID']['input']
  deliveryId: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type AssignDeliveryAddressResult =
  | AddressNotFoundError
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryAddressInvalidError
  | DeliveryCountryInvalidError
  | DeliveryNotFoundError
  | DeliveryRestrictedError

export type AssignDeliveryDateInput = {
  date: Scalars['Date']['input']
  deliveryId: Scalars['String']['input']
  id: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type AssignDeliveryDateResult =
  | Basket
  | BasketEmptyError
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryNotFoundError
  | NoLineItemsExistForDeliveryIdError

export type AssignDeliveryGiftNoteError = Error & {
  __typename: 'AssignDeliveryGiftNoteError'
  message: Scalars['String']['output']
}

export type AssignDeliveryGiftNoteInput = {
  deliveryId: Scalars['String']['input']
  giftNote: Scalars['String']['input']
  id: Scalars['ID']['input']
  version: Scalars['Long']['input']
}

export type AssignDeliveryGiftNoteResult =
  | AssignDeliveryGiftNoteError
  | Basket
  | BasketEmptyError
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryNotFoundError
  | NoLineItemsExistForDeliveryIdError
  | UserInputError

export type AssignDeliveryMethodAndDateInput = {
  deliveryDate?: InputMaybe<Scalars['Date']['input']>
  deliveryId: Scalars['String']['input']
  deliveryInstructions?: InputMaybe<Scalars['String']['input']>
  deliveryMethodId: Scalars['String']['input']
  deliveryMobile?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

export type AssignDeliveryMethodAndDateResult =
  | Basket
  | BasketEmptyError
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryNotFoundError
  | NoLineItemsExistForDeliveryIdError
  | UserInputError

export type AssignDeliveryMethodInput = {
  deliveryId: Scalars['String']['input']
  deliveryInstructions?: InputMaybe<Scalars['String']['input']>
  deliveryMethodId: Scalars['String']['input']
  deliveryMobile?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type AssignDeliveryMethodResult =
  | Basket
  | BasketEmptyError
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryNotFoundError
  | NoLineItemsExistForDeliveryIdError
  | UserInputError

export type AssignLineItemAddressInput = {
  addressId: Scalars['String']['input']
  id: Scalars['ID']['input']
  lineItemId: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type AssignLineItemAddressResult =
  | AddressNotFoundError
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryAddressInvalidError
  | DeliveryCountryInvalidError
  | DeliveryRestrictedError
  | LineItemNotFoundError

export type AssignLineItemEmailAddressInput = {
  email: Scalars['String']['input']
  id: Scalars['ID']['input']
  lineItemId: Scalars['ID']['input']
  name: Scalars['String']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type AssignLineItemEmailAddressResult =
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryAddressInvalidError
  | LineItemNotFoundError

export type AssignRecipientAddressInput = {
  currentAddressId: Scalars['String']['input']
  id: Scalars['ID']['input']
  newAddressId: Scalars['String']['input']
}

export type AssignRecipientAddressResult =
  | AddressNotFoundError
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryAddressInvalidError
  | DeliveryRestrictedError

export enum Audience {
  MOBILE_WEB = 'MOBILE_WEB',
  WEB = 'WEB',
}

export type AutoPromo = {
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type AutocompleteAddress = {
  __typename: 'AutocompleteAddress'
  addressFirstLine: Scalars['String']['output']
  city?: Maybe<Scalars['String']['output']>
  country: Scalars['String']['output']
  displayAddress: Scalars['String']['output']
  displayLines: Array<Scalars['String']['output']>
  houseNumber?: Maybe<Scalars['String']['output']>
  houseNumberExtension?: Maybe<Scalars['String']['output']>
  postcode?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
}

export type AutocompleteAddressError = Error & {
  __typename: 'AutocompleteAddressError'
  message: Scalars['String']['output']
}

export type AutocompleteAddressInput = {
  country: Scalars['String']['input']
  query: Scalars['String']['input']
}

export type AutocompleteAddressResult =
  | AutocompleteAddressError
  | AutocompleteAddressSuccess

export type AutocompleteAddressSuccess = {
  __typename: 'AutocompleteAddressSuccess'
  addresses: Array<AutocompleteAddress>
}

export type AvailableDeliveryOptions = {
  __typename: 'AvailableDeliveryOptions'
  availableOptions?: Maybe<Array<DeliveryOption>>
  hasEarlierDates: Scalars['Boolean']['output']
  suggestedOptions?: Maybe<Array<SuggestedDeliveryOption>>
}

export type BackwardPage = {
  cursor?: InputMaybe<Scalars['String']['input']>
  last: Scalars['Int']['input']
}

export type BadRequest = Error & {
  __typename: 'BadRequest'
  message: Scalars['String']['output']
}

export type Basket = Node &
  Versioned & {
    __typename: 'Basket'
    addressActionType: AddressActionType
    autoPromos?: Maybe<Array<BasketAutoPromo>>
    basketSummary: Array<BasketSummaryItem>
    /** @deprecated Use addressActionType */
    canHaveMultipleAddresses: Scalars['Boolean']['output']
    credits: CreditsBreakdown
    /** @deprecated Use `credits{used}`. */
    creditsUsed: Money
    customerId?: Maybe<Scalars['String']['output']>
    deliveryOptions?: Maybe<DeliveryOptions>
    id: Scalars['ID']['output']
    /** @deprecated For internal use only */
    isReadyForCheckout: Scalars['Boolean']['output']
    lineItems: Array<LineItem>
    membership: BasketMembership
    /** @deprecated Use membership.selected field on basket */
    membershipLineItem?: Maybe<MembershipLineItem>
    /** @deprecated For internal use only */
    notReadyForCheckoutReason?: Maybe<Scalars['String']['output']>
    paymentProviders: Array<PaymentProvider>
    /** @deprecated Field was extended and has union type, use personalisedPromotion */
    personalisedPromo?: Maybe<BasketPersonalisedPromo>
    personalisedPromotion?: Maybe<BasketPersonalisedPromotion>
    priceSummary: BasketPriceSummary
    recipientOptions?: Maybe<BasketRecipients>
    /** @deprecated Not ready for use yet */
    recipientsDeliveries?: Maybe<BasketRecipientsDeliveries>
    recommendations: Recommendations
    requiredAge?: Maybe<RequiredAge>
    savedCards: SavedCards
    /** @deprecated Use recipientAddress field on lineItem */
    shippingAddress?: Maybe<ShippingAddress>
    /** @deprecated For internal use only */
    state: BasketState
    /** @deprecated for internal use */
    store: Store
    subTotalIncTax: Money
    totalDiscount?: Maybe<Money>
    totalGrossTaxedPrice?: Maybe<Money>
    totalItemPrice: Money
    totalItems: Scalars['Int']['output']
    totalPrice: Money
    totalShippingPrice: Money
    totalTaxExclusive?: Maybe<Money>
    totalToPay: Money
    version: Scalars['Long']['output']
    voucherCode?: Maybe<VoucherCode>
  }

export type BasketpersonalisedPromoArgs = {
  audience?: InputMaybe<Audience>
}

export type BasketpersonalisedPromotionArgs = {
  audience?: InputMaybe<Audience>
}

export type BasketrecommendationsArgs = {
  algorithmId?: InputMaybe<Scalars['String']['input']>
  facets?: InputMaybe<RecommendationFacets>
  isDesignInferenceEnabled?: InputMaybe<Scalars['Boolean']['input']>
  isUserLevelPersonalised?: InputMaybe<Scalars['Boolean']['input']>
}

export type BasketAutoPromo = AutoPromo & {
  __typename: 'BasketAutoPromo'
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  isApplied: Scalars['Boolean']['output']
  name: Scalars['String']['output']
}

export type BasketEmailRecipientDelivery = Node & {
  __typename: 'BasketEmailRecipientDelivery'
  deliveries: Array<Delivery>
  id: Scalars['ID']['output']
  summary: BasketRecipientDeliveriesSummary
}

export type BasketEmptyError = Error & {
  __typename: 'BasketEmptyError'
  message: Scalars['String']['output']
}

export type BasketMembership = {
  __typename: 'BasketMembership'
  recommended?: Maybe<MembershipRecommendation>
  selected?: Maybe<MembershipLineItem>
  totalDiscount?: Maybe<Money>
}

export type BasketNotFoundError = Error & {
  __typename: 'BasketNotFoundError'
  message: Scalars['String']['output']
}

export type BasketOrderedError = Error & {
  __typename: 'BasketOrderedError'
  message: Scalars['String']['output']
}

export type BasketPersonalisedPromo = BasketPersonalisedPromoBase & {
  __typename: 'BasketPersonalisedPromo'
  description: Scalars['String']['output']
  exclusionsMessage?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isApplied: Scalars['Boolean']['output']
  message?: Maybe<Scalars['String']['output']>
  metadata?: Maybe<BasketPersonalisedPromoMetadata>
  name: Scalars['String']['output']
  stateErrorMessage?: Maybe<Scalars['String']['output']>
}

export type BasketPersonalisedPromoBase = {
  description: Scalars['String']['output']
  exclusionsMessage?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isApplied: Scalars['Boolean']['output']
  message?: Maybe<Scalars['String']['output']>
  metadata?: Maybe<BasketPersonalisedPromoMetadata>
  name: Scalars['String']['output']
  stateErrorMessage?: Maybe<Scalars['String']['output']>
}

export type BasketPersonalisedPromoMetadata = {
  __typename: 'BasketPersonalisedPromoMetadata'
  seeding?: Maybe<Scalars['Boolean']['output']>
}

export type BasketPersonalisedPromoNoOffer = {
  __typename: 'BasketPersonalisedPromoNoOffer'
  metadata?: Maybe<BasketPersonalisedPromoMetadata>
  reason?: Maybe<Scalars['String']['output']>
}

export type BasketPersonalisedPromoUpsell = BasketPersonalisedPromoBase & {
  __typename: 'BasketPersonalisedPromoUpsell'
  description: Scalars['String']['output']
  exclusionsMessage?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isApplied: Scalars['Boolean']['output']
  message?: Maybe<Scalars['String']['output']>
  metadata?: Maybe<BasketPersonalisedPromoMetadata>
  name: Scalars['String']['output']
  stateErrorMessage?: Maybe<Scalars['String']['output']>
}

export type BasketPersonalisedPromotion =
  | BasketPersonalisedPromo
  | BasketPersonalisedPromoNoOffer
  | BasketPersonalisedPromoUpsell

export type BasketPhysicalRecipientDelivery = Node & {
  __typename: 'BasketPhysicalRecipientDelivery'
  deliveries: Array<Delivery>
  id: Scalars['ID']['output']
  packagingOptions?: Maybe<BasketRecipientDeliveriesPackagingOptions>
  summary: BasketRecipientDeliveriesSummary
}

export type BasketPriceSummary = {
  __typename: 'BasketPriceSummary'
  all: Array<BasketSummaryPrices>
  membership?: Maybe<Money>
  postage?: Maybe<Money>
  salesTax?: Maybe<Money>
  totalDiscount?: Maybe<Money>
  totalItemsCost?: Maybe<Money>
}

export type BasketRecipient = {
  __typename: 'BasketRecipient'
  isMe?: Maybe<Scalars['Boolean']['output']>
  lineItems: Array<LineItem>
  name?: Maybe<Scalars['String']['output']>
}

export type BasketRecipientDeliveries =
  | BasketEmailRecipientDelivery
  | BasketPhysicalRecipientDelivery

export type BasketRecipientDeliveriesPackagingOptions = {
  __typename: 'BasketRecipientDeliveriesPackagingOptions'
  items: Array<BasketRecipientDeliveryPackagingOption>
  packagingMessage?: Maybe<Scalars['String']['output']>
  selected?: Maybe<BasketRecipientDeliveryPackagingOptionType>
}

export type BasketRecipientDeliveriesSummary = {
  __typename: 'BasketRecipientDeliveriesSummary'
  deliveriesInfo: Array<Scalars['String']['output']>
  formattedAddress: Scalars['String']['output']
  groupTitle: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type BasketRecipientDeliveryPackagingOption = {
  __typename: 'BasketRecipientDeliveryPackagingOption'
  description: Scalars['String']['output']
  title: Scalars['String']['output']
  type: BasketRecipientDeliveryPackagingOptionType
}

export enum BasketRecipientDeliveryPackagingOptionType {
  TO_CUSTOMER = 'TO_CUSTOMER',
  TO_RECIPIENT = 'TO_RECIPIENT',
}

export type BasketRecipients = {
  __typename: 'BasketRecipients'
  recipients: Array<BasketRecipient>
}

export type BasketRecipientsDeliveries = {
  __typename: 'BasketRecipientsDeliveries'
  count: Scalars['Int']['output']
  isComplete: Scalars['Boolean']['output']
  items: Array<BasketRecipientDeliveries>
}

export enum BasketState {
  ACTIVE = 'ACTIVE',
  ORDERED = 'ORDERED',
}

export type BasketSummaryBenefitItem = BasketSummaryPriceItem & {
  __typename: 'BasketSummaryBenefitItem'
  priceDisplay?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type BasketSummaryCostItem = BasketSummaryPriceItem & {
  __typename: 'BasketSummaryCostItem'
  priceDisplay?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type BasketSummaryItem = {
  __typename: 'BasketSummaryItem'
  title: Scalars['String']['output']
  total: Money
}

export type BasketSummaryPriceItem = {
  priceDisplay?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type BasketSummaryPrices =
  | BasketSummaryBenefitItem
  | BasketSummaryCostItem

export type BasketValidatedResult = {
  __typename: 'BasketValidatedResult'
  basket: Basket
  /** @deprecated Will be removed in an upcoming release */
  invalidDeliveryMethod?: Maybe<InvalidDeliveryMethod>
  /** @deprecated Will be removed in an upcoming release */
  invalidVoucherMessage?: Maybe<Scalars['String']['output']>
  validations: Array<BasketValidationResult>
}

export type BasketValidation = {
  isBlocking: Scalars['Boolean']['output']
  message: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type BasketValidationResult =
  | DeliveryValidation
  | PromoValidation
  | StockValidation
  | VoucherValidation

export type BillingAddress = {
  __typename: 'BillingAddress'
  addressFirstLine?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  country: Scalars['String']['output']
  firstName: Scalars['String']['output']
  id: Scalars['String']['output']
  lastName: Scalars['String']['output']
  postalCode?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  /** @deprecated Use addressFirstLine */
  streetName?: Maybe<Scalars['String']['output']>
}

export type BlogPostListItem = {
  __typename: 'BlogPostListItem'
  image: ContentImage
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type BlogPostRelatedArticle = {
  __typename: 'BlogPostRelatedArticle'
  cta: CTA
  image: ContentImage
  title: Scalars['String']['output']
}

export type Breadcrumb = {
  __typename: 'Breadcrumb'
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export enum BrowserPlatform {
  Desktop = 'Desktop',
  Mobile = 'Mobile',
}

export type Business = {
  __typename: 'Business'
  businessProject?: Maybe<BusinessProjectResponse>
  /** @deprecated Experimental feature */
  businessProjectRecipientPreSignedUrl?: Maybe<BusinessProjectRecipientPreSignedUrlResult>
}

export type BusinessAddress = {
  addressFirstLine: Scalars['String']['input']
  city: Scalars['String']['input']
  country: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  postcode: Scalars['String']['input']
}

export type BusinessAvailableSubstitution = {
  __typename: 'BusinessAvailableSubstitution'
  key: BusinessSubstitution
  placeholder: Scalars['String']['output']
}

export type BusinessCardCustomisation = {
  __typename: 'BusinessCardCustomisation'
  to: BusinessCardTo
}

export type BusinessCardCustomisationInput = {
  nameFormat: BusinessNameFormat
}

export type BusinessCardDesign = {
  __typename: 'BusinessCardDesign'
  designId?: Maybe<Scalars['String']['output']>
  productKey: Scalars['String']['output']
  sku: Scalars['String']['output']
}

export type BusinessCardProductAndDesignInput = {
  designId: Scalars['String']['input']
  productKey: Scalars['String']['input']
  sku: Scalars['String']['input']
  source?: InputMaybe<Scalars['String']['input']>
}

export type BusinessCardTo = {
  __typename: 'BusinessCardTo'
  nameFormat: BusinessNameFormat
}

export type BusinessDeliveryOptions = {
  __typename: 'BusinessDeliveryOptions'
  nextAvailableBusinessDate: Scalars['Date']['output']
  unavailableBusinessDates: Array<Scalars['Date']['output']>
}

export type BusinessDetails = {
  __typename: 'BusinessDetails'
  billingAddress?: Maybe<BillingAddress>
  companyName?: Maybe<Scalars['String']['output']>
}

export type BusinessGiftInput = {
  productKey: Scalars['String']['input']
  sku: Scalars['String']['input']
}

export enum BusinessNameFormat {
  FIRST = 'FIRST',
  FULL = 'FULL',
  NONE = 'NONE',
}

export type BusinessOrder = {
  __typename: 'BusinessOrder'
  card: BusinessOrderCard
  createdOn: Scalars['Date']['output']
  earliestDeliveryDate?: Maybe<Scalars['Date']['output']>
  gift?: Maybe<Product>
  hasReceipt: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  price: BusinessOrderPrice
  recipientCount: Scalars['Long']['output']
  recipients: Array<BusinessOrderRecipient>
  status: BusinessOrderStatus
  substitutions: BusinessSubstitutions
}

export type BusinessOrderAddress = {
  __typename: 'BusinessOrderAddress'
  addressLine1: Scalars['String']['output']
  city: Scalars['String']['output']
  country: Scalars['String']['output']
  postcode: Scalars['String']['output']
}

export type BusinessOrderCard = {
  __typename: 'BusinessOrderCard'
  designId: Scalars['String']['output']
  productKey: Scalars['String']['output']
  sku: Scalars['String']['output']
}

export type BusinessOrderDelivery = {
  __typename: 'BusinessOrderDelivery'
  deliveryMethod: BusinessOrderDeliveryMethod
  deliveryOption: BusinessOrderDeliveryOption
  id: Scalars['String']['output']
  tracking?: Maybe<BusinessOrderDeliveryTracking>
}

export type BusinessOrderDeliveryMethod = {
  __typename: 'BusinessOrderDeliveryMethod'
  id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type BusinessOrderDeliveryOption = {
  __typename: 'BusinessOrderDeliveryOption'
  deliveryDate: Scalars['Date']['output']
  despatchDate: Scalars['Date']['output']
}

export type BusinessOrderDeliveryTracking = {
  __typename: 'BusinessOrderDeliveryTracking'
  reference: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type BusinessOrderInput = {
  id: Scalars['ID']['input']
}

export type BusinessOrderNotFoundError = Error & {
  __typename: 'BusinessOrderNotFoundError'
  message: Scalars['String']['output']
}

export type BusinessOrderPrice = {
  __typename: 'BusinessOrderPrice'
  itemisation: BusinessOrderPriceItemisation
  total: BusinessOrderPriceTotal
}

export type BusinessOrderPriceItemisation = {
  __typename: 'BusinessOrderPriceItemisation'
  card: Money
  gift?: Maybe<Money>
  shipping: Money
}

export type BusinessOrderPriceTotal = {
  __typename: 'BusinessOrderPriceTotal'
  amount: Money
  items: Scalars['Long']['output']
  shipping: Money
}

export type BusinessOrderRecipient = {
  __typename: 'BusinessOrderRecipient'
  address: BusinessOrderAddress
  delivery?: Maybe<BusinessOrderDelivery>
  firstName: Scalars['String']['output']
  id: Scalars['String']['output']
  lastName: Scalars['String']['output']
  status: BusinessOrderRecipientStatus
}

export enum BusinessOrderRecipientStatus {
  DELIVERED = 'DELIVERED',
  DESPATCHED = 'DESPATCHED',
  FAILED = 'FAILED',
  PACKED = 'PACKED',
  PROCESSING = 'PROCESSING',
  UNKNOWN = 'UNKNOWN',
}

export type BusinessOrderResponse = BusinessOrder | BusinessOrderNotFoundError

export enum BusinessOrderStatus {
  COMPLETED = 'COMPLETED',
  PROCESSING = 'PROCESSING',
  UNKNOWN = 'UNKNOWN',
}

export type BusinessOrdersConnection = {
  __typename: 'BusinessOrdersConnection'
  edges: Array<BusinessOrdersEdge>
  pageInfo: PageInfo
}

export type BusinessOrdersConnectionInput = {
  backwardPage?: InputMaybe<BackwardPage>
  canReorder?: InputMaybe<Scalars['Boolean']['input']>
  forwardPage?: InputMaybe<ForwardPage>
}

export type BusinessOrdersEdge = {
  __typename: 'BusinessOrdersEdge'
  cursor: Scalars['String']['output']
  node: BusinessOrder
}

export type BusinessPreviewSubstitution = {
  __typename: 'BusinessPreviewSubstitution'
  placeholder: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type BusinessPrice = {
  __typename: 'BusinessPrice'
  card?: Maybe<Money>
  delivery?: Maybe<Money>
  gift?: Maybe<Money>
}

export type BusinessPriceDetail = {
  __typename: 'BusinessPriceDetail'
  fullPrice: Money
  price: Money
  promotionalMessage?: Maybe<Scalars['String']['output']>
}

export type BusinessPricing = {
  __typename: 'BusinessPricing'
  card?: Maybe<BusinessPriceDetail>
  delivery?: Maybe<BusinessPriceDetail>
  gift?: Maybe<BusinessPriceDetail>
  total: Money
}

export type BusinessProductImage = {
  __typename: 'BusinessProductImage'
  dimensions: BusinessProductImageDimensions
  url: Scalars['String']['output']
}

export type BusinessProductImageDimensions = {
  __typename: 'BusinessProductImageDimensions'
  h: Scalars['Long']['output']
  w: Scalars['Long']['output']
}

export type BusinessProductVariant = {
  __typename: 'BusinessProductVariant'
  images: Array<BusinessProductImage>
  price: Money
  productKey: Scalars['String']['output']
  sku: Scalars['String']['output']
}

export type BusinessProductVariantInput = {
  productKey: Scalars['String']['input']
  sku: Scalars['String']['input']
}

export type BusinessProductVariantNotFoundError = Error & {
  __typename: 'BusinessProductVariantNotFoundError'
  message: Scalars['String']['output']
}

export type BusinessProductVariantResponse =
  | BusinessProductVariant
  | BusinessProductVariantNotFoundError

export type BusinessProject = {
  __typename: 'BusinessProject'
  cardCustomisation?: Maybe<BusinessCardCustomisation>
  cardDesign?: Maybe<BusinessCardDesign>
  gift?: Maybe<BusinessProjectGift>
  id: Scalars['ID']['output']
  keywords?: Maybe<Array<Scalars['String']['output']>>
  price?: Maybe<BusinessPrice>
  pricing?: Maybe<BusinessPricing>
  recipients: Array<BusinessRecipient>
  substitutions?: Maybe<BusinessSubstitutions>
}

export type BusinessProjectGift = {
  __typename: 'BusinessProjectGift'
  product: Product
  sku: Scalars['String']['output']
}

export type BusinessProjectKeywordInput = {
  keyword: Scalars['String']['input']
}

export type BusinessProjectRecipientPreSignedUrlResult = {
  __typename: 'BusinessProjectRecipientPreSignedUrlResult'
  url: Scalars['String']['output']
}

export type BusinessProjectResponse = BusinessProject | InputValidationError

export type BusinessRecipient = {
  __typename: 'BusinessRecipient'
  address: BusinessRecipientAddress
  anniversaryYear?: Maybe<Scalars['Long']['output']>
  deliveryDate?: Maybe<Scalars['Date']['output']>
  firstName: Scalars['String']['output']
  id: Scalars['String']['output']
  lastName: Scalars['String']['output']
}

export type BusinessRecipientAddress = {
  __typename: 'BusinessRecipientAddress'
  addressLine1: Scalars['String']['output']
  city: Scalars['String']['output']
  country: Scalars['String']['output']
  postcode: Scalars['String']['output']
}

export type BusinessRecipientInput = {
  addressLine1: Scalars['String']['input']
  anniversaryYear?: InputMaybe<Scalars['Long']['input']>
  city: Scalars['String']['input']
  country: Scalars['String']['input']
  deliveryDate?: InputMaybe<Scalars['Date']['input']>
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  postcode: Scalars['String']['input']
}

export enum BusinessSubstitution {
  FIRST_NAME = 'FIRST_NAME',
  NAME = 'NAME',
  YEAR = 'YEAR',
}

export type BusinessSubstitutions = {
  __typename: 'BusinessSubstitutions'
  available: Array<BusinessAvailableSubstitution>
  preview: Array<BusinessPreviewSubstitution>
  previews: Array<Array<BusinessPreviewSubstitution>>
}

export type CTA = {
  __typename: 'CTA'
  action: CTAAction
  /** @deprecated Use action */
  shouldFormat?: Maybe<Scalars['Boolean']['output']>
  title: Scalars['String']['output']
  /** @deprecated Use action */
  url: Scalars['String']['output']
}

export type CTAAction = AddMembershipToBasketAction | LinkAction

export enum CacheControlScope {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
}

export type Capabilities = {
  __typename: 'Capabilities'
  /** @deprecated Use DesignScene.availableCustomisations instead */
  video: Scalars['Boolean']['output']
}

export type CategoryListEdge = {
  __typename: 'CategoryListEdge'
  cursor: Scalars['String']['output']
  node: CategoryListRecommendation
}

export type CategoryListEdges = {
  __typename: 'CategoryListEdges'
  edges: Array<CategoryListEdge>
  pageInfo: CategoryListPageInfo
  totalCount: Scalars['Int']['output']
}

export type CategoryListInvalidCursorError = Error & {
  __typename: 'CategoryListInvalidCursorError'
  message: Scalars['String']['output']
}

export type CategoryListPageInfo = {
  __typename: 'CategoryListPageInfo'
  endCursor?: Maybe<Scalars['String']['output']>
  hasNextPage: Scalars['Boolean']['output']
  hasPreviousPage: Scalars['Boolean']['output']
  startCursor?: Maybe<Scalars['String']['output']>
}

export type CategoryListRecommendation = {
  description?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
}

export type CategoryListResult =
  | CategoryListEdges
  | CategoryListInvalidCursorError

export type CheckoutBusinessProjectResponse =
  | CheckoutBusinessProjectResult
  | InputValidationError

export type CheckoutBusinessProjectResult = {
  __typename: 'CheckoutBusinessProjectResult'
  isFreeOrderEligible?: Maybe<Scalars['Boolean']['output']>
  paymentSessionId: Scalars['String']['output']
}

export type CloneSharedReminderResult =
  | BadRequest
  | CreatedReminder
  | ReminderNotFound

export type Color = {
  __typename: 'Color'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type ColorEdge = {
  __typename: 'ColorEdge'
  cursor: Scalars['ID']['output']
  node: Color
}

export type ColorEdges = {
  __typename: 'ColorEdges'
  edges: Array<ColorEdge>
  pageInfo: DesignCustomisationPageInfo
  totalCount: Scalars['Int']['output']
}

export type ColorsFilterInput = {
  colorSetIds: Array<Scalars['ID']['input']>
}

export type ColorsResult =
  | ColorEdges
  | DesignInvalidCursorError
  | DesignServiceError

export enum ColumnWidthVariant {
  EqualWidth = 'EqualWidth',
  LeftWider = 'LeftWider',
  RightWider = 'RightWider',
}

export type ConcurrentModificationError = Error & {
  __typename: 'ConcurrentModificationError'
  message: Scalars['String']['output']
}

export enum ConsentPosition {
  OPTED_IN = 'OPTED_IN',
  OPTED_OUT = 'OPTED_OUT',
}

export type ContactPreference = {
  __typename: 'ContactPreference'
  status: ContactStatus
  type: ContactPreferenceType
}

export type ContactPreferenceInput = {
  status: ContactStatus
  type: ContactPreferenceType
}

export enum ContactPreferenceType {
  DELIVERY_UPDATES_SMS = 'DELIVERY_UPDATES_SMS',
  DELIVERY_UPDATES_WHATSAPP = 'DELIVERY_UPDATES_WHATSAPP',
  FATHERS_DAY = 'FATHERS_DAY',
  FATHERS_DAY_SMS = 'FATHERS_DAY_SMS',
  FATHERS_DAY_WHATSAPP = 'FATHERS_DAY_WHATSAPP',
  GENERAL_MARKETING = 'GENERAL_MARKETING',
  GENERAL_MARKETING_SMS = 'GENERAL_MARKETING_SMS',
  GENERAL_MARKETING_WHATSAPP = 'GENERAL_MARKETING_WHATSAPP',
  GROUP_CARDS = 'GROUP_CARDS',
  MEMBERSHIPS = 'MEMBERSHIPS',
  MEMBERSHIPS_SMS = 'MEMBERSHIPS_SMS',
  MEMBERSHIPS_WHATSAPP = 'MEMBERSHIPS_WHATSAPP',
  /** @deprecated Use MEMBERSHIPS */
  MOONPIG_PLUS = 'MOONPIG_PLUS',
  MOTHERS_DAY = 'MOTHERS_DAY',
  MOTHERS_DAY_SMS = 'MOTHERS_DAY_SMS',
  MOTHERS_DAY_WHATSAPP = 'MOTHERS_DAY_WHATSAPP',
  REMINDERS_SMS = 'REMINDERS_SMS',
  REMINDERS_WHATSAPP = 'REMINDERS_WHATSAPP',
  SERVICE_UPDATES_SMS = 'SERVICE_UPDATES_SMS',
  SERVICE_UPDATES_WHATSAPP = 'SERVICE_UPDATES_WHATSAPP',
}

export type ContactPreferences = Node & {
  __typename: 'ContactPreferences'
  id: Scalars['ID']['output']
  marketingReviewEligible: Scalars['Boolean']['output']
  preferences: Array<ContactPreference>
  source?: Maybe<ContactSource>
}

export enum ContactSource {
  App = 'App',
  AppCheckout = 'AppCheckout',
  CustomerServices = 'CustomerServices',
  EmailUnsubscribe = 'EmailUnsubscribe',
  GroupCardsSignUp = 'GroupCardsSignUp',
  LandingPage = 'LandingPage',
  MembershipStarted = 'MembershipStarted',
  Migration = 'Migration',
  MyAccountPage = 'MyAccountPage',
  ProspectEmailRegister = 'ProspectEmailRegister',
  RemindersInflowPage = 'RemindersInflowPage',
  WebCheckout = 'WebCheckout',
  WebRegister = 'WebRegister',
}

export enum ContactStatus {
  NOT_ASKED = 'NOT_ASKED',
  OPTED_IN = 'OPTED_IN',
  OPTED_OUT = 'OPTED_OUT',
}

export type Content = {
  __typename: 'Content'
  headerLogo?: Maybe<HeaderLogo>
}

export type ContentDepartment = {
  __typename: 'ContentDepartment'
  dispatchCutOff: ContentDepartmentDispatchCutOff
  id: Scalars['ID']['output']
  longDeliveryInfo: Scalars['String']['output']
  promotionBanner?: Maybe<Scalars['String']['output']>
  shortDeliveryInfo: Scalars['String']['output']
  subdepartments: Array<ContentDepartment>
}

export type ContentDepartmentDispatchCutOff = {
  __typename: 'ContentDepartmentDispatchCutOff'
  weekdays: CutOff
  weekendsAndBankHolidays: CutOff
}

export type ContentDimensions = {
  __typename: 'ContentDimensions'
  height: Scalars['Int']['output']
  width: Scalars['Int']['output']
}

export type ContentImage = {
  __typename: 'ContentImage'
  description: Scalars['String']['output']
  dimensions: ContentDimensions
  url: Scalars['String']['output']
}

export type ContentImageurlArgs = {
  background?: InputMaybe<Scalars['String']['input']>
  fit?: InputMaybe<ContentImageFit>
  focus?: InputMaybe<ContentImageFocus>
  format?: InputMaybe<ContentImageFormat>
  height?: InputMaybe<Scalars['Int']['input']>
  quality?: InputMaybe<Scalars['Int']['input']>
  width?: InputMaybe<Scalars['Int']['input']>
}

export enum ContentImageFit {
  crop = 'crop',
  fill = 'fill',
  thumb = 'thumb',
}

export enum ContentImageFocus {
  bottom = 'bottom',
  left = 'left',
  right = 'right',
  top = 'top',
}

export enum ContentImageFormat {
  jpg = 'jpg',
  png = 'png',
  webp = 'webp',
}

export type ContentItem = {
  __typename: 'ContentItem'
  id: Scalars['String']['output']
}

export type ContentMetadata = {
  __typename: 'ContentMetadata'
  experiment?: Maybe<ContentMetadataExperiment>
  variation?: Maybe<ContentMetadataVariation>
}

export type ContentMetadataExperiment = {
  __typename: 'ContentMetadataExperiment'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type ContentMetadataVariation = {
  __typename: 'ContentMetadataVariation'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type ContentModule = {
  meta: ContentMetadata
}

export enum ContentPlatform {
  android = 'android',
  ios = 'ios',
  web = 'web',
}

export type ContentReminderOccasion = {
  __typename: 'ContentReminderOccasion'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type ContentReminderRelation = {
  __typename: 'ContentReminderRelation'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type ContentSearchFacet = {
  __typename: 'ContentSearchFacet'
  name: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type ContentSearchFacetDetails = {
  __typename: 'ContentSearchFacetDetails'
  group?: Maybe<Scalars['String']['output']>
  key?: Maybe<Scalars['String']['output']>
  /** @deprecated use key instead */
  name: Scalars['String']['output']
  /** @deprecated use key instead */
  path: Scalars['String']['output']
  /** @deprecated use key instead */
  value: Scalars['String']['output']
}

export type ContentVariationInput = {
  name: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type ContentVideo = {
  __typename: 'ContentVideo'
  contentType: Scalars['String']['output']
  description: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type Country = {
  __typename: 'Country'
  code: Scalars['String']['output']
  label: Scalars['String']['output']
}

export enum Courier {
  AN_POST = 'AN_POST',
  AUS_POST = 'AUS_POST',
  DPD = 'DPD',
  PACKS = 'PACKS',
  POST_NL = 'POST_NL',
  ROYAL_MAIL = 'ROYAL_MAIL',
  UNKNOWN = 'UNKNOWN',
  USPS = 'USPS',
}

export type CourierDetails = {
  __typename: 'CourierDetails'
  courier: Courier
  displayName: Scalars['String']['output']
  shortCode?: Maybe<Scalars['String']['output']>
}

export type CreateAddressRequestInput = {
  recipientFirstName: Scalars['String']['input']
  recipientLastName: Scalars['String']['input']
}

export type CreateAddressRequestResult =
  | AddressRequestInputError
  | CreateAddressRequestSuccess

export type CreateAddressRequestSuccess = {
  __typename: 'CreateAddressRequestSuccess'
  addressRequest: AddressRequest
  addressRequests?: Maybe<AddressRequests>
}

export type CreateAudioMediaInput = {
  designToken: Scalars['String']['input']
}

export type CreateAudioMediaResult =
  | MediaInvalidTokenError
  | MediaServiceError
  | MediaUpload

export type CreateCustomerCreationsCustomFontResponse =
  | CustomerCreationsCustomFont
  | CustomerCreationsServiceError

export type CreateCustomerCreationsCustomFontSubmissionResponse =
  | CustomerCreationsCustomFontSubmissionCreateError
  | CustomerCreationsCustomFontSubmissionPending
  | CustomerCreationsServiceError

export type CreateDemoMediaInput = {
  designToken: Scalars['String']['input']
}

export type CreateDemoMediaResult =
  | Media
  | MediaInvalidTokenError
  | MediaServiceError

export type CreateDesignImageUploadInput = {
  designId: Scalars['ID']['input']
}

export type CreateDesignImageUploadResult =
  | DesignAuthorizationError
  | DesignImageUpload
  | DesignImageUploadLimitReachedError
  | DesignNotFoundError
  | DesignServiceError

export type CreateDesignInput = {
  /** @deprecated No longer used */
  allowAllCharacters?: InputMaybe<Scalars['Boolean']['input']>
  /**
   * A set of flags to determine what the client can support.
   * Should be used in conjunction with feature flags on each client.
   */
  capabilities?: InputMaybe<Array<DesignCapability>>
  preferFlexibleLayout?: InputMaybe<Scalars['Boolean']['input']>
  /** Should use overlay text on this design. By using overlay text, templated text elements on the inside scenes of a card will be removed. */
  preferOverlayText?: InputMaybe<Scalars['Boolean']['input']>
  /**
   * Similar to `preferOverlayText` but enables overlay elements on the front of the card, removing any existing text elements.
   * There are only a select number of cards which support this. Enabling this for cards which do not support flexible content on the front will have no effect.
   */
  preferOverlayTextFront?: InputMaybe<Scalars['Boolean']['input']>
  productKey: Scalars['String']['input']
  scenes?: InputMaybe<Array<DesignCustomisationsSceneByIndexInput>>
  sku?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<DesignState>
  /** @deprecated No longer used */
  variantKey?: InputMaybe<Scalars['String']['input']>
  /** @deprecated No longer used */
  videoCardId?: InputMaybe<Scalars['String']['input']>
}

export type CreateDesignResult =
  | Design
  | DesignCustomisationsInputError
  | DesignInvalidTokenError
  | DesignServiceError
  | DesignTemplatesServiceError
  | ProductNotPersonalisableError

export type CreateDesignStickerAI = {
  __typename: 'CreateDesignStickerAI'
  taskId: Scalars['String']['output']
}

export type CreateDesignStickerAIInput = {
  designId: Scalars['ID']['input']
  prompt: Scalars['String']['input']
}

export type CreateDesignStickerAIResult =
  | CreateDesignStickerAI
  | DesignServiceError
  | DesignStickerAIInputError
  | DesignStickerAILimitReachedError
  | DesignStickerAIModerationError
  | DesignStickerAIUnavailableError
  | DesignStickerCopyrightError

export type CreateDraftFromDesignInput = {
  sourceId: Scalars['String']['input']
}

export type CreateDraftFromDesignResult =
  | Design
  | DesignAuthorizationError
  | DesignNotFoundError
  | DesignServiceError
  | DesignTemplatesServiceError

export type CreateInProjectFromDesignInput = {
  capabilities?: InputMaybe<Array<DesignCapability>>
  sourceId: Scalars['String']['input']
}

export type CreateInProjectFromDesignResult =
  | Design
  | DesignAuthorizationError
  | DesignNotFoundError
  | DesignServiceError
  | DesignTemplatesServiceError

export type CreateIncentivisedRemindersResult =
  | BadRequest
  | CreatedIncentivisedReminders

export type CreateReminderFromDraftInput = {
  orderId: Scalars['ID']['input']
}

export type CreateReminderFromDraftResult = CreateReminderFromDraftSuccess

export type CreateReminderFromDraftSuccess = {
  __typename: 'CreateReminderFromDraftSuccess'
  reminder?: Maybe<Reminder>
}

export type CreateReminderResult =
  | BadRequest
  | CreatedReminder
  | ReminderAlreadyExists

export type CreateRemindersAsyncResult = {
  __typename: 'CreateRemindersAsyncResult'
  message: Scalars['String']['output']
}

export type CreateRemindersFromProductsResult =
  | BadRequest
  | CreatedRemindersFromProducts

export type CreateVideoMediaInput = {
  designToken: Scalars['String']['input']
  termsAndConditionsAccepted: Scalars['Boolean']['input']
}

export type CreateVideoMediaResult =
  | MediaInvalidTokenError
  | MediaServiceError
  | MediaTermsAndConditionsNotAcceptedError
  | MediaUpload

export type CreatedIncentivisedReminders = {
  __typename: 'CreatedIncentivisedReminders'
  reminders: Array<Reminder>
}

export type CreatedReminder = Node & {
  __typename: 'CreatedReminder'
  id: Scalars['ID']['output']
}

export type CreatedReminderFromProduct = Node & {
  __typename: 'CreatedReminderFromProduct'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  occasion: Occasion
  occasionDate: OccasionDate
  relationship?: Maybe<Relationship>
}

export type CreatedRemindersFromProducts = {
  __typename: 'CreatedRemindersFromProducts'
  reminders: Array<CreatedReminderFromProduct>
}

export type CreditAccount = {
  __typename: 'CreditAccount'
  id: Scalars['ID']['output']
  records?: Maybe<Array<CreditRecord>>
  remainingBalance?: Maybe<Money>
  store: Scalars['String']['output']
}

export type CreditActivity = {
  __typename: 'CreditActivity'
  amount: Money
  authorizer?: Maybe<Scalars['String']['output']>
  creditId: Scalars['String']['output']
  date?: Maybe<Scalars['String']['output']>
  newBalance: Money
  orderId?: Maybe<Scalars['String']['output']>
  reason?: Maybe<Scalars['String']['output']>
  store?: Maybe<Scalars['String']['output']>
  type: Scalars['String']['output']
}

export type CreditRecord = {
  __typename: 'CreditRecord'
  authCode?: Maybe<Scalars['String']['output']>
  createdDate?: Maybe<Scalars['String']['output']>
  expiredBy?: Maybe<Scalars['String']['output']>
  expiryDate?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  initialBalance: Money
  isExpired?: Maybe<Scalars['Boolean']['output']>
  reason?: Maybe<Scalars['String']['output']>
  remainingBalance: Money
}

export type CreditsBreakdown = {
  __typename: 'CreditsBreakdown'
  available: Money
  remaining: Money
  used: Money
}

export type CriteriaInput = {
  excludeDirectSmile?: InputMaybe<Scalars['Boolean']['input']>
  excludeRude?: InputMaybe<Scalars['Boolean']['input']>
  facets?: InputMaybe<Array<FacetInput>>
  groupedFacets?: InputMaybe<Array<GroupedFacetInput>>
  hasAugmentedReality?: InputMaybe<Scalars['Boolean']['input']>
  hasCollageMaker?: InputMaybe<Scalars['Boolean']['input']>
  occasion?: InputMaybe<Scalars['String']['input']>
  onlyPPCResults?: InputMaybe<Scalars['Boolean']['input']>
  promotionId?: InputMaybe<Scalars['String']['input']>
  recipient?: InputMaybe<Scalars['String']['input']>
  variants?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type CrmDeleteReminderResult = BadRequest | DeletedRemindersSuccess

export type CrmDeleteRemindersInput = {
  encryptedPayload: Scalars['String']['input']
}

export type CrmDetails = {
  __typename: 'CrmDetails'
  cookie?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
}

export type CustomAction = {
  __typename: 'CustomAction'
  configJson: Scalars['String']['output']
  title?: Maybe<Scalars['String']['output']>
  type: Scalars['String']['output']
}

export type Customer = Versioned & {
  __typename: 'Customer'
  businessDetails?: Maybe<BusinessDetails>
  businessOrder?: Maybe<BusinessOrderResponse>
  businessOrdersConnection: BusinessOrdersConnection
  contactPreferences: ContactPreferences
  credits?: Maybe<CustomerCredits>
  /** Customer crmDetails. Returns SailThru Id for Moonpig & Canopy Deploy Id for Greetz. Cookie information is just for Sailthru. */
  crmDetails?: Maybe<CrmDetails>
  email: Scalars['String']['output']
  favourites: Favourites
  firstName: Scalars['String']['output']
  fullPhoneNumber?: Maybe<Scalars['String']['output']>
  groupCardProject: GroupCardProjectResult
  groupCardProjectV2: GroupCardProjectResultV2
  groupCardProjects: GroupCardProjectsResult
  groupCardProjectsV2: GroupCardProjectsResultV2
  hasBusinessOrders: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  identityDetails?: Maybe<IdentityDetails>
  intercom?: Maybe<IntercomData>
  lastName: Scalars['String']['output']
  /** @deprecated Exists only for migration from commerce-api. Use contactPreferences property instead */
  marketingConsentPosition: MarketingConsentPosition
  membership?: Maybe<Membership>
  myAddresses: Array<ShippingAddress>
  order?: Maybe<Order>
  orders?: Maybe<Orders>
  otherAddresses: Array<ShippingAddress>
  recommendations: CustomerRecommendationsResponse
  savedCards?: Maybe<Array<SavedCard>>
  title?: Maybe<Scalars['String']['output']>
  version: Scalars['Long']['output']
}

export type CustomerbusinessOrderArgs = {
  input: BusinessOrderInput
}

export type CustomerbusinessOrdersConnectionArgs = {
  input: BusinessOrdersConnectionInput
}

export type CustomergroupCardProjectArgs = {
  projectId: Scalars['ID']['input']
}

export type CustomergroupCardProjectV2Args = {
  projectId: Scalars['ID']['input']
}

export type CustomerorderArgs = {
  id: Scalars['ID']['input']
}

export type CustomerordersArgs = {
  limit?: InputMaybe<Scalars['Long']['input']>
  offset?: InputMaybe<Scalars['Long']['input']>
}

export type CustomerrecommendationsArgs = {
  request: CustomerRecommendationsRequest
}

export type CustomersavedCardsArgs = {
  store?: InputMaybe<Store>
}

export type CustomerAddressInput = {
  addressFirstLine: Scalars['String']['input']
  city?: InputMaybe<Scalars['String']['input']>
  country: Scalars['String']['input']
  extraAddressLine?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  houseNumber?: InputMaybe<Scalars['String']['input']>
  houseNumberExtension?: InputMaybe<Scalars['String']['input']>
  isMyAddress: Scalars['Boolean']['input']
  lastName: Scalars['String']['input']
  postcode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  /** @deprecated No longer in use */
  title?: InputMaybe<Scalars['String']['input']>
  version: Scalars['Long']['input']
}

export type CustomerAddressInvalidCountry = Error & {
  __typename: 'CustomerAddressInvalidCountry'
  message: Scalars['String']['output']
}

export type CustomerAddressInvalidError = Error & {
  __typename: 'CustomerAddressInvalidError'
  message: Scalars['String']['output']
}

export type CustomerAddressesInput = {
  addresses: Array<CustomerMultiAddressInput>
  version: Scalars['Long']['input']
}

export type CustomerCreationsCustomFont = {
  __typename: 'CustomerCreationsCustomFont'
  createdAt: Scalars['String']['output']
  fontFace?: Maybe<CustomerCreationsCustomFontFace>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  points?: Maybe<CustomerCreationsCustomFontPoints>
  status: CustomerCreationsCustomFontStatus
  updatedAt: Scalars['String']['output']
  upload?: Maybe<CustomerCreationsCustomFontUpload>
}

export type CustomerCreationsCustomFontDeleteComplete = {
  __typename: 'CustomerCreationsCustomFontDeleteComplete'
  id: Scalars['ID']['output']
}

export type CustomerCreationsCustomFontDeleteResponse =
  | CustomerCreationsCustomFontDeleteComplete
  | CustomerCreationsServiceError

export type CustomerCreationsCustomFontEdge = {
  __typename: 'CustomerCreationsCustomFontEdge'
  cursor: Scalars['ID']['output']
  node: CustomerCreationsCustomFont
}

export type CustomerCreationsCustomFontError = Error & {
  __typename: 'CustomerCreationsCustomFontError'
  message: Scalars['String']['output']
}

export type CustomerCreationsCustomFontFace = {
  __typename: 'CustomerCreationsCustomFontFace'
  customFontId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  metrics?: Maybe<CustomerCreationsCustomFontFaceMetrics>
  name: Scalars['String']['output']
  urls: CustomerCreationsCustomFontFaceUrls
}

export type CustomerCreationsCustomFontFaceMetrics = {
  __typename: 'CustomerCreationsCustomFontFaceMetrics'
  head: CustomerCreationsCustomFontFaceMetricsHead
  hhea: CustomerCreationsCustomFontFaceMetricsHhea
  os2: CustomerCreationsCustomFontFaceMetricsOs2
}

export type CustomerCreationsCustomFontFaceMetricsHead = {
  __typename: 'CustomerCreationsCustomFontFaceMetricsHead'
  unitsPerEm: Scalars['Float']['output']
  yMax: Scalars['Float']['output']
  yMin: Scalars['Float']['output']
}

export type CustomerCreationsCustomFontFaceMetricsHhea = {
  __typename: 'CustomerCreationsCustomFontFaceMetricsHhea'
  ascender: Scalars['Float']['output']
  descender: Scalars['Float']['output']
  lineGap: Scalars['Float']['output']
}

export type CustomerCreationsCustomFontFaceMetricsOs2 = {
  __typename: 'CustomerCreationsCustomFontFaceMetricsOs2'
  fsSelection: Scalars['Float']['output']
  fsType: Scalars['Float']['output']
  sCapHeight: Scalars['Float']['output']
  sTypoAscender: Scalars['Float']['output']
  sTypoDescender: Scalars['Float']['output']
  sTypoLineGap: Scalars['Float']['output']
  sxHeight: Scalars['Float']['output']
  usWinAscent: Scalars['Float']['output']
  usWinDescent: Scalars['Float']['output']
}

export type CustomerCreationsCustomFontFaceUrls = {
  __typename: 'CustomerCreationsCustomFontFaceUrls'
  ttf: Scalars['String']['output']
  woff: Scalars['String']['output']
  woff2: Scalars['String']['output']
}

export type CustomerCreationsCustomFontPoints = {
  __typename: 'CustomerCreationsCustomFontPoints'
  url: Scalars['String']['output']
}

export type CustomerCreationsCustomFontResponse =
  | CustomerCreationsCustomFontError
  | CustomerCreationsCustomFontsList

export enum CustomerCreationsCustomFontStatus {
  COMPLETE = 'COMPLETE',
  DELETED = 'DELETED',
  ERROR = 'ERROR',
  PROCESSING = 'PROCESSING',
  UPLOADING = 'UPLOADING',
}

export type CustomerCreationsCustomFontSubmission = {
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  updatedAt: Scalars['String']['output']
}

export type CustomerCreationsCustomFontSubmissionComplete =
  CustomerCreationsCustomFontSubmission & {
    __typename: 'CustomerCreationsCustomFontSubmissionComplete'
    createdAt: Scalars['String']['output']
    font: CustomerCreationsCustomFont
    id: Scalars['ID']['output']
    updatedAt: Scalars['String']['output']
  }

export type CustomerCreationsCustomFontSubmissionCreateError = Error & {
  __typename: 'CustomerCreationsCustomFontSubmissionCreateError'
  message: Scalars['String']['output']
}

export type CustomerCreationsCustomFontSubmissionError =
  CustomerCreationsCustomFontSubmission &
    Error & {
      __typename: 'CustomerCreationsCustomFontSubmissionError'
      createdAt: Scalars['String']['output']
      id: Scalars['ID']['output']
      message: Scalars['String']['output']
      updatedAt: Scalars['String']['output']
    }

export type CustomerCreationsCustomFontSubmissionNotFoundError = Error & {
  __typename: 'CustomerCreationsCustomFontSubmissionNotFoundError'
  message: Scalars['String']['output']
}

export type CustomerCreationsCustomFontSubmissionPending =
  CustomerCreationsCustomFontSubmission & {
    __typename: 'CustomerCreationsCustomFontSubmissionPending'
    createdAt: Scalars['String']['output']
    id: Scalars['ID']['output']
    maxRetryCount: Scalars['Int']['output']
    pollingIntervalMs: Scalars['Int']['output']
    updatedAt: Scalars['String']['output']
    upload: CustomerCreationsCustomFontSubmissionUpload
  }

export type CustomerCreationsCustomFontSubmissionProcessing =
  CustomerCreationsCustomFontSubmission & {
    __typename: 'CustomerCreationsCustomFontSubmissionProcessing'
    createdAt: Scalars['String']['output']
    id: Scalars['ID']['output']
    maxRetryCount: Scalars['Int']['output']
    pollingIntervalMs: Scalars['Int']['output']
    updatedAt: Scalars['String']['output']
  }

export type CustomerCreationsCustomFontSubmissionResponse =
  | CustomerCreationsCustomFontSubmissionComplete
  | CustomerCreationsCustomFontSubmissionError
  | CustomerCreationsCustomFontSubmissionNotFoundError
  | CustomerCreationsCustomFontSubmissionPending
  | CustomerCreationsCustomFontSubmissionProcessing
  | CustomerCreationsServiceError

export type CustomerCreationsCustomFontSubmissionUpload = {
  __typename: 'CustomerCreationsCustomFontSubmissionUpload'
  fields: Array<CustomerCreationsCustomFontSubmissionUploadField>
  url: Scalars['String']['output']
}

export type CustomerCreationsCustomFontSubmissionUploadField = {
  __typename: 'CustomerCreationsCustomFontSubmissionUploadField'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type CustomerCreationsCustomFontUpload = {
  __typename: 'CustomerCreationsCustomFontUpload'
  fields: Array<CustomerCreationsCustomFontUploadField>
  uploadUrl: Scalars['String']['output']
}

export type CustomerCreationsCustomFontUploadField = {
  __typename: 'CustomerCreationsCustomFontUploadField'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type CustomerCreationsCustomFontsList = {
  __typename: 'CustomerCreationsCustomFontsList'
  edges: Array<CustomerCreationsCustomFontEdge>
  pageInfo: CustomerCreationsCustomFontsPageInfo
  totalCount: Scalars['Int']['output']
}

export type CustomerCreationsCustomFontsPageInfo = {
  __typename: 'CustomerCreationsCustomFontsPageInfo'
  endCursor?: Maybe<Scalars['ID']['output']>
  hasNextPage: Scalars['Boolean']['output']
}

export type CustomerCreationsServiceError = Error & {
  __typename: 'CustomerCreationsServiceError'
  message: Scalars['String']['output']
}

export type CustomerCredits = {
  __typename: 'CustomerCredits'
  accounts?: Maybe<Array<CreditAccount>>
  activity?: Maybe<Array<CreditActivity>>
  availableBalance?: Maybe<Money>
  id: Scalars['ID']['output']
}

export type CustomerDeleteAddressInput = {
  addressId: Scalars['String']['input']
  version: Scalars['Long']['input']
}

export type CustomerFeedbackError = {
  __typename: 'CustomerFeedbackError'
  message: Scalars['String']['output']
}

export type CustomerFeedbackInput = {
  comment?: InputMaybe<Scalars['String']['input']>
  orderId?: InputMaybe<Scalars['String']['input']>
  satisfied: Scalars['Boolean']['input']
  source?: InputMaybe<Scalars['String']['input']>
}

export type CustomerFeedbackResult =
  | CustomerFeedbackError
  | CustomerFeedbackSuccess

export type CustomerFeedbackSuccess = {
  __typename: 'CustomerFeedbackSuccess'
  brand: Scalars['String']['output']
  client: Scalars['String']['output']
  comment: Scalars['String']['output']
  creation: Scalars['String']['output']
  customerId: Scalars['String']['output']
  feedbackId: Scalars['String']['output']
  orderId?: Maybe<Scalars['String']['output']>
  satisfied: Scalars['Boolean']['output']
  source?: Maybe<Scalars['String']['output']>
  store: Scalars['String']['output']
}

export type CustomerInformation = {
  __typename: 'CustomerInformation'
  email: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  lastName?: Maybe<Scalars['String']['output']>
}

export type CustomerMultiAddressInput = {
  addressFirstLine: Scalars['String']['input']
  addressKey: Scalars['String']['input']
  city?: InputMaybe<Scalars['String']['input']>
  country: Scalars['String']['input']
  extraAddressLine?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  houseNumber?: InputMaybe<Scalars['String']['input']>
  houseNumberExtension?: InputMaybe<Scalars['String']['input']>
  isMyAddress: Scalars['Boolean']['input']
  lastName: Scalars['String']['input']
  postcode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
}

export type CustomerRecommendationSource = {
  __typename: 'CustomerRecommendationSource'
  orderId: Scalars['String']['output']
  orderItemId: Scalars['String']['output']
  reminderId: Scalars['String']['output']
}

export type CustomerRecommendationsRequest = {
  algorithm?: InputMaybe<Scalars['String']['input']>
  legacyId: Scalars['String']['input']
}

export type CustomerRecommendationsResponse = {
  __typename: 'CustomerRecommendationsResponse'
  occasion: Scalars['String']['output']
  products: Array<Maybe<Product>>
  source: CustomerRecommendationSource
  type: Scalars['String']['output']
}

export enum CustomerSegment {
  ACTIVE_CUSTOMER_HAS_ATTACHED = 'ACTIVE_CUSTOMER_HAS_ATTACHED',
  ACTIVE_CUSTOMER_NEVER_ATTACHED = 'ACTIVE_CUSTOMER_NEVER_ATTACHED',
  LAPSED_CUSTOMER = 'LAPSED_CUSTOMER',
  NEW_CUSTOMER_NEVER_ATTACHED = 'NEW_CUSTOMER_NEVER_ATTACHED',
}

export type CustomerSelfServiceFailed = CustomerSelfServiceResponse & {
  __typename: 'CustomerSelfServiceFailed'
  message: Scalars['String']['output']
}

export type CustomerSelfServiceInput = {
  orderId: Scalars['ID']['input']
  orderLineItemIds: Array<Scalars['ID']['input']>
  reason: Scalars['String']['input']
  resolution: Scalars['String']['input']
}

export type CustomerSelfServiceResponse = {
  message: Scalars['String']['output']
}

export type CustomerSelfServiceSuccess = CustomerSelfServiceResponse & {
  __typename: 'CustomerSelfServiceSuccess'
  message: Scalars['String']['output']
}

export type CustomerUpdateAddressInput = {
  addressFirstLine: Scalars['String']['input']
  addressId: Scalars['String']['input']
  city?: InputMaybe<Scalars['String']['input']>
  country: Scalars['String']['input']
  extraAddressLine?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  houseNumber?: InputMaybe<Scalars['String']['input']>
  houseNumberExtension?: InputMaybe<Scalars['String']['input']>
  isMyAddress: Scalars['Boolean']['input']
  lastName: Scalars['String']['input']
  postcode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  /** @deprecated No longer in use */
  title?: InputMaybe<Scalars['String']['input']>
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type CutOff = {
  __typename: 'CutOff'
  message: Scalars['String']['output']
  time: Scalars['String']['output']
}

export type DefaultPackagingInput = {
  sku: Scalars['String']['input']
}

export type DefaultPackagingResult = VariantPackaging

export type DeleteBasketInput = {
  id: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type DeleteBasketResult =
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeleteBasketSuccessResult

export type DeleteBasketSuccessResult = {
  __typename: 'DeleteBasketSuccessResult'
  id: Scalars['ID']['output']
}

export type DeleteBusinessProjectOutput = {
  __typename: 'DeleteBusinessProjectOutput'
  success: Scalars['Boolean']['output']
}

export type DeleteBusinessProjectResponse =
  | DeleteBusinessProjectOutput
  | InputValidationError

export type DeleteDesignInlayInput = {
  designId: Scalars['String']['input']
}

export type DeleteDesignInlayResult =
  | Design
  | DesignAuthorizationError
  | DesignNotFoundError
  | DesignServiceError
  | DesignStateError
  | DesignTemplatesServiceError

export type DeleteDraftDesignInput = {
  id: Scalars['String']['input']
}

export type DeleteDraftDesignResult =
  | DesignAuthorizationError
  | DesignDeleted
  | DesignNotDraftError
  | DesignNotFoundError
  | DesignServiceError

export type DeleteLineItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  lineItemId: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type DeleteLineItemResult =
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError

export type DeleteReminderResult = DeletedReminder | ReminderNotFound

export type DeletedReminder = Node & {
  __typename: 'DeletedReminder'
  id: Scalars['ID']['output']
}

export type DeletedRemindersSuccess = {
  __typename: 'DeletedRemindersSuccess'
  success: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

export type Delivery = {
  __typename: 'Delivery'
  /** @deprecated Use recipientAddress */
  address: ShippingAddress
  availableDeliveryDates: Array<Scalars['Date']['output']>
  availableMethods: Array<DeliveryMethod>
  canHaveGiftNote: Scalars['Boolean']['output']
  deliveryDate: Scalars['Date']['output']
  dispatchDate: Scalars['Date']['output']
  /** @deprecated For internal use only */
  fulfilmentCentre?: Maybe<FulfilmentCentre>
  giftNote?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  instructions?: Maybe<Scalars['String']['output']>
  lineItems: Array<LineItem>
  method: DeliveryMethod
  mobile?: Maybe<Scalars['String']['output']>
  options?: Maybe<AvailableDeliveryOptions>
  recipientAddress: RecipientAddress
}

export type DeliveryavailableDeliveryDatesArgs = {
  from?: InputMaybe<Scalars['Date']['input']>
  to?: InputMaybe<Scalars['Date']['input']>
}

export type DeliveryAddressInvalidError = Error & {
  __typename: 'DeliveryAddressInvalidError'
  message: Scalars['String']['output']
}

export type DeliveryCancellationRequested = DeliveryPipelineOnHold &
  DeliveryStatus & {
    __typename: 'DeliveryCancellationRequested'
    deliveryStages?: Maybe<Array<DeliveryStage>>
    display: DeliveryStatusDisplay
    isBlocked: Scalars['Boolean']['output']
    pipelineStatus: DeliveryPipelineStatus
    state: DeliveryState
  }

export type DeliveryCancelled = DeliveryPipelineCancelled &
  DeliveryStatus & {
    __typename: 'DeliveryCancelled'
    deliveryStages?: Maybe<Array<DeliveryStage>>
    display: DeliveryStatusDisplay
    isBlocked: Scalars['Boolean']['output']
    pipelineStatus: DeliveryPipelineStatus
    state: DeliveryState
  }

export type DeliveryCountryInvalidError = Error & {
  __typename: 'DeliveryCountryInvalidError'
  /** @deprecated Will be removed in upcoming release, use DeliveryRestrictedError */
  message: Scalars['String']['output']
}

export type DeliveryDateNotAvailableError = Error & {
  __typename: 'DeliveryDateNotAvailableError'
  message: Scalars['String']['output']
}

export type DeliveryDelivered = DeliveryPipelineComplete &
  DeliveryStatus & {
    __typename: 'DeliveryDelivered'
    deliveredDate?: Maybe<Scalars['Date']['output']>
    deliveryStages?: Maybe<Array<DeliveryStage>>
    dispatchDate?: Maybe<Scalars['Date']['output']>
    display: DeliveryStatusDisplay
    isBlocked: Scalars['Boolean']['output']
    pipelineStatus: DeliveryPipelineStatus
    state: DeliveryState
  }

export type DeliveryDispatched = DeliveryPipelineComplete &
  DeliveryStatus & {
    __typename: 'DeliveryDispatched'
    deliveryStages?: Maybe<Array<DeliveryStage>>
    dispatchDate?: Maybe<Scalars['Date']['output']>
    display: DeliveryStatusDisplay
    isBlocked: Scalars['Boolean']['output']
    pipelineStatus: DeliveryPipelineStatus
    state: DeliveryState
  }

export type DeliveryGuarantee = {
  __typename: 'DeliveryGuarantee'
  termsAndConditions?: Maybe<TermsAndConditions>
}

export type DeliveryMethod = {
  __typename: 'DeliveryMethod'
  acceptsDeliveryInstructions: Scalars['Boolean']['output']
  deliveryGuarantee?: Maybe<DeliveryGuarantee>
  description: Scalars['String']['output']
  isGuaranteed: Scalars['Boolean']['output']
  isTracked: Scalars['Boolean']['output']
  methodId: Scalars['String']['output']
  name: Scalars['String']['output']
  peakService?: Maybe<PeakService>
  price: Money
  priceDisplay?: Maybe<Scalars['String']['output']>
}

export type DeliveryMethodNotAvailableError = Error & {
  __typename: 'DeliveryMethodNotAvailableError'
  message: Scalars['String']['output']
}

export type DeliveryNotFoundError = Error & {
  __typename: 'DeliveryNotFoundError'
  deliveryId: Scalars['String']['output']
  message: Scalars['String']['output']
}

export type DeliveryOnHold = DeliveryPipelineOnHold &
  DeliveryStatus & {
    __typename: 'DeliveryOnHold'
    deliveryStages?: Maybe<Array<DeliveryStage>>
    display: DeliveryStatusDisplay
    isBlocked: Scalars['Boolean']['output']
    pipelineStatus: DeliveryPipelineStatus
    state: DeliveryState
  }

export type DeliveryOption = {
  __typename: 'DeliveryOption'
  availableMethods: Array<DeliveryMethod>
  deliveryDate: Scalars['Date']['output']
  fromPrice: Money
}

export type DeliveryOptions = {
  __typename: 'DeliveryOptions'
  /** @deprecated Beta feature. Do not use yet */
  availableDeliveryDates: Array<Scalars['Date']['output']>
  deliveries: Array<Delivery>
  deliveryInfoValid: Scalars['Boolean']['output']
}

export type DeliveryOptionsavailableDeliveryDatesArgs = {
  deliveryId: Scalars['ID']['input']
  from: Scalars['Date']['input']
}

export type DeliveryOutForDelivery = DeliveryPipelineComplete &
  DeliveryStatus & {
    __typename: 'DeliveryOutForDelivery'
    deliveryStages?: Maybe<Array<DeliveryStage>>
    dispatchDate?: Maybe<Scalars['Date']['output']>
    display: DeliveryStatusDisplay
    isBlocked: Scalars['Boolean']['output']
    pipelineStatus: DeliveryPipelineStatus
    state: DeliveryState
  }

export type DeliveryPacked = DeliveryPipelineInProgress &
  DeliveryStatus & {
    __typename: 'DeliveryPacked'
    deliveryStages?: Maybe<Array<DeliveryStage>>
    display: DeliveryStatusDisplay
    isBlocked: Scalars['Boolean']['output']
    pipelineStatus: DeliveryPipelineStatus
    state: DeliveryState
  }

export type DeliveryPipelineCancelled = {
  deliveryStages?: Maybe<Array<DeliveryStage>>
  display: DeliveryStatusDisplay
  isBlocked: Scalars['Boolean']['output']
  pipelineStatus: DeliveryPipelineStatus
  state: DeliveryState
}

export type DeliveryPipelineComplete = {
  deliveryStages?: Maybe<Array<DeliveryStage>>
  dispatchDate?: Maybe<Scalars['Date']['output']>
  display: DeliveryStatusDisplay
  isBlocked: Scalars['Boolean']['output']
  pipelineStatus: DeliveryPipelineStatus
  state: DeliveryState
}

export type DeliveryPipelineFailed = {
  deliveryStages?: Maybe<Array<DeliveryStage>>
  display: DeliveryStatusDisplay
  isBlocked: Scalars['Boolean']['output']
  pipelineStatus: DeliveryPipelineStatus
  state: DeliveryState
}

export type DeliveryPipelineInProgress = {
  deliveryStages?: Maybe<Array<DeliveryStage>>
  display: DeliveryStatusDisplay
  isBlocked: Scalars['Boolean']['output']
  pipelineStatus: DeliveryPipelineStatus
  state: DeliveryState
}

export type DeliveryPipelineOnHold = {
  deliveryStages?: Maybe<Array<DeliveryStage>>
  display: DeliveryStatusDisplay
  isBlocked: Scalars['Boolean']['output']
  pipelineStatus: DeliveryPipelineStatus
  state: DeliveryState
}

export type DeliveryPipelinePending = {
  deliveryStages?: Maybe<Array<DeliveryStage>>
  display: DeliveryStatusDisplay
  isBlocked: Scalars['Boolean']['output']
  pipelineStatus: DeliveryPipelineStatus
  state: DeliveryState
}

/** Used to help determine how far a delivery is along a specific pipeline state */
export enum DeliveryPipelineProgressState {
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
}

/** Used to help determine how a specific delivery state aligns itself in its overall process */
export enum DeliveryPipelineState {
  /** CANCELLED - The Delivery has been successfully cancelled. */
  CANCELLED = 'CANCELLED',
  /** COMPLETE - The delivery has left the Fulfilment Centre and is being handled by the courier */
  COMPLETE = 'COMPLETE',
  /** FAILED - We currently cannot, or will not be processing the delivery. */
  FAILED = 'FAILED',
  /** IN_PROGRESS - A delivery is being processed in one of the fulfilment centres */
  IN_PROGRESS = 'IN_PROGRESS',
  /** ON_HOLD - The progress of the delivery is paused until further confirmation has been received. */
  ON_HOLD = 'ON_HOLD',
  /** PENDING - We've created the delivery but we are awaiting confirmation. */
  PENDING = 'PENDING',
}

export type DeliveryPipelineStatus = {
  __typename: 'DeliveryPipelineStatus'
  progress: DeliveryPipelineProgressState
  state: DeliveryPipelineState
}

export type DeliveryProcessing = DeliveryPipelineInProgress &
  DeliveryStatus & {
    __typename: 'DeliveryProcessing'
    deliveryStages?: Maybe<Array<DeliveryStage>>
    display: DeliveryStatusDisplay
    isBlocked: Scalars['Boolean']['output']
    pipelineStatus: DeliveryPipelineStatus
    state: DeliveryState
  }

export type DeliveryReceived = DeliveryPipelinePending &
  DeliveryStatus & {
    __typename: 'DeliveryReceived'
    deliveryStages?: Maybe<Array<DeliveryStage>>
    display: DeliveryStatusDisplay
    isBlocked: Scalars['Boolean']['output']
    pipelineStatus: DeliveryPipelineStatus
    state: DeliveryState
  }

export type DeliveryRestrictedError = Error & {
  __typename: 'DeliveryRestrictedError'
  message: Scalars['String']['output']
  restrictions: Array<Scalars['String']['output']>
}

export type DeliveryServiceTarget = {
  __typename: 'DeliveryServiceTarget'
  display: DeliveryServiceTargetDisplay
  hasBrandGuarantee: Scalars['Boolean']['output']
  serviceType: DeliveryServiceTargetType
  targetDate?: Maybe<OrderDate>
}

export type DeliveryServiceTargetDisplay = {
  __typename: 'DeliveryServiceTargetDisplay'
  targetSummary: Scalars['String']['output']
}

export enum DeliveryServiceTargetType {
  DELIVERY_BY = 'DELIVERY_BY',
  DELIVERY_FROM = 'DELIVERY_FROM',
  GUARANTEED_BY = 'GUARANTEED_BY',
}

export type DeliveryStage = {
  label: Scalars['String']['output']
  progress: DeliveryPipelineProgressState
  stageNumber: Scalars['Int']['output']
  timestamp?: Maybe<Scalars['Date']['output']>
}

export enum DeliveryState {
  CANCELLATION_REQUESTED = 'CANCELLATION_REQUESTED',
  CANCELLED = 'CANCELLED',
  DELIVERED = 'DELIVERED',
  DISPATCHED = 'DISPATCHED',
  ON_HOLD = 'ON_HOLD',
  OUT_FOR_DELIVERY = 'OUT_FOR_DELIVERY',
  PACKED = 'PACKED',
  PROCESSING = 'PROCESSING',
  RECEIVED = 'RECEIVED',
}

export type DeliveryStatus = {
  deliveryStages?: Maybe<Array<DeliveryStage>>
  display: DeliveryStatusDisplay
  isBlocked: Scalars['Boolean']['output']
  pipelineStatus: DeliveryPipelineStatus
  /** Delivery State: direct consumption is not recommended - Use pipelineStatus instead. */
  state: DeliveryState
}

export type DeliveryStatusDisplay = {
  __typename: 'DeliveryStatusDisplay'
  /** Detailed Status Title - longer title with additional context. Useful for order details */
  detailedStatusTitle: Scalars['String']['output']
  /** Icon - Used to determine which assets to load on the client */
  icon?: Maybe<DeliveryStatusDisplayIcon>
  /** Status Details - expanded explanation of the what the status means to the customer */
  statusDetails?: Maybe<Scalars['String']['output']>
  /** Status Name: (English Only) - used for tagging/attribution */
  statusName: Scalars['String']['output']
  /** Status Title - short summary or status. useful for order history */
  statusTitle: Scalars['String']['output']
}

export type DeliveryStatusDisplayIcon = {
  __typename: 'DeliveryStatusDisplayIcon'
  assetKey: Scalars['String']['output']
}

export enum DeliveryType {
  EMAIL = 'EMAIL',
  POSTAL = 'POSTAL',
}

export type DeliveryValidation = BasketValidation & {
  __typename: 'DeliveryValidation'
  isBlocking: Scalars['Boolean']['output']
  message: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type DemoInlay = Inlay & {
  __typename: 'DemoInlay'
  id: Scalars['ID']['output']
  scene: InlayScene
  sceneObjects: Array<InlaySceneObject>
}

export type DepartmentCount = {
  __typename: 'DepartmentCount'
  count?: Maybe<Scalars['Int']['output']>
  department: DepartmentsEnum
}

export enum DepartmentsEnum {
  ACRYLICS = 'ACRYLICS',
  ALCOHOL_GIFTS = 'ALCOHOL_GIFTS',
  ALL_CARDS = 'ALL_CARDS',
  ALL_FLOWERS_AND_PLANTS = 'ALL_FLOWERS_AND_PLANTS',
  ALL_GIFTS = 'ALL_GIFTS',
  ARENA_POSTAL_FLOWERS = 'ARENA_POSTAL_FLOWERS',
  BALLOONS = 'BALLOONS',
  BEAUTY = 'BEAUTY',
  CALENDAR_PHOTOBOX = 'CALENDAR_PHOTOBOX',
  CANVASES = 'CANVASES',
  CASES = 'CASES',
  DIGITAL_GIFTS = 'DIGITAL_GIFTS',
  DIGITAL_GIFT_CARDS = 'DIGITAL_GIFT_CARDS',
  FLOWERS = 'FLOWERS',
  FOOD_GIFTS = 'FOOD_GIFTS',
  FRAMES = 'FRAMES',
  GADGETS_AND_NOVELTIES = 'GADGETS_AND_NOVELTIES',
  GIFTS_FOR_HOME = 'GIFTS_FOR_HOME',
  GIFT_BOXES = 'GIFT_BOXES',
  GIFT_EXPERIENCES = 'GIFT_EXPERIENCES',
  GIFT_VOUCHERS = 'GIFT_VOUCHERS',
  GREETING_CARDS = 'GREETING_CARDS',
  GUERNSEY_POSTAL_FLOWERS = 'GUERNSEY_POSTAL_FLOWERS',
  INVITATIONS_AND_ANNOUNCEMENTS = 'INVITATIONS_AND_ANNOUNCEMENTS',
  JEWELLERY_AND_ACCESSORIES = 'JEWELLERY_AND_ACCESSORIES',
  LETTERBOX_GIFTS = 'LETTERBOX_GIFTS',
  MINI_CARDS = 'MINI_CARDS',
  MUGS = 'MUGS',
  NON_CUSTOMISABLE_GIFTS = 'NON_CUSTOMISABLE_GIFTS',
  PARTY = 'PARTY',
  PLANTS = 'PLANTS',
  SOFT_TOYS = 'SOFT_TOYS',
  STATIONERY_AND_CRAFT = 'STATIONERY_AND_CRAFT',
  TOYS_AND_GAMES = 'TOYS_AND_GAMES',
  TSHIRTS = 'TSHIRTS',
  WALL_ART = 'WALL_ART',
  WEDDING_STATIONERY = 'WEDDING_STATIONERY',
}

export enum Dependencies {
  DIRECT_SMILE = 'DIRECT_SMILE',
}

export type Design = {
  __typename: 'Design'
  availableStickerSets: Array<DesignAvailableStickerSet>
  availableTextStyles: DesignAvailableTextStyles
  capabilities: Array<DesignCapability>
  clientOrigin?: Maybe<DesignClientOrigin>
  compositions: Array<DesignComposition>
  createdAt: Scalars['String']['output']
  defaultTextStyle?: Maybe<DesignDefaultTextStyle>
  expiresOn: Scalars['Int']['output']
  id: Scalars['ID']['output']
  images: SceneImagesResult
  layout: DesignLayout
  /** @deprecated No longer supported */
  legacyCustomerId?: Maybe<Scalars['String']['output']>
  limits: DesignLimits
  originRegion: Scalars['String']['output']
  owner?: Maybe<Customer>
  productKey: Scalars['String']['output']
  requiresNewRenderer: Scalars['Boolean']['output']
  scenes: Array<DesignScene>
  sku?: Maybe<Scalars['String']['output']>
  sourceId?: Maybe<Scalars['ID']['output']>
  stampTheme: DesignStampTheme
  state: DesignState
  /**
   * Legacy store field. Not used by the Design API in any way and not used by any consumers.
   * Verified across all clients that this field is not used on 2023-04-26.
   * @deprecated No longer supported
   */
  store?: Maybe<DesignStore>
  token: Scalars['String']['output']
  updatedAt: Scalars['String']['output']
  usedFeatures: Array<EditorFeature>
  version: Scalars['Int']['output']
}

export type DesignimagesArgs = {
  composition?: InputMaybe<Scalars['Boolean']['input']>
  debugOverlay?: InputMaybe<Scalars['Boolean']['input']>
  experimental?: InputMaybe<Scalars['Boolean']['input']>
  legacySessionId?: InputMaybe<Scalars['String']['input']>
  substitutions?: InputMaybe<Array<RendererSubstitutionInput>>
  textOnly?: InputMaybe<Scalars['Boolean']['input']>
  useCacheOnly?: InputMaybe<Scalars['Boolean']['input']>
  useNewCache?: InputMaybe<Scalars['Boolean']['input']>
}

export type DesignAddedToBasket = {
  __typename: 'DesignAddedToBasket'
  basket: Basket
  basketId: Scalars['ID']['output']
  basketTotalItems: Scalars['Int']['output']
  customerId?: Maybe<Scalars['String']['output']>
  lineItems: Array<DesignLineItem>
}

export type DesignAddonInput = {
  sku: Scalars['String']['input']
}

export type DesignAmendmentFailure = AmendResult & {
  __typename: 'DesignAmendmentFailure'
  errorCode: AmendErrorCode
  message: Scalars['String']['output']
}

export type DesignAmendmentInput = {
  customerId: Scalars['ID']['input']
  deliveryId: Scalars['String']['input']
  lineItemIds?: InputMaybe<Array<Scalars['String']['input']>>
}

export type DesignAmendmentItem = {
  __typename: 'DesignAmendmentItem'
  amendmentUrl: Scalars['String']['output']
  designId: Scalars['String']['output']
  lineItemId: Scalars['String']['output']
}

export type DesignAmendmentSuccess = AmendResult & {
  __typename: 'DesignAmendmentSuccess'
  amendments: Array<DesignAmendmentItem>
  customerId: Scalars['ID']['output']
  deliveryId: Scalars['String']['output']
  message: Scalars['String']['output']
  orderId: Scalars['ID']['output']
}

export type DesignAuthorizationError = Error & {
  __typename: 'DesignAuthorizationError'
  message: Scalars['String']['output']
  requiresLogin: Scalars['Boolean']['output']
}

export type DesignAvailableColorSet = {
  __typename: 'DesignAvailableColorSet'
  id: Scalars['ID']['output']
}

export type DesignAvailableFontSet = {
  __typename: 'DesignAvailableFontSet'
  id: Scalars['ID']['output']
}

export type DesignAvailableStickerSet = {
  __typename: 'DesignAvailableStickerSet'
  id: Scalars['ID']['output']
}

export type DesignAvailableTextStyles = {
  __typename: 'DesignAvailableTextStyles'
  availableColors: Array<DesignColor>
  availableFontFaces: Array<DesignFontFace>
  availableFontSizes: Array<Scalars['Float']['output']>
  customerCreationsCustomFontFaces: Array<CustomerCreationsCustomFontFace>
}

export enum DesignCapability {
  AI_STICKERS = 'AI_STICKERS',
  AUDIO = 'AUDIO',
  LAYOUTS = 'LAYOUTS',
  OVERLAY_HANDWRITING = 'OVERLAY_HANDWRITING',
  OVERLAY_IMAGE = 'OVERLAY_IMAGE',
  OVERLAY_TEXT = 'OVERLAY_TEXT',
  SMART_TEXT = 'SMART_TEXT',
  STICKERS = 'STICKERS',
  TEXT_STYLE_SETS = 'TEXT_STYLE_SETS',
  VIDEO = 'VIDEO',
}

export type DesignClientOrigin = {
  __typename: 'DesignClientOrigin'
  name: Scalars['String']['output']
  version?: Maybe<Scalars['String']['output']>
}

export type DesignCollageGrid = {
  __typename: 'DesignCollageGrid'
  background?: Maybe<DesignCollageGridBackground>
  border?: Maybe<DesignCollageGridBorder>
  cells: Array<DesignCollageGridCell>
  gutters: Array<DesignCollageGridGutter>
  id: Scalars['ID']['output']
}

export type DesignCollageGridBackground = {
  __typename: 'DesignCollageGridBackground'
  color: Scalars['String']['output']
}

export type DesignCollageGridBackgroundInput = {
  color: Scalars['String']['input']
}

export type DesignCollageGridBorder = {
  __typename: 'DesignCollageGridBorder'
  bottom: Scalars['Float']['output']
  inner: Scalars['Float']['output']
  left: Scalars['Float']['output']
  right: Scalars['Float']['output']
  top: Scalars['Float']['output']
}

export type DesignCollageGridBorderInput = {
  bottom: Scalars['Float']['input']
  inner: Scalars['Float']['input']
  left: Scalars['Float']['input']
  right: Scalars['Float']['input']
  top: Scalars['Float']['input']
}

export type DesignCollageGridCell = {
  __typename: 'DesignCollageGridCell'
  anchors: DesignCollageGridCellAnchors
  content: DesignCollageGridCellContent
  id: Scalars['ID']['output']
}

export type DesignCollageGridCellAnchors = {
  __typename: 'DesignCollageGridCellAnchors'
  bottom?: Maybe<Scalars['ID']['output']>
  left?: Maybe<Scalars['ID']['output']>
  right?: Maybe<Scalars['ID']['output']>
  top?: Maybe<Scalars['ID']['output']>
}

export type DesignCollageGridCellAnchorsInput = {
  bottom?: InputMaybe<Scalars['ID']['input']>
  left?: InputMaybe<Scalars['ID']['input']>
  right?: InputMaybe<Scalars['ID']['input']>
  top?: InputMaybe<Scalars['ID']['input']>
}

export type DesignCollageGridCellContent = {
  __typename: 'DesignCollageGridCellContent'
  image?: Maybe<DesignCollageGridCellContentImage>
  placeholder?: Maybe<DesignCollageGridCellContentPlaceholder>
}

export type DesignCollageGridCellContentImage = {
  __typename: 'DesignCollageGridCellContentImage'
  sourceImage: DesignCollageGridCellSourceImage
}

export type DesignCollageGridCellContentImageInput = {
  sourceImage: DesignCollageGridCellSourceImageInput
}

export type DesignCollageGridCellContentInput = {
  image?: InputMaybe<DesignCollageGridCellContentImageInput>
  placeholder?: InputMaybe<DesignCollageGridCellContentPlaceholderInput>
}

export type DesignCollageGridCellContentPlaceholder = {
  __typename: 'DesignCollageGridCellContentPlaceholder'
  kind: DesignCollageGridCellContentPlaceholderKind
  placedId?: Maybe<Scalars['ID']['output']>
}

export type DesignCollageGridCellContentPlaceholderInput = {
  kind: DesignCollageGridCellContentPlaceholderKind
  placedId?: InputMaybe<Scalars['ID']['input']>
}

export enum DesignCollageGridCellContentPlaceholderKind {
  IMAGE = 'IMAGE',
  TEXT = 'TEXT',
}

export type DesignCollageGridCellInput = {
  anchors: DesignCollageGridCellAnchorsInput
  content: DesignCollageGridCellContentInput
  id?: InputMaybe<Scalars['ID']['input']>
}

export type DesignCollageGridCellSourceImage = {
  __typename: 'DesignCollageGridCellSourceImage'
  id: Scalars['ID']['output']
  offsetX: Scalars['Float']['output']
  offsetY: Scalars['Float']['output']
  scale: Scalars['Float']['output']
}

export type DesignCollageGridCellSourceImageInput = {
  id: Scalars['ID']['input']
  offsetX: Scalars['Float']['input']
  offsetY: Scalars['Float']['input']
  scale: Scalars['Float']['input']
}

export type DesignCollageGridGutter = {
  __typename: 'DesignCollageGridGutter'
  anchors: DesignCollageGridGutterAnchors
  id: Scalars['ID']['output']
  offset: Scalars['Float']['output']
  orientation: DesignCollageGridGutterOrientation
}

export type DesignCollageGridGutterAnchors = {
  __typename: 'DesignCollageGridGutterAnchors'
  end?: Maybe<Scalars['ID']['output']>
  start?: Maybe<Scalars['ID']['output']>
}

export type DesignCollageGridGutterAnchorsInput = {
  end?: InputMaybe<Scalars['ID']['input']>
  start?: InputMaybe<Scalars['ID']['input']>
}

export type DesignCollageGridGutterInput = {
  anchors: DesignCollageGridGutterAnchorsInput
  id: Scalars['ID']['input']
  offset: Scalars['Float']['input']
  orientation: DesignCollageGridGutterOrientation
}

export enum DesignCollageGridGutterOrientation {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
}

export type DesignCollageGridInput = {
  background?: InputMaybe<DesignCollageGridBackgroundInput>
  border?: InputMaybe<DesignCollageGridBorderInput>
  cells: Array<DesignCollageGridCellInput>
  gutters: Array<DesignCollageGridGutterInput>
  id?: InputMaybe<Scalars['ID']['input']>
}

export type DesignCollageGrids = {
  __typename: 'DesignCollageGrids'
  grids: Array<DesignCollageGrid>
}

export type DesignCollageGridsResult = DesignCollageGrids | DesignServiceError

export type DesignColor = {
  __typename: 'DesignColor'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type DesignComposition = {
  __typename: 'DesignComposition'
  height: Scalars['Int']['output']
  layers: Array<DesignCompositionLayer>
  width: Scalars['Int']['output']
}

export type DesignCompositionLayer =
  | DesignCompositionLayerMapping
  | DesignCompositionLayerStatic

export enum DesignCompositionLayerBlendMode {
  COLOR = 'COLOR',
  COLOR_BURN = 'COLOR_BURN',
  COLOR_DODGE = 'COLOR_DODGE',
  DARKEN = 'DARKEN',
  DIFFERENCE = 'DIFFERENCE',
  EXCLUSION = 'EXCLUSION',
  HARD_LIGHT = 'HARD_LIGHT',
  HUE = 'HUE',
  LIGHTEN = 'LIGHTEN',
  LIGHTER = 'LIGHTER',
  MULTIPLY = 'MULTIPLY',
  OVERLAY = 'OVERLAY',
  SATURATION = 'SATURATION',
  SCREEN = 'SCREEN',
  SOFT_LIGHT = 'SOFT_LIGHT',
  SOURCE_OVER = 'SOURCE_OVER',
}

export type DesignCompositionLayerMapping = {
  __typename: 'DesignCompositionLayerMapping'
  blendMode: DesignCompositionLayerBlendMode
  imageUrl: Scalars['String']['output']
  opacity: Scalars['Float']['output']
  sceneId: Scalars['ID']['output']
}

export type DesignCompositionLayerStatic = {
  __typename: 'DesignCompositionLayerStatic'
  blendMode: DesignCompositionLayerBlendMode
  imageUrl: Scalars['String']['output']
  opacity: Scalars['Float']['output']
}

export type DesignCustomisationElementImageCollage = {
  __typename: 'DesignCustomisationElementImageCollage'
  editedImage: DesignImageUploaded
  elementId: Scalars['ID']['output']
  grid?: Maybe<DesignCollageGrid>
}

export type DesignCustomisationElementImageCollageInput = {
  editedImage: DesignImageUploadedInput
  elementId: Scalars['ID']['input']
  grid?: InputMaybe<DesignCollageGridInput>
}

export type DesignCustomisationElementImageDynamic = {
  __typename: 'DesignCustomisationElementImageDynamic'
  elementId: Scalars['ID']['output']
  textParts: Array<Scalars['String']['output']>
}

export type DesignCustomisationElementImageDynamicInput = {
  elementId: Scalars['ID']['input']
  textParts: Array<Scalars['String']['input']>
}

export type DesignCustomisationElementImageUpload = {
  __typename: 'DesignCustomisationElementImageUpload'
  editedImage: DesignImageUploaded
  elementId: Scalars['ID']['output']
  sourceImage?: Maybe<DesignImageSource>
}

export type DesignCustomisationElementImageUploadInput = {
  editedImage: DesignImageUploadedInput
  elementId: Scalars['ID']['input']
  sourceImage?: InputMaybe<DesignImageSourceInput>
  /** @deprecated Ignored, use sourceImage.transform instead */
  transform?: InputMaybe<DesignTransformInput>
}

export type DesignCustomisationElementTextPlaceholder = {
  __typename: 'DesignCustomisationElementTextPlaceholder'
  elementId: Scalars['ID']['output']
  textParts: Array<Scalars['String']['output']>
}

export type DesignCustomisationElementTextPlaceholderInput = {
  elementId: Scalars['ID']['input']
  textParts: Array<Scalars['String']['input']>
}

export type DesignCustomisationElementTextPlain = {
  __typename: 'DesignCustomisationElementTextPlain'
  elementId: Scalars['ID']['output']
  substitutions?: Maybe<Array<Scalars['String']['output']>>
  text: Scalars['String']['output']
}

export type DesignCustomisationElementTextPlainInput = {
  elementId: Scalars['ID']['input']
  substitutions?: InputMaybe<Array<Scalars['String']['input']>>
  text: Scalars['String']['input']
}

export type DesignCustomisationElementTextStyled = {
  __typename: 'DesignCustomisationElementTextStyled'
  colorId: Scalars['String']['output']
  elementId: Scalars['ID']['output']
  fontFaceId: Scalars['String']['output']
  fontSize: Scalars['Float']['output']
  horizontalAlignment: DesignHorizontalAlignment
  substitutions?: Maybe<Array<Scalars['String']['output']>>
  text: Scalars['String']['output']
  verticalAlignment: DesignVerticalAlignment
}

export type DesignCustomisationElementTextStyledInput = {
  colorId: Scalars['String']['input']
  elementId: Scalars['ID']['input']
  fontFaceId: Scalars['String']['input']
  fontSize: Scalars['Float']['input']
  horizontalAlignment: DesignHorizontalAlignment
  substitutions?: InputMaybe<Array<Scalars['String']['input']>>
  text: Scalars['String']['input']
  verticalAlignment: DesignVerticalAlignment
}

export type DesignCustomisationPageInfo = {
  __typename: 'DesignCustomisationPageInfo'
  endCursor?: Maybe<Scalars['ID']['output']>
  hasNextPage: Scalars['Boolean']['output']
}

export type DesignCustomisations = {
  __typename: 'DesignCustomisations'
  groupMessages?: Maybe<DesignCustomisationsGroupMessages>
  handwriting?: Maybe<DesignCustomisationsHandwriting>
  imageUpload?: Maybe<DesignCustomisationsImageUpload>
  layout?: Maybe<DesignCustomisationsLayout>
  overlay?: Maybe<DesignCustomisationsOverlay>
  template?: Maybe<DesignCustomisationsTemplate>
}

export type DesignCustomisationsGroupMessages = {
  __typename: 'DesignCustomisationsGroupMessages'
  image: DesignImageUploaded
  sourceImage?: Maybe<DesignImageSource>
}

export type DesignCustomisationsGroupMessagesInput = {
  image: DesignImageUploadedInput
  sourceImage?: InputMaybe<DesignImageSourceInput>
}

export type DesignCustomisationsHandwriting = {
  __typename: 'DesignCustomisationsHandwriting'
  image: DesignImageUploaded
  sourceImage?: Maybe<DesignImageSource>
}

export type DesignCustomisationsHandwritingInput = {
  image: DesignImageUploadedInput
  sourceImage?: InputMaybe<DesignImageSourceInput>
}

export type DesignCustomisationsImageUpload = {
  __typename: 'DesignCustomisationsImageUpload'
  image: DesignImageUploaded
  sourceImage?: Maybe<DesignImageSource>
}

export type DesignCustomisationsImageUploadInput = {
  image: DesignImageUploadedInput
  sourceImage?: InputMaybe<DesignImageSourceInput>
}

export type DesignCustomisationsInput = {
  groupMessages?: InputMaybe<DesignCustomisationsGroupMessagesInput>
  handwriting?: InputMaybe<DesignCustomisationsHandwritingInput>
  imageUpload?: InputMaybe<DesignCustomisationsImageUploadInput>
  layout?: InputMaybe<DesignCustomisationsLayoutInput>
  overlay?: InputMaybe<DesignCustomisationsOverlayInput>
  template?: InputMaybe<DesignCustomisationsTemplateInput>
}

export type DesignCustomisationsInputError = Error & {
  __typename: 'DesignCustomisationsInputError'
  errors: Array<DesignInputError>
  message: Scalars['String']['output']
}

export type DesignCustomisationsLayout = {
  __typename: 'DesignCustomisationsLayout'
  grid: DesignCollageGrid
}

export type DesignCustomisationsLayoutInput = {
  grid: DesignCollageGridInput
}

export type DesignCustomisationsOverlay = {
  __typename: 'DesignCustomisationsOverlay'
  overlays: Array<DesignOverlay>
}

export type DesignCustomisationsOverlayInput = {
  aiSticker?: InputMaybe<Array<DesignOverlayAIStickerInput>>
  image?: InputMaybe<Array<DesignOverlayImageInput>>
  inlay?: InputMaybe<Array<DesignOverlayInlayInput>>
  media?: InputMaybe<Array<DesignOverlayMediaInput>>
  sticker?: InputMaybe<Array<DesignOverlayStickerInput>>
  text?: InputMaybe<Array<DesignOverlayTextInput>>
}

export type DesignCustomisationsSceneByIndexInput = {
  customisations: DesignCustomisationsInput
  index: Scalars['Int']['input']
}

export type DesignCustomisationsSceneInput = {
  customisations: DesignCustomisationsInput
  id: Scalars['ID']['input']
}

export type DesignCustomisationsTemplate = {
  __typename: 'DesignCustomisationsTemplate'
  imageCollage: Array<DesignCustomisationElementImageCollage>
  imageDynamic: Array<DesignCustomisationElementImageDynamic>
  imageUpload: Array<DesignCustomisationElementImageUpload>
  textPlaceholder: Array<DesignCustomisationElementTextPlaceholder>
  textPlain: Array<DesignCustomisationElementTextPlain>
  textStyled: Array<DesignCustomisationElementTextStyled>
}

export type DesignCustomisationsTemplateInput = {
  imageCollage?: InputMaybe<Array<DesignCustomisationElementImageCollageInput>>
  imageDynamic?: InputMaybe<Array<DesignCustomisationElementImageDynamicInput>>
  imageUpload: Array<DesignCustomisationElementImageUploadInput>
  textPlaceholder: Array<DesignCustomisationElementTextPlaceholderInput>
  textPlain: Array<DesignCustomisationElementTextPlainInput>
  textStyled: Array<DesignCustomisationElementTextStyledInput>
}

export enum DesignCustomisationsType {
  AI_STICKERS = 'AI_STICKERS',
  AUDIO = 'AUDIO',
  GROUP_MESSAGES = 'GROUP_MESSAGES',
  HANDWRITING = 'HANDWRITING',
  IMAGE_UPLOAD = 'IMAGE_UPLOAD',
  LAYOUTS = 'LAYOUTS',
  OVERLAY_HANDWRITING = 'OVERLAY_HANDWRITING',
  OVERLAY_IMAGE = 'OVERLAY_IMAGE',
  OVERLAY_TEXT = 'OVERLAY_TEXT',
  SMART_TEXT = 'SMART_TEXT',
  STICKERS = 'STICKERS',
  TEMPLATE = 'TEMPLATE',
  VIDEO = 'VIDEO',
}

export type DesignDefaultTextStyle = {
  __typename: 'DesignDefaultTextStyle'
  colorId: Scalars['String']['output']
  fontFaceId: Scalars['String']['output']
  fontSize: Scalars['Float']['output']
}

export type DesignDeleted = {
  __typename: 'DesignDeleted'
  id: Scalars['ID']['output']
}

export type DesignElement =
  | DesignElementImageCollage
  | DesignElementImageDynamic
  | DesignElementImageStatic
  | DesignElementImageUpload
  | DesignElementShapeRectangle
  | DesignElementTextPlaceholder
  | DesignElementTextPlain
  | DesignElementTextStatic
  | DesignElementTextStyled

export type DesignElementImageCollage = {
  __typename: 'DesignElementImageCollage'
  defaultPreviewImageUrlVariants: DesignImageUrlVariants
  height: Scalars['Float']['output']
  id: Scalars['ID']['output']
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  placeholderImageUrlVariants: DesignImageUrlVariants
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignElementImageCommon = {
  height: Scalars['Float']['output']
  id: Scalars['ID']['output']
  /** Returns same as maskUrlVariants.editor */
  maskUrl?: Maybe<Scalars['String']['output']>
  maskUrlVariants?: Maybe<DesignImageUrlVariants>
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  /** Returns same as urlVariants.editor */
  url: Scalars['String']['output']
  urlVariants?: Maybe<DesignImageUrlVariants>
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignElementImageDynamic = {
  __typename: 'DesignElementImageDynamic'
  dynamic: DesignImageDynamic
  height: Scalars['Float']['output']
  id: Scalars['ID']['output']
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  textParts: Array<DesignTextPartEditable>
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignElementImageStatic = DesignElementImageCommon & {
  __typename: 'DesignElementImageStatic'
  height: Scalars['Float']['output']
  id: Scalars['ID']['output']
  /** Returns same as maskUrlVariants.editor */
  maskUrl?: Maybe<Scalars['String']['output']>
  maskUrlVariants?: Maybe<DesignImageUrlVariants>
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  /** Returns same as urlVariants.editor */
  url: Scalars['String']['output']
  urlVariants?: Maybe<DesignImageUrlVariants>
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignElementImageUpload = DesignElementImageCommon & {
  __typename: 'DesignElementImageUpload'
  height: Scalars['Float']['output']
  id: Scalars['ID']['output']
  /** Returns same as maskUrlVariants.editor */
  maskUrl?: Maybe<Scalars['String']['output']>
  maskUrlVariants?: Maybe<DesignImageUrlVariants>
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  required: Scalars['Boolean']['output']
  rotation: Scalars['Float']['output']
  /** Returns same as urlVariants.editor */
  url: Scalars['String']['output']
  urlVariants?: Maybe<DesignImageUrlVariants>
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignElementMissingRequiredError = Error & {
  __typename: 'DesignElementMissingRequiredError'
  elementId: Scalars['String']['output']
  message: Scalars['String']['output']
  sceneId: Scalars['String']['output']
  templateId: Scalars['String']['output']
}

export type DesignElementShapeRectangle = {
  __typename: 'DesignElementShapeRectangle'
  fillColor: Scalars['String']['output']
  height: Scalars['Float']['output']
  id: Scalars['ID']['output']
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  outline?: Maybe<DesignOutline>
  rotation: Scalars['Float']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignElementTextCommon = {
  color: DesignColor
  fontFace: DesignFontFace
  fontSize: Scalars['Float']['output']
  height: Scalars['Float']['output']
  horizontalAlignment: DesignHorizontalAlignment
  id: Scalars['ID']['output']
  /** @deprecated Required for legacy only */
  legacyLineSpacing?: Maybe<Scalars['Float']['output']>
  lineSpacing: Scalars['Float']['output']
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  shadow?: Maybe<DesignTextShadow>
  verticalAlignment: DesignVerticalAlignment
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignElementTextPlaceholder = DesignElementTextCommon & {
  __typename: 'DesignElementTextPlaceholder'
  color: DesignColor
  fontFace: DesignFontFace
  fontSize: Scalars['Float']['output']
  height: Scalars['Float']['output']
  horizontalAlignment: DesignHorizontalAlignment
  id: Scalars['ID']['output']
  /** @deprecated Required for legacy only */
  legacyLineSpacing?: Maybe<Scalars['Float']['output']>
  lineSpacing: Scalars['Float']['output']
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  shadow?: Maybe<DesignTextShadow>
  textParts: Array<DesignTextPart>
  verticalAlignment: DesignVerticalAlignment
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignElementTextPlain = DesignElementTextCommon & {
  __typename: 'DesignElementTextPlain'
  color: DesignColor
  editableText: DesignTextEditable
  fontFace: DesignFontFace
  fontSize: Scalars['Float']['output']
  height: Scalars['Float']['output']
  horizontalAlignment: DesignHorizontalAlignment
  id: Scalars['ID']['output']
  /** @deprecated Required for legacy only */
  legacyLineSpacing?: Maybe<Scalars['Float']['output']>
  lineSpacing: Scalars['Float']['output']
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  shadow?: Maybe<DesignTextShadow>
  verticalAlignment: DesignVerticalAlignment
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignElementTextStatic = DesignElementTextCommon & {
  __typename: 'DesignElementTextStatic'
  color: DesignColor
  fontFace: DesignFontFace
  fontSize: Scalars['Float']['output']
  height: Scalars['Float']['output']
  horizontalAlignment: DesignHorizontalAlignment
  id: Scalars['ID']['output']
  /** @deprecated Required for legacy only */
  legacyLineSpacing?: Maybe<Scalars['Float']['output']>
  lineSpacing: Scalars['Float']['output']
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  shadow?: Maybe<DesignTextShadow>
  text: Scalars['String']['output']
  verticalAlignment: DesignVerticalAlignment
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignElementTextStyled = DesignElementTextCommon & {
  __typename: 'DesignElementTextStyled'
  availableColors: Array<DesignColor>
  availableFontFaces: Array<DesignFontFace>
  availableFontSizes: Array<Scalars['Float']['output']>
  color: DesignColor
  editableText: DesignTextEditable
  fontFace: DesignFontFace
  fontSize: Scalars['Float']['output']
  height: Scalars['Float']['output']
  horizontalAlignment: DesignHorizontalAlignment
  id: Scalars['ID']['output']
  /** @deprecated Required for legacy only */
  legacyLineSpacing?: Maybe<Scalars['Float']['output']>
  lineSpacing: Scalars['Float']['output']
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  shadow?: Maybe<DesignTextShadow>
  verticalAlignment: DesignVerticalAlignment
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignFilterInput = {
  includePrintOnlyScenes?: InputMaybe<Scalars['Boolean']['input']>
  /** @deprecated No longer used */
  videoCardId?: InputMaybe<Scalars['String']['input']>
}

export type DesignFontFace = {
  __typename: 'DesignFontFace'
  id: Scalars['ID']['output']
  metrics?: Maybe<DesignFontFaceMetrics>
  name: Scalars['String']['output']
  urls: DesignFontFaceUrls
}

export type DesignFontFaceMetrics = {
  __typename: 'DesignFontFaceMetrics'
  head: DesignFontFaceMetricsHead
  hhea: DesignFontFaceMetricsHhea
  os2: DesignFontFaceMetricsOs2
}

export type DesignFontFaceMetricsHead = {
  __typename: 'DesignFontFaceMetricsHead'
  unitsPerEm: Scalars['Float']['output']
  yMax: Scalars['Float']['output']
  yMin: Scalars['Float']['output']
}

export type DesignFontFaceMetricsHhea = {
  __typename: 'DesignFontFaceMetricsHhea'
  ascender: Scalars['Float']['output']
  descender: Scalars['Float']['output']
  lineGap: Scalars['Float']['output']
}

export type DesignFontFaceMetricsOs2 = {
  __typename: 'DesignFontFaceMetricsOs2'
  fsSelection: Scalars['Float']['output']
  fsType: Scalars['Float']['output']
  sCapHeight: Scalars['Float']['output']
  sTypoAscender: Scalars['Float']['output']
  sTypoDescender: Scalars['Float']['output']
  sTypoLineGap: Scalars['Float']['output']
  sxHeight: Scalars['Float']['output']
  usWinAscent: Scalars['Float']['output']
  usWinDescent: Scalars['Float']['output']
}

export type DesignFontFaceUrls = {
  __typename: 'DesignFontFaceUrls'
  ttf: Scalars['String']['output']
  woff: Scalars['String']['output']
  woff2: Scalars['String']['output']
}

export enum DesignHorizontalAlignment {
  CENTER = 'CENTER',
  JUSTIFY = 'JUSTIFY',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export type DesignImageConfig = {
  __typename: 'DesignImageConfig'
  maxSizeBytes: Scalars['Int']['output']
  minSizeBytes: Scalars['Int']['output']
}

export type DesignImageDynamic = {
  __typename: 'DesignImageDynamic'
  format: DesignImageDynamicFormat
  id: Scalars['ID']['output']
}

export enum DesignImageDynamicFormat {
  JPEG = 'JPEG',
  PNG = 'PNG',
}

export type DesignImageSource = {
  __typename: 'DesignImageSource'
  id: Scalars['ID']['output']
  transform: DesignTransform
}

export type DesignImageSourceInput = {
  id: Scalars['ID']['input']
  transform: DesignTransformInput
}

export type DesignImageUpload = {
  __typename: 'DesignImageUpload'
  fields: Array<DesignImageUploadField>
  imageId: Scalars['ID']['output']
  url: Scalars['String']['output']
}

export type DesignImageUploadField = {
  __typename: 'DesignImageUploadField'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type DesignImageUploadLimitReachedError = Error & {
  __typename: 'DesignImageUploadLimitReachedError'
  message: Scalars['String']['output']
}

export type DesignImageUploaded = {
  __typename: 'DesignImageUploaded'
  id: Scalars['ID']['output']
  url?: Maybe<Scalars['String']['output']>
}

export type DesignImageUploadedInput = {
  id: Scalars['ID']['input']
}

export type DesignImageUrlVariants = {
  __typename: 'DesignImageUrlVariants'
  editor: Scalars['String']['output']
  preview: Scalars['String']['output']
  preview2: Scalars['String']['output']
  print: Scalars['String']['output']
  print2: Scalars['String']['output']
}

export type DesignInlayMetadata = {
  lineItemId: Scalars['String']['input']
  sku: Scalars['String']['input']
}

export type DesignInputDesignError = Error & {
  __typename: 'DesignInputDesignError'
  message: Scalars['String']['output']
}

export type DesignInputError =
  | DesignElementMissingRequiredError
  | DesignInputDesignError
  | DesignInputInvalidElementError
  | DesignInputProfanityError
  | DesignInputSceneError
  | DesignInputSceneNotFoundError
  | DesignInputTemplateElementNotFoundError

export type DesignInputInvalidElementError = Error & {
  __typename: 'DesignInputInvalidElementError'
  inputElementId: Scalars['String']['output']
  message: Scalars['String']['output']
  sceneId: Scalars['String']['output']
  templateId: Scalars['String']['output']
  type?: Maybe<Scalars['String']['output']>
}

export type DesignInputProfanityError = Error & {
  __typename: 'DesignInputProfanityError'
  inputElementId: Scalars['String']['output']
  message: Scalars['String']['output']
  sceneId: Scalars['String']['output']
  templateId: Scalars['String']['output']
  type?: Maybe<Scalars['String']['output']>
}

export type DesignInputSceneError = Error & {
  __typename: 'DesignInputSceneError'
  inputSceneId: Scalars['String']['output']
  message: Scalars['String']['output']
}

export type DesignInputSceneNotFoundError = Error & {
  __typename: 'DesignInputSceneNotFoundError'
  inputSceneId: Scalars['String']['output']
  message: Scalars['String']['output']
}

export type DesignInputTemplateElementNotFoundError = Error & {
  __typename: 'DesignInputTemplateElementNotFoundError'
  inputElementId: Scalars['String']['output']
  message: Scalars['String']['output']
  sceneId: Scalars['String']['output']
  templateId: Scalars['String']['output']
}

export type DesignIntent = {
  intent: Intent
  ordinal?: InputMaybe<Scalars['String']['input']>
  value: Scalars['String']['input']
}

export type DesignInvalidCursorError = Error & {
  __typename: 'DesignInvalidCursorError'
  message: Scalars['String']['output']
}

export type DesignInvalidTokenError = Error & {
  __typename: 'DesignInvalidTokenError'
  message: Scalars['String']['output']
}

export type DesignIsValid = {
  __typename: 'DesignIsValid'
  isValid: Scalars['Boolean']['output']
}

export type DesignIsValidInput = {
  id: Scalars['ID']['input']
}

export type DesignIsValidResult =
  | DesignAuthorizationError
  | DesignIsValid
  | DesignNotFoundError
  | DesignServiceError
  | DesignTemplatesServiceError

export enum DesignLayout {
  CARD_LANDSCAPE = 'CARD_LANDSCAPE',
  CARD_PORTRAIT = 'CARD_PORTRAIT',
  CARD_SQUARE = 'CARD_SQUARE',
  GENERIC = 'GENERIC',
  LABELS_LANDSCAPE = 'LABELS_LANDSCAPE',
  LABELS_PORTRAIT = 'LABELS_PORTRAIT',
  MUG = 'MUG',
  POSTCARD_LANDSCAPE = 'POSTCARD_LANDSCAPE',
  POSTCARD_PORTRAIT = 'POSTCARD_PORTRAIT',
  SLEEVE_HORIZONTAL = 'SLEEVE_HORIZONTAL',
  SLEEVE_VERTICAL = 'SLEEVE_VERTICAL',
  TSHIRT = 'TSHIRT',
  TSHIRT_FRONT = 'TSHIRT_FRONT',
  TSHIRT_FRONT_BACK = 'TSHIRT_FRONT_BACK',
  UNKNOWN = 'UNKNOWN',
}

export type DesignLimits = {
  __typename: 'DesignLimits'
  maxHandwritingCount: Scalars['Int']['output']
  maxImageCount: Scalars['Int']['output']
  maxInlayCount: Scalars['Int']['output']
  maxMediaCount: Scalars['Int']['output']
  maxStickerCount: Scalars['Int']['output']
  maxTextCount: Scalars['Int']['output']
}

export type DesignLineItem = {
  __typename: 'DesignLineItem'
  productType: Scalars['String']['output']
  title: Scalars['String']['output']
  totalPrice: Money
}

export enum DesignMediaKind {
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
}

export type DesignNotDraftError = Error & {
  __typename: 'DesignNotDraftError'
  message: Scalars['String']['output']
}

export type DesignNotFoundError = Error & {
  __typename: 'DesignNotFoundError'
  message: Scalars['String']['output']
}

export enum DesignOrientation {
  LANDSCAPE = 'LANDSCAPE',
  PORTRAIT = 'PORTRAIT',
}

export type DesignOutline = {
  __typename: 'DesignOutline'
  color: Scalars['String']['output']
  width: Scalars['Float']['output']
}

export type DesignOverlay =
  | DesignOverlayAISticker
  | DesignOverlayImage
  | DesignOverlayInlay
  | DesignOverlayMedia
  | DesignOverlaySticker
  | DesignOverlayText

export type DesignOverlayAISticker = DesignOverlayCommon & {
  __typename: 'DesignOverlayAISticker'
  content: DesignOverlayAIStickerContent
  height: Scalars['Float']['output']
  index: Scalars['Int']['output']
  rotation: Scalars['Float']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignOverlayAIStickerContent = {
  __typename: 'DesignOverlayAIStickerContent'
  /** @deprecated Not used, use editedImage.id instead */
  aiStickerId?: Maybe<Scalars['ID']['output']>
  editedImage: DesignImageUploaded
  sourceImage?: Maybe<DesignImageSource>
  /** @deprecated Not used, use editedImage.url instead */
  url?: Maybe<Scalars['String']['output']>
}

export type DesignOverlayAIStickerContentInput = {
  /** @deprecated Provide editedImage.id instead */
  aiStickerId?: InputMaybe<Scalars['ID']['input']>
  editedImage: DesignImageUploadedInput
  sourceImage?: InputMaybe<DesignImageSourceInput>
  /** @deprecated Never used, provide editedImage.id instead */
  url?: InputMaybe<Scalars['String']['input']>
}

export type DesignOverlayAIStickerInput = {
  content: DesignOverlayAIStickerContentInput
  height: Scalars['Float']['input']
  index: Scalars['Int']['input']
  rotation: Scalars['Float']['input']
  width: Scalars['Float']['input']
  x: Scalars['Float']['input']
  y: Scalars['Float']['input']
}

export type DesignOverlayCommon = {
  height: Scalars['Float']['output']
  index: Scalars['Int']['output']
  rotation: Scalars['Float']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignOverlayImage = DesignOverlayCommon & {
  __typename: 'DesignOverlayImage'
  content: DesignOverlayImageContent
  height: Scalars['Float']['output']
  index: Scalars['Int']['output']
  rotation: Scalars['Float']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignOverlayImageContent = {
  __typename: 'DesignOverlayImageContent'
  editedImage: DesignImageUploaded
  fixed?: Maybe<Scalars['Boolean']['output']>
  imageKind?: Maybe<DesignOverlayImageKind>
  mask?: Maybe<DesignOverlayImageContentMask>
  sourceImage?: Maybe<DesignImageSource>
}

export type DesignOverlayImageContentInput = {
  editedImage: DesignImageUploadedInput
  fixed?: InputMaybe<Scalars['Boolean']['input']>
  imageKind?: InputMaybe<DesignOverlayImageKind>
  mask?: InputMaybe<DesignOverlayImageContentMaskInput>
  sourceImage?: InputMaybe<DesignImageSourceInput>
}

export type DesignOverlayImageContentMask = {
  __typename: 'DesignOverlayImageContentMask'
  id: Scalars['ID']['output']
  url: Scalars['String']['output']
}

export type DesignOverlayImageContentMaskInput = {
  id: Scalars['ID']['input']
}

export type DesignOverlayImageInput = {
  content: DesignOverlayImageContentInput
  height: Scalars['Float']['input']
  index: Scalars['Int']['input']
  rotation: Scalars['Float']['input']
  width: Scalars['Float']['input']
  x: Scalars['Float']['input']
  y: Scalars['Float']['input']
}

export enum DesignOverlayImageKind {
  HANDWRITING = 'HANDWRITING',
  PHOTO = 'PHOTO',
}

export type DesignOverlayInlay = DesignOverlayCommon & {
  __typename: 'DesignOverlayInlay'
  content: DesignOverlayInlayContent
  height: Scalars['Float']['output']
  index: Scalars['Int']['output']
  rotation: Scalars['Float']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignOverlayInlayContent = {
  __typename: 'DesignOverlayInlayContent'
  height: Scalars['Float']['output']
  image: RendererInlayImageResult
  inlayId: Scalars['ID']['output']
  scene: InlayScene
  sceneObjects: Array<InlaySceneObject>
  width: Scalars['Float']['output']
}

export type DesignOverlayInlayContentInput = {
  inlayId: Scalars['ID']['input']
}

export type DesignOverlayInlayInput = {
  content: DesignOverlayInlayContentInput
  height: Scalars['Float']['input']
  index: Scalars['Int']['input']
  rotation: Scalars['Float']['input']
  width: Scalars['Float']['input']
  x: Scalars['Float']['input']
  y: Scalars['Float']['input']
}

export type DesignOverlayMedia = DesignOverlayCommon & {
  __typename: 'DesignOverlayMedia'
  content: DesignOverlayMediaContent
  height: Scalars['Float']['output']
  index: Scalars['Int']['output']
  rotation: Scalars['Float']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignOverlayMediaContent = {
  __typename: 'DesignOverlayMediaContent'
  designId: Scalars['ID']['output']
  height: Scalars['Float']['output']
  kind?: Maybe<DesignMediaKind>
  media: MediaResult
  mediaId: Scalars['ID']['output']
  scene: MediaScene
  width: Scalars['Float']['output']
}

export type DesignOverlayMediaContentInput = {
  kind?: InputMaybe<DesignMediaKind>
  mediaToken: Scalars['String']['input']
}

export type DesignOverlayMediaInput = {
  content: DesignOverlayMediaContentInput
  height: Scalars['Float']['input']
  index: Scalars['Int']['input']
  rotation: Scalars['Float']['input']
  width: Scalars['Float']['input']
  x: Scalars['Float']['input']
  y: Scalars['Float']['input']
}

export type DesignOverlaySticker = DesignOverlayCommon & {
  __typename: 'DesignOverlaySticker'
  content: DesignOverlayStickerContent
  height: Scalars['Float']['output']
  index: Scalars['Int']['output']
  rotation: Scalars['Float']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignOverlayStickerContent = {
  __typename: 'DesignOverlayStickerContent'
  stickerId: Scalars['ID']['output']
  urls: StickerUrls
}

export type DesignOverlayStickerContentInput = {
  stickerId: Scalars['ID']['input']
}

export type DesignOverlayStickerInput = {
  content: DesignOverlayStickerContentInput
  height: Scalars['Float']['input']
  index: Scalars['Int']['input']
  rotation: Scalars['Float']['input']
  width: Scalars['Float']['input']
  x: Scalars['Float']['input']
  y: Scalars['Float']['input']
}

export type DesignOverlayText = DesignOverlayCommon & {
  __typename: 'DesignOverlayText'
  content: DesignOverlayTextContent
  height: Scalars['Float']['output']
  index: Scalars['Int']['output']
  rotation: Scalars['Float']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignOverlayTextContent = {
  __typename: 'DesignOverlayTextContent'
  /**
   * Author of the customisation as determined by the client.
   *
   * Currently optional until client consistency is reached.
   */
  author?: Maybe<DesignTextAuthor>
  colorId: Scalars['ID']['output']
  /** The text box is not intended to be moved, rotated, or resized by the user. */
  fixed?: Maybe<Scalars['Boolean']['output']>
  fontFaceId: Scalars['ID']['output']
  fontFaceType?: Maybe<FontFaceType>
  fontSize: Scalars['Float']['output']
  fragments?: Maybe<Array<DesignTextFragment>>
  horizontalAlignment: DesignHorizontalAlignment
  substitutions?: Maybe<Array<Scalars['String']['output']>>
  text: Scalars['String']['output']
  verticalAlignment: DesignVerticalAlignment
}

export type DesignOverlayTextContentInput = {
  /**
   * Author of the customisation as determined by the client.
   *
   * Currently optional until client consistency is reached.
   */
  author?: InputMaybe<DesignTextAuthor>
  colorId: Scalars['ID']['input']
  /** The text box is not intended to be moved, rotated, or resized by the user. */
  fixed?: InputMaybe<Scalars['Boolean']['input']>
  fontFaceId: Scalars['ID']['input']
  fontFaceType?: InputMaybe<FontFaceType>
  fontSize: Scalars['Float']['input']
  fragments?: InputMaybe<Array<DesignTextFragmentInput>>
  horizontalAlignment: DesignHorizontalAlignment
  substitutions?: InputMaybe<Array<Scalars['String']['input']>>
  text: Scalars['String']['input']
  verticalAlignment: DesignVerticalAlignment
}

export type DesignOverlayTextInput = {
  content: DesignOverlayTextContentInput
  height: Scalars['Float']['input']
  index: Scalars['Int']['input']
  rotation: Scalars['Float']['input']
  width: Scalars['Float']['input']
  x: Scalars['Float']['input']
  y: Scalars['Float']['input']
}

export type DesignPlaceholders = PlaceholderSticker

export type DesignPlacement = {
  __typename: 'DesignPlacement'
  height: Scalars['Float']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignPlacements = {
  __typename: 'DesignPlacements'
  handwriting: DesignPlacement
  media: DesignPlacement
}

export type DesignProductNotFoundError = Error & {
  __typename: 'DesignProductNotFoundError'
  message: Scalars['String']['output']
}

export enum DesignRenderMethod {
  LEGACY_1 = 'LEGACY_1',
  LEGACY_2 = 'LEGACY_2',
}

export type DesignResult =
  | Design
  | DesignAuthorizationError
  | DesignNotFoundError
  | DesignServiceError
  | DesignTemplatesServiceError

export type DesignScene = {
  __typename: 'DesignScene'
  availableCustomisations: Array<DesignCustomisationsType>
  customisations: DesignCustomisations
  groupMessages?: Maybe<DesignSceneGroupMessages>
  handwriting?: Maybe<DesignSceneHandwriting>
  height: Scalars['Float']['output']
  id: Scalars['ID']['output']
  imageUpload?: Maybe<DesignSceneImageUpload>
  isCustomised: Scalars['Boolean']['output']
  layoutOriginal?: Maybe<DesignCustomisationsLayout>
  placeholders?: Maybe<Array<DesignPlaceholders>>
  placements: DesignPlacements
  template: DesignTemplate
  title: Scalars['String']['output']
  usedFeatures: Array<EditorFeature>
  width: Scalars['Float']['output']
}

export type DesignSceneGroupMessages = {
  __typename: 'DesignSceneGroupMessages'
  height: Scalars['Float']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignSceneHandwriting = {
  __typename: 'DesignSceneHandwriting'
  height: Scalars['Float']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignSceneImageUpload = {
  __typename: 'DesignSceneImageUpload'
  height: Scalars['Float']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignSceneLayouts = {
  __typename: 'DesignSceneLayouts'
  grids: Array<DesignCollageGrid>
}

export type DesignSceneLayoutsResult = DesignSceneLayouts | DesignServiceError

/** Generic error response from a request to the Design API. */
export type DesignServiceError = Error & {
  __typename: 'DesignServiceError'
  message: Scalars['String']['output']
}

export type DesignSetInlayError = Error & {
  __typename: 'DesignSetInlayError'
  message: Scalars['String']['output']
}

/** Successful SmartText response. */
export type DesignSmartText = {
  __typename: 'DesignSmartText'
  /** Message generated by SmartText engine. */
  text: Scalars['String']['output']
}

/**
 * Smart text config includes information about whether or not the feature is enabled and
 * how many more requests the user can make for the day.
 */
export type DesignSmartTextConfig = {
  __typename: 'DesignSmartTextConfig'
  enabled: Scalars['Boolean']['output']
  /** Maximum length of the user prompt. */
  maxPromptLength: Scalars['Int']['output']
  /** Number of requests remaining at this time. */
  remainingRequests: Scalars['Int']['output']
}

export type DesignSmartTextConfigResult =
  | DesignServiceError
  | DesignSmartTextConfig

export type DesignSmartTextInput = {
  /** Customer provided prompt for the AI engine to use. */
  prompt: Scalars['String']['input']
}

/**
 * Error response returned when the prompt given exceeds the maximum length allowed.
 *
 * Maximum prompt length is defined in DesignSmartTextConfig.maxPromptLength.
 */
export type DesignSmartTextInputError = Error & {
  __typename: 'DesignSmartTextInputError'
  message: Scalars['String']['output']
}

/**
 * Error response returned when client makes too many requests. Requests are limited per user (auth token).
 *
 * Retries may be allowed but are likely to return the same error.
 *
 * Users are restricted to 25 requests in the space of 24 hours as a rolling period.
 */
export type DesignSmartTextLimitReachedError = Error & {
  __typename: 'DesignSmartTextLimitReachedError'
  message: Scalars['String']['output']
}

/**
 * Error response returned when the prompt given for the query fails moderation checking.
 *
 * Subsequent requests with the same prompt should not be made again.
 */
export type DesignSmartTextModerationError = Error & {
  __typename: 'DesignSmartTextModerationError'
  message: Scalars['String']['output']
}

/** SmartText response. */
export type DesignSmartTextResult =
  | DesignServiceError
  | DesignSmartText
  | DesignSmartTextInputError
  | DesignSmartTextLimitReachedError
  | DesignSmartTextModerationError
  | DesignSmartTextUnavailableError

/** This error is returned when the feature has been turned off through terraform variables. */
export type DesignSmartTextUnavailableError = Error & {
  __typename: 'DesignSmartTextUnavailableError'
  message: Scalars['String']['output']
}

export enum DesignStampTheme {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
}

export enum DesignState {
  DRAFT = 'DRAFT',
  IN_BASKET = 'IN_BASKET',
  IN_PROJECT = 'IN_PROJECT',
  ORDERED = 'ORDERED',
}

export type DesignStateError = Error & {
  __typename: 'DesignStateError'
  message: Scalars['String']['output']
}

export type DesignStickerAIConfig = {
  __typename: 'DesignStickerAIConfig'
  enabled: Scalars['Boolean']['output']
  maxPromptLength: Scalars['Int']['output']
  remainingRequests: Scalars['Int']['output']
}

export type DesignStickerAIConfigResult =
  | DesignServiceError
  | DesignStickerAIConfig

export type DesignStickerAIInputError = Error & {
  __typename: 'DesignStickerAIInputError'
  message: Scalars['String']['output']
}

export type DesignStickerAILimitReachedError = Error & {
  __typename: 'DesignStickerAILimitReachedError'
  message: Scalars['String']['output']
}

export type DesignStickerAIModerationError = Error & {
  __typename: 'DesignStickerAIModerationError'
  message: Scalars['String']['output']
}

export type DesignStickerAIUnavailableError = Error & {
  __typename: 'DesignStickerAIUnavailableError'
  message: Scalars['String']['output']
}

export type DesignStickerCopyrightError = Error & {
  __typename: 'DesignStickerCopyrightError'
  message: Scalars['String']['output']
}

export enum DesignStore {
  AU = 'AU',
  IE = 'IE',
  NL = 'NL',
  UK = 'UK',
  US = 'US',
}

export type DesignTemplate = {
  __typename: 'DesignTemplate'
  elements: Array<DesignElement>
  id: Scalars['ID']['output']
  orientation: DesignOrientation
  renderMethod?: Maybe<DesignRenderMethod>
}

export type DesignTemplatesServiceError = Error & {
  __typename: 'DesignTemplatesServiceError'
  message: Scalars['String']['output']
}

/**
 * The author of the overlay text customisation.
 *
 * Clients will determine this and supply to setCustomisations mutations inputs.
 */
export enum DesignTextAuthor {
  /** Customer generated text, no editor tooling used. */
  CUSTOMER = 'CUSTOMER',
  /** Message generated by our new AI message feature without any modification. */
  SMART_TEXT = 'SMART_TEXT',
  /** Message generated by our new AI message but then modified by the customer. */
  SMART_TEXT_MODIFIED = 'SMART_TEXT_MODIFIED',
  /** Starter message used without any modification. */
  STARTER = 'STARTER',
  /** Starter message used but then modified by the customer. */
  STARTER_MODIFIED = 'STARTER_MODIFIED',
}

export type DesignTextEditable = {
  __typename: 'DesignTextEditable'
  allowBlankText: Scalars['Boolean']['output']
  allowDefaultText: Scalars['Boolean']['output']
  /** @deprecated Required for legacy only */
  customNum?: Maybe<Scalars['Int']['output']>
  defaultPreviewText?: Maybe<Scalars['String']['output']>
  defaultText: Scalars['String']['output']
  /** @deprecated Required for legacy only */
  editableNum?: Maybe<Scalars['Int']['output']>
  maxCharacters?: Maybe<Scalars['Int']['output']>
  textTransform?: Maybe<DesignTextTransform>
}

export type DesignTextFragment = {
  __typename: 'DesignTextFragment'
  fontSize: Scalars['Float']['output']
  text: Scalars['String']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignTextFragmentInput = {
  fontSize: Scalars['Float']['input']
  text: Scalars['String']['input']
  x: Scalars['Float']['input']
  y: Scalars['Float']['input']
}

export type DesignTextPart = DesignTextPartEditable | DesignTextPartStatic

export type DesignTextPartEditable = {
  __typename: 'DesignTextPartEditable'
  allowBlankText: Scalars['Boolean']['output']
  allowDefaultText: Scalars['Boolean']['output']
  /** @deprecated Required for legacy only */
  customNum?: Maybe<Scalars['Int']['output']>
  defaultText: Scalars['String']['output']
  /** @deprecated Required for legacy only */
  editableNum?: Maybe<Scalars['Int']['output']>
  maxCharacters?: Maybe<Scalars['Int']['output']>
  textTransform?: Maybe<DesignTextTransform>
}

export type DesignTextPartStatic = {
  __typename: 'DesignTextPartStatic'
  text: Scalars['String']['output']
}

export type DesignTextShadow = {
  __typename: 'DesignTextShadow'
  color: Scalars['String']['output']
  offsetX: Scalars['Float']['output']
  offsetY: Scalars['Float']['output']
}

export enum DesignTextTransform {
  UPPERCASE = 'UPPERCASE',
}

export type DesignTransform = {
  __typename: 'DesignTransform'
  position: DesignTransformPosition
  rotation: Scalars['Float']['output']
  scale: Scalars['Float']['output']
}

export type DesignTransformInput = {
  position: DesignTransformPositionInput
  rotation: Scalars['Float']['input']
  scale: Scalars['Float']['input']
}

export type DesignTransformPosition = {
  __typename: 'DesignTransformPosition'
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignTransformPositionInput = {
  x: Scalars['Float']['input']
  y: Scalars['Float']['input']
}

export type DesignValidationError = Error & {
  __typename: 'DesignValidationError'
  errors: Array<DesignValidationErrorError>
  message: Scalars['String']['output']
}

export type DesignValidationErrorError = DesignElementMissingRequiredError

export enum DesignVerticalAlignment {
  BOTTOM = 'BOTTOM',
  MIDDLE = 'MIDDLE',
  TOP = 'TOP',
}

export type Designs = {
  __typename: 'Designs'
  items: Array<Design>
}

export type DesignsFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>
  /** @deprecated No longer used */
  productKey?: InputMaybe<Scalars['String']['input']>
  /** @deprecated No longer used, will be assumed to be DRAFT */
  state?: InputMaybe<DesignState>
}

export type DesignsResult =
  | DesignServiceError
  | DesignTemplatesServiceError
  | Designs

export type DigitalFormat = {
  __typename: 'DigitalFormat'
  name: Scalars['String']['output']
}

export type DigitalRecipientStage = DeliveryStage & {
  __typename: 'DigitalRecipientStage'
  label: Scalars['String']['output']
  progress: DeliveryPipelineProgressState
  stageNumber: Scalars['Int']['output']
  timestamp?: Maybe<Scalars['Date']['output']>
}

export type Dimensions = {
  __typename: 'Dimensions'
  height: Scalars['Int']['output']
  width: Scalars['Int']['output']
}

export type DiscountedLineItemPrice = {
  __typename: 'DiscountedLineItemPrice'
  discountType?: Maybe<LineItemDiscountType>
  discounted: Money
  original: Money
}

export type DuplicateLineItemInput = {
  id: Scalars['ID']['input']
  lineItemId: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type DuplicateLineItemResult =
  | BasketNotFoundError
  | ConcurrentModificationError
  | LineItemDuplicateRestrictedError
  | LineItemDuplicatedBasketResult
  | LineItemNotFoundError
  | ProductNotFoundError

export type DynamicImage = {
  __typename: 'DynamicImage'
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type DynamicImageFormat = {
  __typename: 'DynamicImageFormat'
  jpeg: Array<DynamicImage>
  webp: Array<DynamicImage>
}

export type DynamicImagesResponse = {
  __typename: 'DynamicImagesResponse'
  intentKey: Scalars['String']['output']
  large: DynamicImageFormat
  medium: DynamicImageFormat
  original: DynamicImageFormat
  small: DynamicImageFormat
}

export type EditorFeature =
  | EditorFeatureAllCharacters
  | EditorFeatureAudio
  | EditorFeatureLayout
  | EditorFeatureOverlayAISticker
  | EditorFeatureOverlayImage
  | EditorFeatureOverlayImageMask
  | EditorFeatureOverlayInlay
  | EditorFeatureOverlaySticker
  | EditorFeatureOverlayText
  | EditorFeatureSceneGroupMessages
  | EditorFeatureSceneHandwriting
  | EditorFeatureSceneImageUpload
  | EditorFeatureTemplateBaseline
  | EditorFeatureTemplateImageCollage
  | EditorFeatureTemplateImageDynamic
  | EditorFeatureVideo

export type EditorFeatureAllCharacters = EditorFeatureCommon & {
  __typename: 'EditorFeatureAllCharacters'
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

export type EditorFeatureAudio = EditorFeatureCommon & {
  __typename: 'EditorFeatureAudio'
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

export type EditorFeatureCommon = {
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

export type EditorFeatureLayout = EditorFeatureCommon & {
  __typename: 'EditorFeatureLayout'
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

export type EditorFeatureOverlayAISticker = EditorFeatureCommon & {
  __typename: 'EditorFeatureOverlayAISticker'
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

export type EditorFeatureOverlayImage = EditorFeatureCommon & {
  __typename: 'EditorFeatureOverlayImage'
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

export type EditorFeatureOverlayImageMask = EditorFeatureCommon & {
  __typename: 'EditorFeatureOverlayImageMask'
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

export type EditorFeatureOverlayInlay = EditorFeatureCommon & {
  __typename: 'EditorFeatureOverlayInlay'
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

export type EditorFeatureOverlaySticker = EditorFeatureCommon & {
  __typename: 'EditorFeatureOverlaySticker'
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

export type EditorFeatureOverlayText = EditorFeatureCommon & {
  __typename: 'EditorFeatureOverlayText'
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

export type EditorFeatureSceneGroupMessages = EditorFeatureCommon & {
  __typename: 'EditorFeatureSceneGroupMessages'
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

export type EditorFeatureSceneHandwriting = EditorFeatureCommon & {
  __typename: 'EditorFeatureSceneHandwriting'
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

export type EditorFeatureSceneImageUpload = EditorFeatureCommon & {
  __typename: 'EditorFeatureSceneImageUpload'
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

export type EditorFeatureTemplateBaseline = EditorFeatureCommon & {
  __typename: 'EditorFeatureTemplateBaseline'
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

export type EditorFeatureTemplateImageCollage = EditorFeatureCommon & {
  __typename: 'EditorFeatureTemplateImageCollage'
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

export type EditorFeatureTemplateImageDynamic = EditorFeatureCommon & {
  __typename: 'EditorFeatureTemplateImageDynamic'
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

export type EditorFeatureVideo = EditorFeatureCommon & {
  __typename: 'EditorFeatureVideo'
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

export type EmailAddress = {
  __typename: 'EmailAddress'
  email: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type Error = {
  message: Scalars['String']['output']
}

export type Errors = {
  messages: Array<Scalars['String']['output']>
}

export type ExpireCreditsInput = {
  authCode: Scalars['String']['input']
  creditId: Scalars['String']['input']
}

export type ExpireCreditsResult = {
  __typename: 'ExpireCreditsResult'
  accounts?: Maybe<Array<Maybe<CreditAccount>>>
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type ExplorationTileList = CategoryListRecommendation & {
  __typename: 'ExplorationTileList'
  description?: Maybe<Scalars['String']['output']>
  items?: Maybe<Array<Maybe<ExplorationTiles>>>
  name: Scalars['String']['output']
}

export type ExplorationTiles = {
  __typename: 'ExplorationTiles'
  altText: Scalars['String']['output']
  id: Scalars['String']['output']
  image: ContentImage
  link: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type Facet = {
  __typename: 'Facet'
  children?: Maybe<Array<Facet>>
  count: Scalars['Int']['output']
  facetKey?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  label?: Maybe<Scalars['String']['output']>
  /** @deprecated Use 'group' instead. */
  name: Scalars['String']['output']
  nbaScore?: Maybe<Scalars['Float']['output']>
  /** @deprecated No longer supported */
  path?: Maybe<Scalars['String']['output']>
  /** @deprecated Use 'facetKey' instead as it is language agnostic */
  value: Scalars['String']['output']
}

export type FacetGroup = {
  __typename: 'FacetGroup'
  department: DepartmentsEnum
  group: Scalars['String']['output']
}

export type FacetInput = {
  facetKey?: InputMaybe<Scalars['String']['input']>
  group?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  path?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['String']['input']>
}

export type FacetKeyWithMetadata = {
  facetKey: Scalars['String']['input']
  source: FilterSource
}

export type Facets = {
  __typename: 'Facets'
  all?: Maybe<Array<Maybe<Facet>>>
  hierarchical?: Maybe<Array<Maybe<Facet>>>
  /** @deprecated Use 'all' collection instead. */
  occasion?: Maybe<Array<Maybe<Facet>>>
  /** @deprecated Use 'all' collection instead. */
  recipient?: Maybe<Array<Maybe<Facet>>>
}

export type Favourites = {
  __typename: 'Favourites'
  list: FavouritesList
}

export type FavouriteslistArgs = {
  listId?: Scalars['ID']['input']
}

export type FavouritesList = {
  __typename: 'FavouritesList'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  products: Array<Maybe<Product>>
}

export type FetchStickerAITaskFailed = {
  __typename: 'FetchStickerAITaskFailed'
  message: Scalars['String']['output']
  taskId: Scalars['String']['output']
}

export type FetchStickerAITaskInput = {
  taskId: Scalars['String']['input']
}

export type FetchStickerAITaskItem = {
  __typename: 'FetchStickerAITaskItem'
  aiStickerId: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type FetchStickerAITaskNotFound = Error & {
  __typename: 'FetchStickerAITaskNotFound'
  message: Scalars['String']['output']
}

export type FetchStickerAITaskPending = {
  __typename: 'FetchStickerAITaskPending'
  message: Scalars['String']['output']
  taskId: Scalars['String']['output']
}

export type FetchStickerAITaskResult =
  | DesignServiceError
  | FetchStickerAITaskFailed
  | FetchStickerAITaskNotFound
  | FetchStickerAITaskPending
  | FetchStickerAITaskSuccess

export type FetchStickerAITaskSuccess = {
  __typename: 'FetchStickerAITaskSuccess'
  items: Array<FetchStickerAITaskItem>
  softError?: Maybe<Scalars['String']['output']>
  taskId: Scalars['String']['output']
}

export type FilterFacet = {
  __typename: 'FilterFacet'
  all?: Maybe<Scalars['Boolean']['output']>
  children?: Maybe<Array<FilterItem>>
  count: Scalars['Int']['output']
  facetKey: Scalars['String']['output']
  group: Scalars['String']['output']
  hasSelectedChildren: Scalars['Boolean']['output']
  id: Scalars['String']['output']
  isAutoApplied?: Maybe<Scalars['Boolean']['output']>
  isQuickFilter?: Maybe<Scalars['Boolean']['output']>
  isSelected: Scalars['Boolean']['output']
  isUserSelected: Scalars['Boolean']['output']
  label: Scalars['String']['output']
  /** @deprecated Unused field */
  layoutKey?: Maybe<Scalars['String']['output']>
  /** @deprecated Use label instead */
  name: Scalars['String']['output']
  nbaScore?: Maybe<Scalars['Float']['output']>
  parentKey: Scalars['String']['output']
  /** @deprecated Use facetKey instead */
  path?: Maybe<Scalars['String']['output']>
  /** @deprecated Unused field */
  promoted?: Maybe<Scalars['Boolean']['output']>
  /** @deprecated Unused field */
  sorting?: Maybe<FilterSorting>
  /** @deprecated Use facetKey instead */
  value: Scalars['String']['output']
}

export type FilterHeader = {
  __typename: 'FilterHeader'
  name: Scalars['String']['output']
}

export type FilterItem =
  | FilterFacet
  | FilterHeader
  | InvertedToggleFilter
  | ToggleFilter

export type FilterResults = {
  __typename: 'FilterResults'
  count: Scalars['Int']['output']
  facets?: Maybe<Array<Maybe<FilterFacet>>>
  facetsWithToggles?: Maybe<Array<Maybe<ApplicableFilter>>>
}

export enum FilterSorting {
  ALPHABETICAL = 'ALPHABETICAL',
  COUNT = 'COUNT',
  GROUP = 'GROUP',
  NONE = 'NONE',
}

export enum FilterSource {
  FILTER = 'FILTER',
  SUGGESTION = 'SUGGESTION',
}

export type FixedQuantity = {
  __typename: 'FixedQuantity'
  required: Scalars['Int']['output']
}

export type Font = {
  __typename: 'Font'
  id: Scalars['ID']['output']
  metrics: DesignFontFaceMetrics
  name: Scalars['String']['output']
  urls: FontUrls
}

export type FontEdge = {
  __typename: 'FontEdge'
  cursor: Scalars['ID']['output']
  node: Font
}

export type FontEdges = {
  __typename: 'FontEdges'
  edges: Array<FontEdge>
  pageInfo: DesignCustomisationPageInfo
  totalCount: Scalars['Int']['output']
}

export enum FontFaceType {
  CUSTOMER_CREATIONS = 'CUSTOMER_CREATIONS',
  TEMPLATE = 'TEMPLATE',
}

export type FontUrls = {
  __typename: 'FontUrls'
  ttf: Scalars['String']['output']
  woff: Scalars['String']['output']
  woff2: Scalars['String']['output']
}

export type FontsFilterInput = {
  fontSetIds: Array<Scalars['ID']['input']>
}

export type FontsResult =
  | DesignInvalidCursorError
  | DesignServiceError
  | FontEdges

export type ForgottenPasswordInput = {
  email: Scalars['String']['input']
  region?: InputMaybe<Region>
}

export type ForgottenPasswordInvalidEmail = Error & {
  __typename: 'ForgottenPasswordInvalidEmail'
  message: Scalars['String']['output']
}

export type ForgottenPasswordInvalidStore = Error & {
  __typename: 'ForgottenPasswordInvalidStore'
  message: Scalars['String']['output']
}

export type ForgottenPasswordResult =
  | ForgottenPasswordInvalidEmail
  | ForgottenPasswordInvalidStore
  | ForgottenPasswordSent

export type ForgottenPasswordSent = {
  __typename: 'ForgottenPasswordSent'
  message: Scalars['String']['output']
}

export type ForwardPage = {
  cursor?: InputMaybe<Scalars['String']['input']>
  first: Scalars['Int']['input']
}

export type FulfilmentCentre = {
  __typename: 'FulfilmentCentre'
  countryCode?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
}

export type GenerateTrackingLinkFailed = Error & {
  __typename: 'GenerateTrackingLinkFailed'
  message: Scalars['String']['output']
}

export type GenerateTrackingLinkInput = {
  deliveryId: Scalars['String']['input']
  orderId: Scalars['ID']['input']
}

export type GenerateTrackingLinkResponse =
  | GenerateTrackingLinkFailed
  | GenerateTrackingLinkSuccess

export type GenerateTrackingLinkSuccess = {
  __typename: 'GenerateTrackingLinkSuccess'
  trackingLink: Scalars['String']['output']
}

export type GetOrCreateDraftDesignInput = {
  /** @deprecated No longer used */
  allowAllCharacters?: InputMaybe<Scalars['Boolean']['input']>
  /**
   * A set of flags to determine what the client can support.
   * Should be used in conjunction with feature flags on each client.
   */
  capabilities?: InputMaybe<Array<DesignCapability>>
  preferFlexibleLayout?: InputMaybe<Scalars['Boolean']['input']>
  /**
   * Should use overlay text on this design when creating a new design.
   * If an existing design is found, the overlay preference is not changed, i.e. if it is false, it will remain false.
   * By using overlay text, templated text elements on the inside scenes of a card will be removed.
   */
  preferOverlayText?: InputMaybe<Scalars['Boolean']['input']>
  /**
   * Similar to `preferOverlayText` but enables overlay elements on the front of the card, removing any existing text elements.
   * There are only a select number of cards which support this. Enabling this for cards which do not support flexible content on the front will have no effect.
   */
  preferOverlayTextFront?: InputMaybe<Scalars['Boolean']['input']>
  productKey: Scalars['String']['input']
  sku?: InputMaybe<Scalars['String']['input']>
  /** @deprecated No longer used */
  variantKey?: InputMaybe<Scalars['String']['input']>
  /** @deprecated No longer used */
  videoCardId?: InputMaybe<Scalars['String']['input']>
}

export type GetOrCreateDraftDesignResult =
  | Design
  | DesignServiceError
  | DesignTemplatesServiceError
  | ProductNotPersonalisableError

export type GetReminderInput = {
  id: Scalars['String']['input']
  store?: InputMaybe<Store>
}

export type GetReminderResult = Reminder | ReminderNotFound

export type GetRemindersInput = {
  endDate?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
  store?: InputMaybe<Store>
  take?: InputMaybe<Scalars['Int']['input']>
}

export type GroupAddMessageResult =
  | GroupCardAuthenticationError
  | GroupCardInputInvalidError
  | GroupCardMessage
  | GroupCardMessagesLimitReachedError
  | GroupCardServiceError

export type GroupAddMessageResultV2 =
  | GroupCardAuthenticatedMessageV2
  | GroupCardAuthenticationError
  | GroupCardInputInvalidError
  | GroupCardMessageV2
  | GroupCardMessagesExceedCapacityError
  | GroupCardMessagesLimitReachedError
  | GroupCardServiceError
  | GroupCardUnavailableError

export type GroupCardAddMessageInput = {
  addMessageToken: Scalars['String']['input']
  authorName: Scalars['String']['input']
  message: Scalars['String']['input']
}

export type GroupCardAddMessageInputV2 = {
  addMessageToken: Scalars['String']['input']
  authorName: Scalars['String']['input']
  /** @deprecated Use font field instead */
  colorId?: InputMaybe<Scalars['Int']['input']>
  font?: InputMaybe<GroupCardFontInput>
  /** @deprecated Use font field instead */
  fontFaceId?: InputMaybe<Scalars['Int']['input']>
  message: Scalars['String']['input']
}

export type GroupCardArchiveProjectInput = {
  projectId: Scalars['ID']['input']
}

export type GroupCardArchiveProjectResult =
  | GroupCardNotFoundError
  | GroupCardServiceError
  | GroupCardSuccess

export type GroupCardAuthenticatedMessageV2 = {
  __typename: 'GroupCardAuthenticatedMessageV2'
  authorName: Scalars['String']['output']
  colorId: Scalars['Int']['output']
  font: GroupCardFont
  fontFaceId: Scalars['Int']['output']
  message: Scalars['String']['output']
  messageId: Scalars['ID']['output']
  productId: Scalars['String']['output']
  projectId: Scalars['ID']['output']
  scenes: Array<GroupCardsScene>
}

export type GroupCardAuthenticatedMessageV2scenesArgs = {
  pages: Scalars['Int']['input']
}

export type GroupCardAuthenticationError = GroupCardError & {
  __typename: 'GroupCardAuthenticationError'
  message: Scalars['String']['output']
}

export type GroupCardConfig = {
  __typename: 'GroupCardConfig'
  authorNameCharacterLimit: Scalars['Int']['output']
  messageCharacterLimit: Scalars['Int']['output']
  projectMessageLimit: Scalars['Int']['output']
  projectNameCharacterLimit: Scalars['Int']['output']
  projectsLimit: Scalars['Int']['output']
}

export type GroupCardConfigV2 = {
  __typename: 'GroupCardConfigV2'
  authorNameCharacterLimit: Scalars['Int']['output']
  messageCharacterLimit: Scalars['Int']['output']
  projectMessageLimit: Scalars['Int']['output']
}

export type GroupCardCreateDesignInput = {
  projectId: Scalars['ID']['input']
}

export type GroupCardCreateDesignResult =
  | GroupCardNotFoundError
  | GroupCardServiceError
  | GroupCardSuccess

export type GroupCardCreateProjectInput = {
  deadlineTime?: InputMaybe<Scalars['String']['input']>
  occasion?: InputMaybe<Occasion>
  productId?: InputMaybe<Scalars['String']['input']>
  productVariantSku?: InputMaybe<Scalars['String']['input']>
  projectName: Scalars['String']['input']
  recipient?: InputMaybe<Scalars['String']['input']>
}

export type GroupCardCreateProjectInputV2 = {
  deadlineTime?: InputMaybe<Scalars['String']['input']>
  occasion?: InputMaybe<Occasion>
  productId: Scalars['String']['input']
  productVariantSku: Scalars['String']['input']
  projectName: Scalars['String']['input']
  recipient: Scalars['String']['input']
}

export type GroupCardCreateProjectResult =
  | GroupCardInputInvalidError
  | GroupCardProject
  | GroupCardProjectsLimitReachedError
  | GroupCardServiceError

export type GroupCardCreateProjectResultV2 =
  | GroupCardInputInvalidError
  | GroupCardProjectV2
  | GroupCardServiceError

export type GroupCardDeleteMessageInput = {
  messageId: Scalars['ID']['input']
  projectId: Scalars['ID']['input']
}

export type GroupCardDeleteProjectInput = {
  projectId: Scalars['ID']['input']
}

export type GroupCardDeleteProjectResult =
  | GroupCardServiceError
  | GroupCardSuccess

export type GroupCardError = {
  message: Scalars['String']['output']
}

export type GroupCardFont = {
  __typename: 'GroupCardFont'
  colorId: Scalars['String']['output']
  fontFaceId: Scalars['String']['output']
}

export type GroupCardFontInput = {
  colorId: Scalars['String']['input']
  fontFaceId: Scalars['String']['input']
}

export type GroupCardInputInvalidError = GroupCardError & {
  __typename: 'GroupCardInputInvalidError'
  message: Scalars['String']['output']
}

export type GroupCardMessage = {
  __typename: 'GroupCardMessage'
  authorName: Scalars['String']['output']
  message: Scalars['String']['output']
  messageId: Scalars['ID']['output']
}

export type GroupCardMessageV2 = {
  __typename: 'GroupCardMessageV2'
  authorName: Scalars['String']['output']
  colorId: Scalars['Int']['output']
  font: GroupCardFont
  fontFaceId: Scalars['Int']['output']
  isOwner: Scalars['Boolean']['output']
  message: Scalars['String']['output']
  messageId: Scalars['ID']['output']
}

export type GroupCardMessagesExceedCapacityError = GroupCardError & {
  __typename: 'GroupCardMessagesExceedCapacityError'
  message: Scalars['String']['output']
}

export type GroupCardMessagesLimitReachedError = GroupCardError & {
  __typename: 'GroupCardMessagesLimitReachedError'
  message: Scalars['String']['output']
}

export type GroupCardNotFoundError = GroupCardError & {
  __typename: 'GroupCardNotFoundError'
  message: Scalars['String']['output']
}

export type GroupCardOccasion = {
  __typename: 'GroupCardOccasion'
  occasion: Occasion
}

export type GroupCardOccasions = {
  __typename: 'GroupCardOccasions'
  occasions: Array<GroupCardOccasion>
}

export type GroupCardOccasionsResult =
  | GroupCardOccasions
  | GroupCardServiceError

export type GroupCardProject = {
  __typename: 'GroupCardProject'
  addMessageToken: Scalars['String']['output']
  addMessageUrl: Scalars['String']['output']
  createdTime: Scalars['String']['output']
  deadlineTime?: Maybe<Scalars['String']['output']>
  imageUrl: Scalars['String']['output']
  messages: Array<GroupCardMessage>
  occasion?: Maybe<Occasion>
  productId?: Maybe<Scalars['String']['output']>
  productVariantSku?: Maybe<Scalars['String']['output']>
  projectId: Scalars['ID']['output']
  projectName: Scalars['String']['output']
  recipient?: Maybe<Scalars['String']['output']>
}

export type GroupCardProjectimageUrlArgs = {
  heightPx: Scalars['Int']['input']
  textColor?: InputMaybe<Scalars['String']['input']>
  widthPx: Scalars['Int']['input']
}

export type GroupCardProjectArchivedState = {
  __typename: 'GroupCardProjectArchivedState'
  projectId: Scalars['ID']['output']
}

export type GroupCardProjectClosedState = {
  __typename: 'GroupCardProjectClosedState'
  message: Scalars['String']['output']
}

export type GroupCardProjectClosedStateV2 = {
  __typename: 'GroupCardProjectClosedStateV2'
  message: Scalars['String']['output']
}

export type GroupCardProjectFullState = {
  __typename: 'GroupCardProjectFullState'
  projectName: Scalars['String']['output']
}

export type GroupCardProjectFullStateV2 = {
  __typename: 'GroupCardProjectFullStateV2'
  projectName: Scalars['String']['output']
}

export type GroupCardProjectOpenAuthenticatedState = {
  __typename: 'GroupCardProjectOpenAuthenticatedState'
  imageUrl: Scalars['String']['output']
  productId?: Maybe<Scalars['String']['output']>
  productVariantSku?: Maybe<Scalars['String']['output']>
  projectId: Scalars['ID']['output']
  projectName: Scalars['String']['output']
}

export type GroupCardProjectOpenAuthenticatedStateimageUrlArgs = {
  heightPx: Scalars['Int']['input']
  textColor?: InputMaybe<Scalars['String']['input']>
  widthPx: Scalars['Int']['input']
}

export type GroupCardProjectOpenAuthenticatedStateV2 = {
  __typename: 'GroupCardProjectOpenAuthenticatedStateV2'
  deadlineTime?: Maybe<Scalars['String']['output']>
  isOwner: Scalars['Boolean']['output']
  myMessage?: Maybe<GroupCardMessageV2>
  occasion?: Maybe<Occasion>
  productId: Scalars['String']['output']
  productVariantSku: Scalars['String']['output']
  projectId: Scalars['ID']['output']
  projectName: Scalars['String']['output']
  recipient: Scalars['String']['output']
  scenes: Array<GroupCardsScene>
}

export type GroupCardProjectOpenAuthenticatedStateV2scenesArgs = {
  pages: Scalars['Int']['input']
}

export type GroupCardProjectOpenState = {
  __typename: 'GroupCardProjectOpenState'
  productId?: Maybe<Scalars['String']['output']>
  productVariantSku?: Maybe<Scalars['String']['output']>
  projectName: Scalars['String']['output']
}

export type GroupCardProjectOpenStateV2 = {
  __typename: 'GroupCardProjectOpenStateV2'
  deadlineTime?: Maybe<Scalars['String']['output']>
  myMessage?: Maybe<GroupCardMessageV2>
  occasion?: Maybe<Occasion>
  productId: Scalars['String']['output']
  productVariantSku: Scalars['String']['output']
  projectId: Scalars['ID']['output']
  projectName: Scalars['String']['output']
  recipient: Scalars['String']['output']
}

export type GroupCardProjectResult =
  | GroupCardNotFoundError
  | GroupCardProject
  | GroupCardServiceError

export type GroupCardProjectResultV2 =
  | GroupCardNotFoundError
  | GroupCardProjectV2
  | GroupCardServiceError

export type GroupCardProjectV2 = {
  __typename: 'GroupCardProjectV2'
  addMessageToken: Scalars['String']['output']
  addMessageUrl: Scalars['String']['output']
  createdTime: Scalars['String']['output']
  deadlineTime?: Maybe<Scalars['String']['output']>
  designId?: Maybe<Scalars['String']['output']>
  messageCount: Scalars['Int']['output']
  messages: Array<GroupCardMessageV2>
  occasion?: Maybe<Occasion>
  productId: Scalars['String']['output']
  productVariantSku: Scalars['String']['output']
  projectId: Scalars['ID']['output']
  projectName: Scalars['String']['output']
  recipient: Scalars['String']['output']
  scenes: Array<GroupCardsScene>
}

export type GroupCardProjectV2scenesArgs = {
  pages: Scalars['Int']['input']
}

export type GroupCardProjects = {
  __typename: 'GroupCardProjects'
  projects: Array<GroupCardProject>
}

export type GroupCardProjectsLimitReachedError = GroupCardError & {
  __typename: 'GroupCardProjectsLimitReachedError'
  message: Scalars['String']['output']
}

export type GroupCardProjectsResult = GroupCardProjects | GroupCardServiceError

export type GroupCardProjectsResultV2 =
  | GroupCardProjectsV2
  | GroupCardServiceError

export type GroupCardProjectsV2 = {
  __typename: 'GroupCardProjectsV2'
  projects: Array<GroupCardProjectV2>
}

export type GroupCardServiceError = GroupCardError & {
  __typename: 'GroupCardServiceError'
  message: Scalars['String']['output']
}

export type GroupCardSuccess = {
  __typename: 'GroupCardSuccess'
  id: Scalars['ID']['output']
}

export type GroupCardTrackCheckoutInput = {
  projectId: Scalars['ID']['input']
}

export type GroupCardTrackCheckoutResult =
  | GroupCardNotFoundError
  | GroupCardServiceError
  | GroupCardSuccess

export type GroupCardTrackSignupEventResult =
  | GroupCardServiceError
  | GroupCardSuccess

export type GroupCardUnavailableError = GroupCardError & {
  __typename: 'GroupCardUnavailableError'
  message: Scalars['String']['output']
}

export type GroupCardUpdateProjectInput = {
  deadlineTime?: InputMaybe<Scalars['String']['input']>
  occasion?: InputMaybe<Occasion>
  productId?: InputMaybe<Scalars['String']['input']>
  productVariantSku?: InputMaybe<Scalars['String']['input']>
  projectId: Scalars['ID']['input']
  projectName: Scalars['String']['input']
  recipient?: InputMaybe<Scalars['String']['input']>
}

export type GroupCardUpdateProjectInputV2 = {
  deadlineTime?: InputMaybe<Scalars['String']['input']>
  occasion?: InputMaybe<Occasion>
  productId: Scalars['String']['input']
  productVariantSku: Scalars['String']['input']
  projectId: Scalars['ID']['input']
  projectName: Scalars['String']['input']
  recipient: Scalars['String']['input']
}

export type GroupCardUpdateProjectResult =
  | GroupCardInputInvalidError
  | GroupCardNotFoundError
  | GroupCardServiceError
  | GroupCardUpdatedProject

export type GroupCardUpdateProjectResultV2 =
  | GroupCardInputInvalidError
  | GroupCardNotFoundError
  | GroupCardProjectV2
  | GroupCardServiceError
  | GroupCardUnavailableError

export type GroupCardUpdateProjectWithDesignInput = {
  designId: Scalars['String']['input']
  projectId: Scalars['ID']['input']
}

export type GroupCardUpdateProjectWithDesignResult =
  | GroupCardServiceError
  | GroupCardSuccess

export type GroupCardUpdatedProject = {
  __typename: 'GroupCardUpdatedProject'
  addMessageToken: Scalars['String']['output']
  createdTime: Scalars['String']['output']
  deadlineTime?: Maybe<Scalars['String']['output']>
  occasion?: Maybe<Occasion>
  productId?: Maybe<Scalars['String']['output']>
  productVariantSku?: Maybe<Scalars['String']['output']>
  projectId: Scalars['ID']['output']
  projectName: Scalars['String']['output']
  recipient?: Maybe<Scalars['String']['output']>
}

export type GroupCardsScene = {
  __typename: 'GroupCardsScene'
  height: Scalars['Float']['output']
  page: Scalars['Int']['output']
  sceneObjects: Array<GroupCardsSceneObject>
  width: Scalars['Float']['output']
}

export type GroupCardsSceneObject = GroupCardsSceneText

export type GroupCardsSceneText = {
  __typename: 'GroupCardsSceneText'
  colorId: Scalars['Int']['output']
  fixedFontSize: Scalars['Float']['output']
  font: GroupCardFont
  fontFaceId: Scalars['Int']['output']
  height: Scalars['Float']['output']
  isOwner: Scalars['Boolean']['output']
  lineHeight: Scalars['Float']['output']
  size: Scalars['Float']['output']
  text: Scalars['String']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type GroupDeleteMessageResult =
  | GroupCardAuthenticationError
  | GroupCardServiceError
  | GroupCardSuccess

export type GroupDeleteMessageResultV2 =
  | GroupCardAuthenticationError
  | GroupCardNotFoundError
  | GroupCardServiceError
  | GroupCardSuccess

export type GroupedFacetInput = {
  group: Scalars['String']['input']
  keys: Array<Scalars['String']['input']>
  keysWithMetadata?: InputMaybe<Array<FacetKeyWithMetadata>>
  userApplied?: InputMaybe<Scalars['Boolean']['input']>
}

export type HeaderLogo = {
  __typename: 'HeaderLogo'
  icon?: Maybe<ContentImage>
}

export type IdentityDetails = {
  __typename: 'IdentityDetails'
  oidc?: Maybe<Array<OidcProvider>>
  password: Scalars['Boolean']['output']
  state?: Maybe<Scalars['String']['output']>
}

export type Image = {
  __typename: 'Image'
  /** @deprecated Please do not use this field. It will be removed in the coming releases */
  dimensions: Dimensions
  url: Scalars['String']['output']
}

export enum ImagePlacement {
  ImageLeft = 'ImageLeft',
  ImageRight = 'ImageRight',
}

export type InfoBanner = {
  __typename: 'InfoBanner'
  text: Scalars['String']['output']
}

export type InfoBlock = {
  __typename: 'InfoBlock'
  image: ContentImage
  text: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type Inlay = {
  id: Scalars['ID']['output']
  scene: InlayScene
  sceneObjects: Array<InlaySceneObject>
}

export type InlayImageUrls = {
  __typename: 'InlayImageUrls'
  editor: Scalars['String']['output']
  preview: Scalars['String']['output']
  print: Scalars['String']['output']
}

export type InlayNotFoundError = Error & {
  __typename: 'InlayNotFoundError'
  message: Scalars['String']['output']
}

export type InlayResult =
  | DemoInlay
  | InlayNotFoundError
  | InlayServiceError
  | VoucherInlay

export type InlayScene = {
  __typename: 'InlayScene'
  height: Scalars['Float']['output']
  id: Scalars['ID']['output']
  image: RendererImageResult
  sceneObjects: Array<RendererSceneObject>
  width: Scalars['Float']['output']
}

export type InlaySceneObject = InlaySceneObjectImage | InlaySceneObjectText

export type InlaySceneObjectCommon = {
  height: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type InlaySceneObjectImage = InlaySceneObjectCommon & {
  __typename: 'InlaySceneObjectImage'
  height: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  urls: InlayImageUrls
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type InlaySceneObjectText = InlaySceneObjectCommon & {
  __typename: 'InlaySceneObjectText'
  fontSize: Scalars['Float']['output']
  height: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  text: Scalars['String']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type InlayServiceError = Error & {
  __typename: 'InlayServiceError'
  message: Scalars['String']['output']
}

export type InputValidationError = Error & {
  __typename: 'InputValidationError'
  message: Scalars['String']['output']
}

export type InspirationItem = ProductInspiration | SearchTermInspiration

export enum Intent {
  MILESTONE = 'MILESTONE',
}

export type IntercomData = {
  __typename: 'IntercomData'
  userDataJwt: Scalars['String']['output']
}

export type InvalidCustomerAddressResult = {
  __typename: 'InvalidCustomerAddressResult'
  address: ShippingAddress
}

export type InvalidDeliveryMethod = {
  __typename: 'InvalidDeliveryMethod'
  description: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type InvalidEmailError = {
  __typename: 'InvalidEmailError'
  emailAddress: Scalars['String']['output']
}

export type InvertedToggleFilter = {
  __typename: 'InvertedToggleFilter'
  facetKey: Scalars['String']['output']
  group: Scalars['String']['output']
  icon?: Maybe<Scalars['String']['output']>
  isAutoApplied?: Maybe<Scalars['Boolean']['output']>
  isQuickFilter?: Maybe<Scalars['Boolean']['output']>
  isSelected: Scalars['Boolean']['output']
  isUserSelected: Scalars['Boolean']['output']
  label: Scalars['String']['output']
  toggleType: ToggleType
}

export type KeyedAddAddressesError = {
  __typename: 'KeyedAddAddressesError'
  key: Scalars['String']['output']
  message: Scalars['String']['output']
}

export type KeyedCustomerAddressErrorMessage = {
  __typename: 'KeyedCustomerAddressErrorMessage'
  key: Scalars['String']['output']
  message: Scalars['String']['output']
}

export type LabelPromo = {
  __typename: 'LabelPromo'
  text: Scalars['String']['output']
}

export type LabelRoundel = {
  __typename: 'LabelRoundel'
  bottom: Scalars['String']['output']
  prefix: Scalars['String']['output']
  top: Scalars['String']['output']
}

export type LabelledOccasion = {
  __typename: 'LabelledOccasion'
  /** @deprecated Labels will be stored in the client */
  label: Scalars['String']['output']
  occasion: Occasion
}

export type LabelledRelationship = {
  __typename: 'LabelledRelationship'
  /** @deprecated Labels will be stored in the client */
  label: Scalars['String']['output']
  relationship: Relationship
}

export type LineItem = Node & {
  __typename: 'LineItem'
  addons: Array<LineItemAddon>
  availability: VariantAvailability
  availableVariants?: Maybe<Array<LineItemVariantOption>>
  canBeDuplicated: Scalars['Boolean']['output']
  /** @deprecated Use the more specific productCoverImage field */
  coverImage?: Maybe<Image>
  customisationId?: Maybe<Scalars['String']['output']>
  /** @deprecated Private field for child resolver */
  deliveryId?: Maybe<Scalars['String']['output']>
  /** @deprecated Private field for child resolver */
  deliveryMethodId?: Maybe<Scalars['String']['output']>
  deliveryType: DeliveryType
  description?: Maybe<Scalars['String']['output']>
  design?: Maybe<Design>
  /** @deprecated Beta feature. Do not use yet. A design is a combination of a template and it's customizations. A designId refers to one of these instances of a design. */
  designId?: Maybe<Scalars['ID']['output']>
  digitalGift?: Maybe<LineItemDigitalGift>
  displayName?: Maybe<Scalars['String']['output']>
  eCardSku?: Maybe<Scalars['String']['output']>
  /** @deprecated Please do not use this field. It should be constructed by clients */
  editUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  packaging?: Maybe<LineItemPackaging>
  price: LineItemPrice
  productCoverImage?: Maybe<Image>
  productId: Scalars['ID']['output']
  productSlug?: Maybe<Scalars['String']['output']>
  productType?: Maybe<Scalars['String']['output']>
  productTypeName: Scalars['String']['output']
  quantity: Scalars['Int']['output']
  quantityOption?: Maybe<QuantityOption>
  recipientAddress?: Maybe<RecipientAddress>
  /** @deprecated Use recipientAddress */
  shippingAddress?: Maybe<ShippingAddress>
  size?: Maybe<Scalars['String']['output']>
  sku?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  totalGrossTaxedPrice?: Maybe<Money>
  totalPrice: Money
  unitPrice: Money
  /** @deprecated Will be removed in upcoming release, use sku instead */
  variantId: Scalars['Int']['output']
  /** @deprecated Use availableVariants */
  variants: Array<LineItemVariant>
}

export type LineItemAddon = {
  __typename: 'LineItemAddon'
  addon: Addon
  id: Scalars['ID']['output']
}

export type LineItemDeliveryRestrictedError = {
  __typename: 'LineItemDeliveryRestrictedError'
  lineItemId: Scalars['String']['output']
  restrictions: Array<Scalars['String']['output']>
}

export type LineItemDigitalGift = {
  __typename: 'LineItemDigitalGift'
  id: Scalars['ID']['output']
  image?: Maybe<Image>
  inStock: Scalars['Boolean']['output']
  price: Money
  productId: Scalars['String']['output']
  sku: Scalars['String']['output']
  title: Scalars['String']['output']
}

export enum LineItemDiscountType {
  PLUS = 'PLUS',
}

export type LineItemDuplicateRestrictedError = Error & {
  __typename: 'LineItemDuplicateRestrictedError'
  message: Scalars['String']['output']
}

export type LineItemDuplicatedBasketResult = {
  __typename: 'LineItemDuplicatedBasketResult'
  basket: Basket
  lineItem: LineItem
}

export type LineItemNotFoundError = Error & {
  __typename: 'LineItemNotFoundError'
  message: Scalars['String']['output']
}

export type LineItemPackaging = {
  __typename: 'LineItemPackaging'
  availablePackaging: Packaging
  id: Scalars['ID']['output']
  selectedPackaging: VariantPackaging
  sku: Scalars['String']['output']
}

export type LineItemPrice = DiscountedLineItemPrice | StandardLineItemPrice

export type LineItemToAddress = {
  addressId: Scalars['String']['input']
  lineItemId: Scalars['ID']['input']
}

export type LineItemVariant = {
  __typename: 'LineItemVariant'
  additionalInfo?: Maybe<Scalars['String']['output']>
  description: Scalars['String']['output']
  price: Money
  priceLabel: Scalars['String']['output']
  sku: Scalars['String']['output']
  /** @deprecated Will be removed in upcoming release, use sku instead */
  variantId: Scalars['Int']['output']
}

export type LineItemVariantOption = {
  __typename: 'LineItemVariantOption'
  isLandscape: Scalars['Boolean']['output']
  priceLabel: Scalars['String']['output']
  productVariant: ProductVariant
}

export type LinkAction = {
  __typename: 'LinkAction'
  shouldFormat?: Maybe<Scalars['Boolean']['output']>
  title?: Maybe<Scalars['String']['output']>
  url: Scalars['String']['output']
}

export type Location = {
  __typename: 'Location'
  city: Scalars['String']['output']
  county: Scalars['String']['output']
  postcode: Scalars['String']['output']
}

export type LookupAddress = {
  __typename: 'LookupAddress'
  addressFirstLine: Scalars['String']['output']
  city?: Maybe<Scalars['String']['output']>
  houseNumber?: Maybe<Scalars['String']['output']>
  houseNumberExtension?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  postcode: Scalars['String']['output']
  state?: Maybe<Scalars['String']['output']>
  streetName?: Maybe<Scalars['String']['output']>
}

export type LookupAddressUk = {
  __typename: 'LookupAddressUk'
  addressLines: Scalars['String']['output']
  county?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  postTown?: Maybe<Scalars['String']['output']>
  postcode: Scalars['String']['output']
}

export type LookupAddressesUkResult = {
  __typename: 'LookupAddressesUkResult'
  addresses: Array<LookupAddressUk>
}

export type MarketingConsentPosition = {
  __typename: 'MarketingConsentPosition'
  position?: Maybe<ConsentPosition>
}

export enum MarketingConsentSource {
  APP = 'APP',
  APPCHECKOUT = 'APPCHECKOUT',
  CUSTOMER_SERVICES = 'CUSTOMER_SERVICES',
  EMAIL_UNSUBSCRIBE = 'EMAIL_UNSUBSCRIBE',
  GROUP_CARDS_SIGN_UP = 'GROUP_CARDS_SIGN_UP',
  LANDING_PAGE = 'LANDING_PAGE',
  MIGRATION = 'MIGRATION',
  MY_ACCOUNT_PAGE = 'MY_ACCOUNT_PAGE',
  REMINDERS_INFLOW_PAGE = 'REMINDERS_INFLOW_PAGE',
  WEBCHECKOUT = 'WEBCHECKOUT',
  WEB_REGISTER = 'WEB_REGISTER',
}

export type Mask = {
  __typename: 'Mask'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  urls: MaskUrls
}

export type MaskEdge = {
  __typename: 'MaskEdge'
  cursor: Scalars['ID']['output']
  node: Mask
}

export type MaskEdges = {
  __typename: 'MaskEdges'
  edges: Array<MaskEdge>
  pageInfo?: Maybe<MaskPageInfo>
  totalCount: Scalars['Int']['output']
}

export type MaskPageInfo = {
  __typename: 'MaskPageInfo'
  endCursor?: Maybe<Scalars['ID']['output']>
  hasNextPage: Scalars['Boolean']['output']
}

export type MaskUrls = {
  __typename: 'MaskUrls'
  editor: Scalars['String']['output']
  editorThumbnail: Scalars['String']['output']
  preview: Scalars['String']['output']
  print: Scalars['String']['output']
}

export type MasksResult =
  | DesignInvalidCursorError
  | DesignServiceError
  | MaskEdges

export type Me = {
  __typename: 'Me'
  addressBook?: Maybe<AddressBook>
  addressRequests?: Maybe<AddressRequests>
  anonymousId?: Maybe<Scalars['ID']['output']>
  basket?: Maybe<Basket>
  business?: Maybe<Business>
  customer?: Maybe<Customer>
  recipients?: Maybe<RecipientsResult>
  segments: Array<CustomerSegment>
}

export type MebasketArgs = {
  store?: InputMaybe<Store>
}

export type MerecipientsArgs = {
  input?: InputMaybe<RecipientsInput>
}

export type Media = {
  __typename: 'Media'
  activated: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  interactive: Scalars['Boolean']['output']
  kind: MediaKind
  scene: MediaScene
  token: Scalars['String']['output']
}

export type MediasceneArgs = {
  height: Scalars['Float']['input']
  width: Scalars['Float']['input']
}

export type MediaConfig = {
  __typename: 'MediaConfig'
  audio: MediaConfigKind
  video: MediaConfigKind
}

export type MediaConfigKind = {
  __typename: 'MediaConfigKind'
  maxDurationSeconds?: Maybe<Scalars['Int']['output']>
  maxSizeBytes: Scalars['Int']['output']
  sceneAspectRatio: Scalars['Float']['output']
  /** List of supported mime types ordered by preference. If available, clients should use the first mime type from this list. */
  supportedMimeTypes: Array<Scalars['String']['output']>
}

export type MediaInvalidTokenError = Error & {
  __typename: 'MediaInvalidTokenError'
  message: Scalars['String']['output']
}

export enum MediaKind {
  Audio = 'Audio',
  Video = 'Video',
}

export type MediaNotFoundError = Error & {
  __typename: 'MediaNotFoundError'
  message: Scalars['String']['output']
}

export type MediaNotReadyError = Error & {
  __typename: 'MediaNotReadyError'
  message: Scalars['String']['output']
}

export type MediaRecipient = {
  __typename: 'MediaRecipient'
  downloadUrl: Scalars['String']['output']
  expiresAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  kind: MediaKind
  url: Scalars['String']['output']
}

export type MediaRecipientResult =
  | MediaNotFoundError
  | MediaNotReadyError
  | MediaRecipient
  | MediaServiceError

export type MediaResult = Media | MediaNotFoundError | MediaServiceError

export type MediaScene = {
  __typename: 'MediaScene'
  height: Scalars['Float']['output']
  id: Scalars['ID']['output']
  image: RendererImageResult
  sceneObjects: Array<RendererSceneObject>
  width: Scalars['Float']['output']
}

export type MediaServiceError = Error & {
  __typename: 'MediaServiceError'
  message: Scalars['String']['output']
}

export type MediaTermsAndConditionsNotAcceptedError = Error & {
  __typename: 'MediaTermsAndConditionsNotAcceptedError'
  message: Scalars['String']['output']
}

export type MediaUpload = {
  __typename: 'MediaUpload'
  fields: Array<MediaUploadField>
  media: Media
  url: Scalars['String']['output']
}

export type MediaUploadField = {
  __typename: 'MediaUploadField'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type MemberPrices = {
  __typename: 'MemberPrices'
  firstPurchase: Money
}

export type Membership = {
  __typename: 'Membership'
  amountPaid?: Maybe<Money>
  customerId: Scalars['ID']['output']
  expiryDate: Scalars['String']['output']
  gracePeriod: Scalars['Boolean']['output']
  label: Scalars['String']['output']
  membershipType: MembershipType
  paymentMethodId?: Maybe<Scalars['String']['output']>
  payments?: Maybe<Array<Maybe<MembershipPayment>>>
  refund: MembershipRefund
  renewalFrequency: RenewalFrequency
  savings?: Maybe<MembershipSavings>
  startDate: Scalars['String']['output']
  status: MembershipStatus
}

export type MembershipFeedback = {
  canContact?: InputMaybe<Scalars['Boolean']['input']>
  questions?: InputMaybe<Array<MembershipFeedbackQuestion>>
}

export type MembershipFeedbackQuestion = {
  answer: Scalars['String']['input']
  question: Scalars['String']['input']
}

export type MembershipLineItem = {
  __typename: 'MembershipLineItem'
  membershipType: MembershipType
  price: Money
  renewalFrequency?: Maybe<RenewalFrequency>
  slug: Scalars['String']['output']
  subtext: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type MembershipOrderItem = {
  __typename: 'MembershipOrderItem'
  membershipType: MembershipType
  price: Money
}

export type MembershipPayment = {
  __typename: 'MembershipPayment'
  date: Scalars['String']['output']
  interactionId?: Maybe<Scalars['String']['output']>
  money: Money
}

export type MembershipRecommendation = {
  __typename: 'MembershipRecommendation'
  price: Money
  title: Scalars['String']['output']
  type: MembershipType
}

export type MembershipRefund = {
  __typename: 'MembershipRefund'
  eligible: Scalars['Boolean']['output']
  interactionId?: Maybe<Scalars['String']['output']>
  money?: Maybe<Money>
}

export type MembershipSavings = {
  __typename: 'MembershipSavings'
  total: Money
}

export enum MembershipStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  GRACE_PERIOD = 'GRACE_PERIOD',
  NON_RECURRING = 'NON_RECURRING',
}

export enum MembershipType {
  MOONPIG_PLUS = 'MOONPIG_PLUS',
  PLUS = 'PLUS',
}

export type MembershipUnavailableError = Error & {
  __typename: 'MembershipUnavailableError'
  message: Scalars['String']['output']
}

export type MembershipVoucherError = Error & {
  __typename: 'MembershipVoucherError'
  message: Scalars['String']['output']
}

export type MissionButton = {
  __typename: 'MissionButton'
  image?: Maybe<ContentImage>
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export enum ModalTarget {
  Gallery = 'Gallery',
  Homepage = 'Homepage',
  Landing = 'Landing',
  Search = 'Search',
}

export type Module =
  | ModuleAlert
  | ModuleBanner
  | ModuleBlogHomepageImage
  | ModuleBlogPostAuthor
  | ModuleBlogPostCategory
  | ModuleBlogPostDate
  | ModuleBlogPostRelatedArticles
  | ModuleBlogPostsCategories
  | ModuleBlogPostsListing
  | ModuleBreadcrumbs
  | ModuleButtons
  | ModuleCTAStrip
  | ModuleCard
  | ModuleDeliveryStrip
  | ModuleDescription
  | ModuleDynamicHero
  | ModuleDynamicMissionButtons
  | ModuleEmailCapture
  | ModuleHeading
  | ModuleHero
  | ModuleIncentivisedReminders
  | ModuleInfo
  | ModuleMissionButtons
  | ModuleModal
  | ModuleOfferStrip
  | ModulePanel
  | ModulePlacards
  | ModulePlaceholder
  | ModulePromoTile
  | ModuleRecommendationsForCustomer
  | ModuleRichText
  | ModuleRichTextImage
  | ModuleSEO
  | ModuleSearchResults
  | ModuleTabbedProductLists
  | ModuleTiles
  | ModuleTwoColumnPlacard
  | ModuleUspCarousel
  | ModuleVideo

export type ModuleAlert = {
  __typename: 'ModuleAlert'
  dismissible: Scalars['Boolean']['output']
  message: Scalars['String']['output']
  severity: ModuleAlertSeverity
  title: Scalars['String']['output']
}

export enum ModuleAlertSeverity {
  Critical = 'Critical',
  Info = 'Info',
  Warning = 'Warning',
}

export type ModuleBanner = {
  __typename: 'ModuleBanner'
  action?: Maybe<Action>
  text: Scalars['String']['output']
  theme: Scalars['String']['output']
}

export type ModuleBlogHomepageImage = {
  __typename: 'ModuleBlogHomepageImage'
  image: ContentImage
}

export type ModuleBlogPostAuthor = {
  __typename: 'ModuleBlogPostAuthor'
  image: ContentImage
  jobTitle: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type ModuleBlogPostCategory = {
  __typename: 'ModuleBlogPostCategory'
  category: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type ModuleBlogPostDate = {
  __typename: 'ModuleBlogPostDate'
  date: Scalars['String']['output']
}

export type ModuleBlogPostRelatedArticles = {
  __typename: 'ModuleBlogPostRelatedArticles'
  items: Array<BlogPostRelatedArticle>
  title: Scalars['String']['output']
}

export type ModuleBlogPostsCategories = {
  __typename: 'ModuleBlogPostsCategories'
  items: Array<ModuleBlogPostCategory>
}

export type ModuleBlogPostsListing = {
  __typename: 'ModuleBlogPostsListing'
  items: Array<BlogPostListItem>
  title: Scalars['String']['output']
}

export type ModuleBreadcrumbs = {
  __typename: 'ModuleBreadcrumbs'
  breadcrumbs: Array<Breadcrumb>
}

export type ModuleButtons = {
  __typename: 'ModuleButtons'
  items: Array<CTA>
}

export type ModuleCTAStrip = ContentModule & {
  __typename: 'ModuleCTAStrip'
  backgroundImage?: Maybe<ContentImage>
  banner: Scalars['Boolean']['output']
  cta: CTA
  meta: ContentMetadata
  text: Scalars['String']['output']
}

export type ModuleCard = {
  __typename: 'ModuleCard'
  ctas?: Maybe<Array<CTA>>
  image: ContentImage
  pills?: Maybe<Array<Scalars['String']['output']>>
  subtitle: Scalars['String']['output']
  text: Scalars['String']['output']
  title: Scalars['String']['output']
  video?: Maybe<ContentVideo>
}

export type ModuleDeliveryStrip = {
  __typename: 'ModuleDeliveryStrip'
  cta?: Maybe<CTA>
  text: Scalars['String']['output']
}

export type ModuleDescription = {
  __typename: 'ModuleDescription'
  description: Scalars['String']['output']
}

export type ModuleDynamicHero = {
  __typename: 'ModuleDynamicHero'
  ctas?: Maybe<Array<CTA>>
  image: ContentImage
  offer: Scalars['Boolean']['output']
  promotionId?: Maybe<Scalars['String']['output']>
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
  variant: ModuleHeroVariant
}

export type ModuleDynamicMissionButtons = ContentModule & {
  __typename: 'ModuleDynamicMissionButtons'
  meta: ContentMetadata
  missionButtons: Array<MissionButton>
  promotionId?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type ModuleEmailCapture = {
  __typename: 'ModuleEmailCapture'
  actionButtonText: Scalars['String']['output']
  display: Scalars['String']['output']
  errorText: Scalars['String']['output']
  heading: Scalars['String']['output']
  image: ContentImage
  inputLabel: Scalars['String']['output']
  inputPlaceholder?: Maybe<Scalars['String']['output']>
  privacyPolicy: LinkAction
  text: Scalars['String']['output']
  thankYouButtonText: Scalars['String']['output']
  thankYouHeading: Scalars['String']['output']
  thankYouText: Scalars['String']['output']
  unsubscribeText: Scalars['String']['output']
}

export type ModuleHeading = {
  __typename: 'ModuleHeading'
  heading: Scalars['String']['output']
  hidden: Scalars['Boolean']['output']
}

export type ModuleHero = {
  __typename: 'ModuleHero'
  ctas?: Maybe<Array<CTA>>
  image: ContentImage
  offer: Scalars['Boolean']['output']
  promotionId?: Maybe<Scalars['String']['output']>
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
  variant: ModuleHeroVariant
}

export enum ModuleHeroVariant {
  FullWidth = 'FullWidth',
  LimitedWidth = 'LimitedWidth',
}

export type ModuleIncentivisedReminders = {
  __typename: 'ModuleIncentivisedReminders'
  endImage: ContentImage
  endText: Scalars['String']['output']
  endTitle: Scalars['String']['output']
  introImage: ContentImage
  introText: Scalars['String']['output']
  introTitle: Scalars['String']['output']
  notificationTitle: Scalars['String']['output']
  numberOfRemindersInOffer: Scalars['Int']['output']
  occasions?: Maybe<Array<ContentReminderOccasion>>
  relations?: Maybe<Array<ContentReminderRelation>>
  title: Scalars['String']['output']
  voucherCode?: Maybe<Scalars['String']['output']>
  voucherDescription: Scalars['String']['output']
}

export type ModuleInfo = {
  __typename: 'ModuleInfo'
  items: Array<InfoBlock>
  title: Scalars['String']['output']
}

export type ModuleMissionButtons = ContentModule & {
  __typename: 'ModuleMissionButtons'
  meta: ContentMetadata
  missionButtons: Array<MissionButton>
  promotionId?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type ModuleModal = {
  __typename: 'ModuleModal'
  /** @deprecated this is legacy and will be removed in the future */
  buttons: Array<CTA>
  /** @deprecated this is legacy and will be removed in the future */
  cookieName: Scalars['String']['output']
  /** @deprecated this is legacy and will be removed in the future */
  dismissalMessage: Scalars['String']['output']
  /** @deprecated this is legacy and will be removed in the future */
  heading: Scalars['String']['output']
  /** @deprecated this is legacy and will be removed in the future */
  platforms: Array<BrowserPlatform>
  /** @deprecated this is legacy and will be removed in the future */
  text: Scalars['String']['output']
}

export type ModuleOfferStrip = {
  __typename: 'ModuleOfferStrip'
  enabled: Scalars['Boolean']['output']
  text: Scalars['String']['output']
}

export type ModulePanel = {
  __typename: 'ModulePanel'
  cta: CTA
  image: ContentImage
  name: Scalars['String']['output']
}

export type ModulePlacards = {
  __typename: 'ModulePlacards'
  items: Array<Placard>
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type ModulePlaceholder = {
  __typename: 'ModulePlaceholder'
  variant: ModulePlaceholderVariant
}

export enum ModulePlaceholderVariant {
  Bundles = 'Bundles',
  ContinueJourney = 'ContinueJourney',
  CookieList = 'CookieList',
  CustomerSatisfaction = 'CustomerSatisfaction',
  Drafts = 'Drafts',
  GroupCardsStarter = 'GroupCardsStarter',
  MostRecentOrder = 'MostRecentOrder',
  RecentlyViewed = 'RecentlyViewed',
  ReminderImport = 'ReminderImport',
  Reminders = 'Reminders',
  Voucher = 'Voucher',
}

export type ModulePromoTile = {
  __typename: 'ModulePromoTile'
  cta: CTA
  description: Scalars['String']['output']
  image: ContentImage
  internallyPromoted: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type ModulePromotionalCard = {
  __typename: 'ModulePromotionalCard'
  description: Scalars['String']['output']
  icon?: Maybe<ContentImage>
  link?: Maybe<CTA>
  title: Scalars['String']['output']
}

export type ModuleRecommendationsForCustomer = {
  __typename: 'ModuleRecommendationsForCustomer'
  algorithm: Scalars['String']['output']
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type ModuleRichText = {
  __typename: 'ModuleRichText'
  blocks: Array<RichTextBlock>
}

export type ModuleRichTextImage = {
  __typename: 'ModuleRichTextImage'
  altText: Scalars['String']['output']
  image: ContentImage
}

export type ModuleSEO = {
  __typename: 'ModuleSEO'
  items: Array<SEOBlock>
}

export type ModuleSearchResults = {
  __typename: 'ModuleSearchResults'
  /** @deprecated no longer supported */
  availableFilters: Array<Scalars['String']['output']>
  departments: Array<Scalars['String']['output']>
  facetDetails: Array<ContentSearchFacetDetails>
  keywords: Scalars['String']['output']
  promotionId?: Maybe<Scalars['String']['output']>
  /** @deprecated use facetDetails and promotionId instead */
  searchFiltersJson: Scalars['String']['output']
  /** @deprecated use keywords instead */
  searchTerm: Scalars['String']['output']
  sponsoredProducts: Array<SponsoredProduct>
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type ModuleTabbedProductLists = {
  __typename: 'ModuleTabbedProductLists'
  productLists: Array<ModuleSearchResults>
  title: Scalars['String']['output']
}

export type ModuleTiles = {
  __typename: 'ModuleTiles'
  items: Array<Tile>
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
  variant: ModuleTilesVariant
}

export enum ModuleTilesVariant {
  Default = 'Default',
  Round = 'Round',
}

export type ModuleTwoColumnPlacard = {
  __typename: 'ModuleTwoColumnPlacard'
  body: Scalars['String']['output']
  cta?: Maybe<CTA>
  image: ContentImage
  imagePlacement: ImagePlacement
  title: Scalars['String']['output']
  variant: ColumnWidthVariant
}

export type ModuleUspCarousel = {
  __typename: 'ModuleUspCarousel'
  items: Array<USP>
}

export type ModuleVideo = {
  __typename: 'ModuleVideo'
  id: Scalars['ID']['output']
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
  titleHidden: Scalars['Boolean']['output']
}

export type Money = {
  __typename: 'Money'
  amount: Scalars['String']['output']
  centAmount: Scalars['Long']['output']
  currencyCode: Scalars['Currency']['output']
  display: Scalars['String']['output']
  fractionDigits: Scalars['Int']['output']
}

export type MoneyInput = {
  centAmount: Scalars['Long']['input']
  currencyCode: Scalars['Currency']['input']
  fractionDigits: Scalars['Int']['input']
}

export type Mutation = {
  __typename: 'Mutation'
  activateRedemption: RedemptionResult
  addAddress?: Maybe<AddAddressResult>
  addAddressRequestAddress: AddAddressRequestAddressResult
  addAddresses?: Maybe<AddAddressesResult>
  addCardAndDigitalGiftToBasket?: Maybe<AddCardAndDigitalGiftResult>
  addCredits?: Maybe<AddCreditsResult>
  addCustomerAddress?: Maybe<AddCustomerAddressResult>
  addCustomerAddresses?: Maybe<AddCustomerAddressesResult>
  addCustomerSelfService?: Maybe<CustomerSelfServiceResponse>
  addDesignToBasket: AddDesignToBasketResult
  addDigitalGiftToBasket?: Maybe<AddDigitalGiftToBasketResult>
  addGiftToBusinessProject: BusinessProjectResponse
  addKeywordToBusinessProject: BusinessProjectResponse
  addMembershipToBasket: AddMembershipToBasketResult
  addToBasket?: Maybe<AddToBasketResult>
  addToBasketAndSplit?: Maybe<AddToBasketAndSplitResult>
  addToFavouritesList: AddToFavouritesList
  amendDeliveryDesign: AmendResult
  applyAutoPromo?: Maybe<ApplyAutoPromoResult>
  applyPromo?: Maybe<ApplyPromoResult>
  assignABTestVariant?: Maybe<AssignABTestVariantResult>
  assignBasketAddress?: Maybe<AssignBasketAddressResult>
  assignBasketVoucher?: Maybe<AssignBasketVoucherResult>
  assignBillingAddress?: Maybe<AssignBillingAddressResult>
  assignDeliveryAddress?: Maybe<AssignDeliveryAddressResult>
  assignDeliveryDate?: Maybe<AssignDeliveryDateResult>
  assignDeliveryGiftNote?: Maybe<AssignDeliveryGiftNoteResult>
  assignDeliveryMethod?: Maybe<AssignDeliveryMethodResult>
  assignDeliveryMethodAndDate?: Maybe<AssignDeliveryMethodAndDateResult>
  assignLineItemAddress?: Maybe<AssignLineItemAddressResult>
  assignLineItemEmailAddress?: Maybe<AssignLineItemEmailAddressResult>
  assignRecipientAddress?: Maybe<AssignRecipientAddressResult>
  cancelMembership: Membership
  checkoutBusinessProject: CheckoutBusinessProjectResponse
  cloneSharedReminder: CloneSharedReminderResult
  createAddressRequest: CreateAddressRequestResult
  createAudioMedia: CreateAudioMediaResult
  /** @deprecated Use createCustomerCreationsCustomFontSubmission */
  createCustomerCreationsCustomFont: CreateCustomerCreationsCustomFontResponse
  createCustomerCreationsCustomFontSubmission: CreateCustomerCreationsCustomFontSubmissionResponse
  createCustomerFeedback: CustomerFeedbackResult
  createDemoMedia: CreateDemoMediaResult
  createDesign: CreateDesignResult
  createDesignImageUpload: CreateDesignImageUploadResult
  createDesignStickerAI: CreateDesignStickerAIResult
  createDraftFromDesign: CreateDraftFromDesignResult
  createInProjectFromDesign: CreateInProjectFromDesignResult
  createIncentivisedReminders: CreateIncentivisedRemindersResult
  createReminder: CreateReminderResult
  createReminderFromDraft: CreateReminderFromDraftResult
  createRemindersAsync: CreateRemindersAsyncResult
  createRemindersFromProducts: CreateRemindersFromProductsResult
  createVideoMedia: CreateVideoMediaResult
  crmDeleteReminders: CrmDeleteReminderResult
  deleteBasket?: Maybe<DeleteBasketResult>
  deleteBusinessProject: DeleteBusinessProjectResponse
  deleteCustomerCreationsCustomFont: CustomerCreationsCustomFontDeleteResponse
  deleteDesignInlay: DeleteDesignInlayResult
  deleteDraftDesign: DeleteDraftDesignResult
  deleteLineItem?: Maybe<DeleteLineItemResult>
  deleteReminder: DeleteReminderResult
  duplicateLineItem?: Maybe<DuplicateLineItemResult>
  expireCredits?: Maybe<ExpireCreditsResult>
  forgottenPassword?: Maybe<ForgottenPasswordResult>
  generateBillingPortalUrl: Scalars['String']['output']
  generateTrackingLink?: Maybe<GenerateTrackingLinkResponse>
  getOrCreateDraftDesign: GetOrCreateDraftDesignResult
  groupCardAddMessage: GroupAddMessageResult
  groupCardAddMessageV2: GroupAddMessageResultV2
  groupCardArchiveProject: GroupCardArchiveProjectResult
  groupCardCreateDesign: GroupCardCreateDesignResult
  groupCardCreateProject: GroupCardCreateProjectResult
  groupCardCreateProjectV2: GroupCardCreateProjectResultV2
  groupCardDeleteMessage: GroupDeleteMessageResult
  groupCardDeleteMessageV2: GroupDeleteMessageResultV2
  groupCardDeleteProject: GroupCardDeleteProjectResult
  groupCardTrackCheckout: GroupCardTrackCheckoutResult
  groupCardTrackSignupEvent: GroupCardTrackSignupEventResult
  groupCardUpdateProject: GroupCardUpdateProjectResult
  groupCardUpdateProjectV2: GroupCardUpdateProjectResultV2
  groupCardUpdateProjectWithDesign: GroupCardUpdateProjectWithDesignResult
  processBusinessRecipientData: ProcessBusinessRecipientDataResult
  reactivateMembership: Membership
  registerEmail: RegisterEmailResult
  removeAddress?: Maybe<RemoveAddressResult>
  removeBasketVoucher?: Maybe<RemoveBasketVoucherResult>
  removeCustomerAddress?: Maybe<RemoveCustomerAddressResult>
  removeFromFavouritesList: RemoveFromFavouritesList
  removeGiftFromBusinessProject: BusinessProjectResponse
  removeKeywordFromBusinessProject: BusinessProjectResponse
  removeMembershipFromBasket: RemoveMembershipFromBasketResult
  removeSavedCard?: Maybe<RemoveSavedCardResult>
  requestOrderCancellation: RequestOrderCancellationResult
  requestResend: RequestResendResult
  revokeMembershipByCustomerId: RevokeMembershipByCustomerIdResponse
  selfValidateAddress: SelfValidateAddressResult
  setBusinessCardCustomisation: BusinessProjectResponse
  setBusinessCardProductAndDesign: BusinessProjectResponse
  setBusinessProjectSource: BusinessProjectResponse
  setBusinessRecipients: BusinessProjectResponse
  setDesignCustomisations: SetDesignCustomisationsResult
  setDesignInlay: SetDesignInlayResult
  shareReminder: ShareReminderResult
  splitLineItemQuantity?: Maybe<SplitLineItemQuantityResult>
  splitMultiQuantityCards?: Maybe<SplitMultiCardsResult>
  trackRecipient?: Maybe<TrackRecipientResult>
  unlinkReminderFromOrder: UnlinkReminderFromOrderResult
  updateAddress?: Maybe<UpdateAddressResult>
  updateAddressPackaging?: Maybe<UpdateAddressPackagingResult>
  updateAddressType?: Maybe<UpdateAddressTypeResult>
  updateContactPreferences?: Maybe<ContactPreferences>
  updateCustomerAddress?: Maybe<UpdateCustomerAddressResult>
  updateCustomerDetails?: Maybe<UpdateCustomerDetailsResult>
  /** @deprecated Exists only for migration from commerce-api. Use updateContactPreferences instead */
  updateCustomerMarketingConsentPosition?: Maybe<UpdateCustomerMarketingConsentPositionResult>
  updateEmail?: Maybe<UpdateEmailResult>
  updateLineItem?: Maybe<UpdateLineItemResult>
  /** @deprecated Replaced by updateLineItem */
  updateLineItemQuantity?: Maybe<UpdateLineItemQuantityResult>
  /** @deprecated Replaced by updateLineItem */
  updateLineItemVariant?: Maybe<UpdateLineItemVariantResult>
  updatePhoneNumber?: Maybe<UpdatePhoneNumberResult>
  updateReminder: UpdateReminderResult
  validateBasket?: Maybe<ValidateBasketResult>
  validateCustomerAddress: ValidateCustomerAddressResult
}

export type MutationactivateRedemptionArgs = {
  input: ActivateRedemptionInput
}

export type MutationaddAddressArgs = {
  input: AddAddressInput
}

export type MutationaddAddressRequestAddressArgs = {
  input: AddAddressRequestAddressInput
}

export type MutationaddAddressesArgs = {
  input: AddAddressesInput
}

export type MutationaddCardAndDigitalGiftToBasketArgs = {
  input: AddCardAndDigitalGiftToBasketInput
}

export type MutationaddCreditsArgs = {
  input: AddCreditsInput
}

export type MutationaddCustomerAddressArgs = {
  input: CustomerAddressInput
}

export type MutationaddCustomerAddressesArgs = {
  input: CustomerAddressesInput
}

export type MutationaddCustomerSelfServiceArgs = {
  input: CustomerSelfServiceInput
}

export type MutationaddDesignToBasketArgs = {
  input: AddDesignToBasketInput
}

export type MutationaddDigitalGiftToBasketArgs = {
  input: AddDigitalGiftToBasketInput
}

export type MutationaddGiftToBusinessProjectArgs = {
  input: BusinessGiftInput
}

export type MutationaddKeywordToBusinessProjectArgs = {
  input: BusinessProjectKeywordInput
}

export type MutationaddMembershipToBasketArgs = {
  input: AddMembershipToBasketInput
}

export type MutationaddToBasketArgs = {
  input: AddToBasketInput
}

export type MutationaddToBasketAndSplitArgs = {
  input: AddToBasketAndSplitInput
}

export type MutationaddToFavouritesListArgs = {
  listId?: Scalars['ID']['input']
  productIds: Array<Scalars['String']['input']>
}

export type MutationamendDeliveryDesignArgs = {
  input: DesignAmendmentInput
}

export type MutationapplyAutoPromoArgs = {
  input: ApplyAutoPromoInput
}

export type MutationapplyPromoArgs = {
  input: ApplyPromoInput
}

export type MutationassignABTestVariantArgs = {
  input: AssignABTestVariantInput
}

export type MutationassignBasketAddressArgs = {
  input: AssignBasketAddressInput
}

export type MutationassignBasketVoucherArgs = {
  input: AssignBasketVoucherInput
}

export type MutationassignBillingAddressArgs = {
  addressId: Scalars['String']['input']
}

export type MutationassignDeliveryAddressArgs = {
  input: AssignDeliveryAddressInput
}

export type MutationassignDeliveryDateArgs = {
  input: AssignDeliveryDateInput
}

export type MutationassignDeliveryGiftNoteArgs = {
  input: AssignDeliveryGiftNoteInput
}

export type MutationassignDeliveryMethodArgs = {
  input: AssignDeliveryMethodInput
}

export type MutationassignDeliveryMethodAndDateArgs = {
  input: AssignDeliveryMethodAndDateInput
}

export type MutationassignLineItemAddressArgs = {
  input: AssignLineItemAddressInput
}

export type MutationassignLineItemEmailAddressArgs = {
  input: AssignLineItemEmailAddressInput
}

export type MutationassignRecipientAddressArgs = {
  input: AssignRecipientAddressInput
}

export type MutationcancelMembershipArgs = {
  feedback?: InputMaybe<MembershipFeedback>
}

export type MutationcloneSharedReminderArgs = {
  sharedReminder: Scalars['String']['input']
}

export type MutationcreateAddressRequestArgs = {
  input: CreateAddressRequestInput
}

export type MutationcreateAudioMediaArgs = {
  input: CreateAudioMediaInput
}

export type MutationcreateCustomerCreationsCustomFontSubmissionArgs = {
  assetId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationcreateCustomerFeedbackArgs = {
  input: CustomerFeedbackInput
}

export type MutationcreateDemoMediaArgs = {
  input: CreateDemoMediaInput
}

export type MutationcreateDesignArgs = {
  input: CreateDesignInput
}

export type MutationcreateDesignImageUploadArgs = {
  input: CreateDesignImageUploadInput
}

export type MutationcreateDesignStickerAIArgs = {
  input: CreateDesignStickerAIInput
}

export type MutationcreateDraftFromDesignArgs = {
  input: CreateDraftFromDesignInput
}

export type MutationcreateInProjectFromDesignArgs = {
  input: CreateInProjectFromDesignInput
}

export type MutationcreateIncentivisedRemindersArgs = {
  input: Array<ReminderInput>
}

export type MutationcreateReminderArgs = {
  input: ReminderInput
}

export type MutationcreateReminderFromDraftArgs = {
  input: CreateReminderFromDraftInput
}

export type MutationcreateRemindersAsyncArgs = {
  input: Array<ReminderInput>
}

export type MutationcreateRemindersFromProductsArgs = {
  input: RemindersFromProductsInput
}

export type MutationcreateVideoMediaArgs = {
  input: CreateVideoMediaInput
}

export type MutationcrmDeleteRemindersArgs = {
  input: CrmDeleteRemindersInput
}

export type MutationdeleteBasketArgs = {
  input?: InputMaybe<DeleteBasketInput>
}

export type MutationdeleteCustomerCreationsCustomFontArgs = {
  assetId: Scalars['String']['input']
}

export type MutationdeleteDesignInlayArgs = {
  input: DeleteDesignInlayInput
}

export type MutationdeleteDraftDesignArgs = {
  input: DeleteDraftDesignInput
}

export type MutationdeleteLineItemArgs = {
  input: DeleteLineItemInput
}

export type MutationdeleteReminderArgs = {
  id: Scalars['ID']['input']
  store?: InputMaybe<Store>
}

export type MutationduplicateLineItemArgs = {
  input: DuplicateLineItemInput
}

export type MutationexpireCreditsArgs = {
  input: ExpireCreditsInput
}

export type MutationforgottenPasswordArgs = {
  input: ForgottenPasswordInput
}

export type MutationgenerateTrackingLinkArgs = {
  input: GenerateTrackingLinkInput
}

export type MutationgetOrCreateDraftDesignArgs = {
  input: GetOrCreateDraftDesignInput
}

export type MutationgroupCardAddMessageArgs = {
  input: GroupCardAddMessageInput
}

export type MutationgroupCardAddMessageV2Args = {
  input: GroupCardAddMessageInputV2
}

export type MutationgroupCardArchiveProjectArgs = {
  input: GroupCardArchiveProjectInput
}

export type MutationgroupCardCreateDesignArgs = {
  input: GroupCardCreateDesignInput
}

export type MutationgroupCardCreateProjectArgs = {
  input: GroupCardCreateProjectInput
}

export type MutationgroupCardCreateProjectV2Args = {
  input: GroupCardCreateProjectInputV2
}

export type MutationgroupCardDeleteMessageArgs = {
  input: GroupCardDeleteMessageInput
}

export type MutationgroupCardDeleteMessageV2Args = {
  input: GroupCardDeleteMessageInput
}

export type MutationgroupCardDeleteProjectArgs = {
  input: GroupCardDeleteProjectInput
}

export type MutationgroupCardTrackCheckoutArgs = {
  input: GroupCardTrackCheckoutInput
}

export type MutationgroupCardUpdateProjectArgs = {
  input: GroupCardUpdateProjectInput
}

export type MutationgroupCardUpdateProjectV2Args = {
  input: GroupCardUpdateProjectInputV2
}

export type MutationgroupCardUpdateProjectWithDesignArgs = {
  input: GroupCardUpdateProjectWithDesignInput
}

export type MutationprocessBusinessRecipientDataArgs = {
  input: ProcessBusinessRecipientDataInput
}

export type MutationregisterEmailArgs = {
  input: RegisterEmailInput
}

export type MutationremoveAddressArgs = {
  input: RemoveAddressInput
}

export type MutationremoveBasketVoucherArgs = {
  input: RemoveBasketVoucherInput
}

export type MutationremoveCustomerAddressArgs = {
  input: CustomerDeleteAddressInput
}

export type MutationremoveFromFavouritesListArgs = {
  listId?: Scalars['ID']['input']
  productIds: Array<Scalars['String']['input']>
}

export type MutationremoveKeywordFromBusinessProjectArgs = {
  input: BusinessProjectKeywordInput
}

export type MutationremoveMembershipFromBasketArgs = {
  input: RemoveMembershipFromBasketInput
}

export type MutationremoveSavedCardArgs = {
  input: RemoveSavedCardInput
}

export type MutationrequestOrderCancellationArgs = {
  input: RequestOrderCancellationInput
}

export type MutationrequestResendArgs = {
  input: RequestResendInput
}

export type MutationrevokeMembershipByCustomerIdArgs = {
  customerId: Scalars['String']['input']
}

export type MutationselfValidateAddressArgs = {
  input: SelfValidateAddressInput
}

export type MutationsetBusinessCardCustomisationArgs = {
  input: BusinessCardCustomisationInput
}

export type MutationsetBusinessCardProductAndDesignArgs = {
  input: BusinessCardProductAndDesignInput
}

export type MutationsetBusinessProjectSourceArgs = {
  input: SetBusinessProjectSourceInput
}

export type MutationsetBusinessRecipientsArgs = {
  input: SetBusinessRecipientsInput
}

export type MutationsetDesignCustomisationsArgs = {
  input: SetDesignCustomisationsInput
}

export type MutationsetDesignInlayArgs = {
  input: SetDesignInlayInput
}

export type MutationshareReminderArgs = {
  input: ShareReminderInput
}

export type MutationsplitLineItemQuantityArgs = {
  input: SplitLineItemQuantityInput
}

export type MutationsplitMultiQuantityCardsArgs = {
  input: SplitMultiCardsInput
}

export type MutationtrackRecipientArgs = {
  input: TrackRecipientInput
}

export type MutationunlinkReminderFromOrderArgs = {
  orderId: Scalars['ID']['input']
  reminderId: Scalars['ID']['input']
}

export type MutationupdateAddressArgs = {
  input: UpdateAddressInput
}

export type MutationupdateAddressPackagingArgs = {
  input: UpdateAddressPackagingInput
}

export type MutationupdateAddressTypeArgs = {
  input: UpdateAddressTypeInput
}

export type MutationupdateContactPreferencesArgs = {
  input: UpdateContactPreferencesInput
}

export type MutationupdateCustomerAddressArgs = {
  input: CustomerUpdateAddressInput
}

export type MutationupdateCustomerDetailsArgs = {
  input: UpdateCustomerDetailsInput
}

export type MutationupdateCustomerMarketingConsentPositionArgs = {
  input: UpdateCustomerMarketingConsentPositionInput
}

export type MutationupdateEmailArgs = {
  newEmail: Scalars['String']['input']
}

export type MutationupdateLineItemArgs = {
  input: UpdateLineItemInput
}

export type MutationupdateLineItemQuantityArgs = {
  input: UpdateLineItemQuantityInput
}

export type MutationupdateLineItemVariantArgs = {
  input: UpdateLineItemVariantInput
}

export type MutationupdatePhoneNumberArgs = {
  input: PhoneNumberInput
}

export type MutationupdateReminderArgs = {
  id: Scalars['ID']['input']
  input: UpdateReminderInput
}

export type MutationvalidateBasketArgs = {
  input: ValidateBasketInput
}

export type MutationvalidateCustomerAddressArgs = {
  input: ValidateCustomerAddressInput
}

export type NationalOccasionDateResult = {
  __typename: 'NationalOccasionDateResult'
  day: Scalars['Int']['output']
  month: Scalars['Int']['output']
  nextDate: Scalars['String']['output']
  occasion: Occasion
}

export type Navigation = {
  __typename: 'Navigation'
  items: Array<NavigationItem>
}

export enum NavigationCapability {
  CARD_FINDER = 'CARD_FINDER',
  COLLAGE_CARD = 'COLLAGE_CARD',
  DIGITAL_GIFTS = 'DIGITAL_GIFTS',
  MOONPIG_PLUS = 'MOONPIG_PLUS',
}

export type NavigationItem = {
  __typename: 'NavigationItem'
  icon: Scalars['String']['output']
  image?: Maybe<ContentImage>
  items: Array<NavigationItem>
  label?: Maybe<Scalars['String']['output']>
  requiredCapabilities?: Maybe<Array<NavigationCapability>>
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type NoLineItemsExistForDeliveryIdError = Error & {
  __typename: 'NoLineItemsExistForDeliveryIdError'
  message: Scalars['String']['output']
}

export type Node = {
  id: Scalars['ID']['output']
}

export enum Occasion {
  ANNIVERSARY = 'ANNIVERSARY',
  BIRTHDAY = 'BIRTHDAY',
  BON_VOYAGE = 'BON_VOYAGE',
  CHINESE_NEW_YEAR = 'CHINESE_NEW_YEAR',
  CHRISTENINGS = 'CHRISTENINGS',
  CHRISTMAS = 'CHRISTMAS',
  CONFIRMATION = 'CONFIRMATION',
  CONGRATULATIONS = 'CONGRATULATIONS',
  DIWALI = 'DIWALI',
  DRIVING_TEST = 'DRIVING_TEST',
  EASTER = 'EASTER',
  EID = 'EID',
  ENGAGEMENT = 'ENGAGEMENT',
  EXAMS = 'EXAMS',
  FATHERS_DAY = 'FATHERS_DAY',
  GET_WELL = 'GET_WELL',
  GOOD_LUCK = 'GOOD_LUCK',
  GRADUATION = 'GRADUATION',
  HALLOWEEN = 'HALLOWEEN',
  HOLY_COMMUNION = 'HOLY_COMMUNION',
  IN_REMEMBRANCE = 'IN_REMEMBRANCE',
  JEWISH_CELEBRATIONS = 'JEWISH_CELEBRATIONS',
  JUST_A_NOTE = 'JUST_A_NOTE',
  LEAVING = 'LEAVING',
  LOVE = 'LOVE',
  MOTHERS_DAY = 'MOTHERS_DAY',
  NEW_BABY = 'NEW_BABY',
  NEW_HOME = 'NEW_HOME',
  NEW_JOB = 'NEW_JOB',
  NEW_SCHOOL = 'NEW_SCHOOL',
  NEW_YEAR = 'NEW_YEAR',
  PREGNANCY = 'PREGNANCY',
  RETIREMENT = 'RETIREMENT',
  SAINTS_DAYS = 'SAINTS_DAYS',
  SAINT_NICHOLAS = 'SAINT_NICHOLAS',
  SORRY = 'SORRY',
  SPECIAL_OCCASION = 'SPECIAL_OCCASION',
  SYMPATHY = 'SYMPATHY',
  THANKSGIVING = 'THANKSGIVING',
  THANK_YOU = 'THANK_YOU',
  THINKING_OF_YOU = 'THINKING_OF_YOU',
  VALENTINES_DAY = 'VALENTINES_DAY',
  WEDDING = 'WEDDING',
}

export type OccasionDate = {
  __typename: 'OccasionDate'
  day: Scalars['Int']['output']
  month: Scalars['Int']['output']
}

export type OccasionDateInput = {
  day: Scalars['Int']['input']
  month: Scalars['Int']['input']
}

export type OidcProvider = {
  __typename: 'OidcProvider'
  id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type OpenGraph = {
  __typename: 'OpenGraph'
  description: Scalars['String']['output']
  image: ContentImage
  locale: Scalars['String']['output']
  siteName: Scalars['String']['output']
  title: Scalars['String']['output']
  type?: Maybe<Scalars['String']['output']>
  url: Scalars['String']['output']
}

export type Order = Node &
  Versioned & {
    __typename: 'Order'
    appliedDiscount?: Maybe<AppliedDiscount>
    client?: Maybe<Scalars['String']['output']>
    /** Payments: Total of all customerCredit payments on the order */
    creditsUsed: Money
    customerEmail?: Maybe<Scalars['String']['output']>
    customerId: Scalars['ID']['output']
    id: Scalars['ID']['output']
    membershipOrderItem?: Maybe<MembershipOrderItem>
    orderDate: Scalars['Date']['output']
    orderDeliveries: Array<OrderDelivery>
    /** @deprecated Will be removed in upcoming release, use orderItems on orderDeliveries */
    orderItems: Array<OrderItem>
    orderNumber?: Maybe<Scalars['String']['output']>
    orderRegion: Scalars['String']['output']
    payments: Array<Maybe<Payment>>
    /** Total: Shipping price for the order */
    postagePrice: Money
    selfServe: SelfServe
    /** @deprecated Will be removed in upcoming release, use shippingAddress on orderDeliveries */
    shippingAddress: ShippingAddress
    showSupportButton: Scalars['Boolean']['output']
    /** @deprecated Use orderRegion instead */
    store: Store
    /** Total: total of order (itemprice + shipping + tax) w/o (discount) */
    subTotalIncTax: Money
    /** Total: total of order (itemprice + tax + discount) w/o (shipping) */
    subTotalPrice: Money
    supportOptions: SupportOptions
    /** Total: discount applied to the order */
    totalDiscount?: Maybe<Money>
    /** Total: price of all items in the order */
    totalItemPrice: Money
    totalItems: Scalars['Int']['output']
    /** Payments: Total of all non-customerCredit payments on the order */
    totalPaid: Money
    /** Total: total of order (itemprice + shipping + tax) */
    totalPrice: Money
    /** Total: total of order (itemprice + shipping) w/o (tax) */
    totalPriceGross: Money
    /** Total: Shipping price for the order */
    totalShippingPrice: Money
    /** Total: total of order w/o tax */
    totalTaxExclusive?: Maybe<Money>
    version: Scalars['Long']['output']
  }

export type OrderAddon = {
  __typename: 'OrderAddon'
  coverImage?: Maybe<Image>
  id: Scalars['ID']['output']
  sku: Scalars['String']['output']
  title: Scalars['String']['output']
  totalPrice: Money
  unitPrice: Money
}

export type OrderCancellationError = {
  __typename: 'OrderCancellationError'
  errorDetails: Scalars['String']['output']
  orderId: Scalars['ID']['output']
}

export type OrderCancellationSummary = {
  __typename: 'OrderCancellationSummary'
  customerId: Scalars['ID']['output']
  deliveries?: Maybe<Array<Scalars['String']['output']>>
  orderId: Scalars['ID']['output']
}

export type OrderData = {
  date: Scalars['Date']['input']
  id: Scalars['ID']['input']
}

export type OrderDate = {
  __typename: 'OrderDate'
  timestamp: Scalars['Date']['output']
}

export type OrderDelivery = {
  __typename: 'OrderDelivery'
  actualDispatchDate?: Maybe<Scalars['Date']['output']>
  /** @deprecated Use recipientAddress */
  address: ShippingAddress
  deliveryDate: Scalars['Date']['output']
  deliveryInformation?: Maybe<OrderDeliveryInformation>
  deliveryStatus: DeliveryStatus
  estimatedDispatchDate?: Maybe<Scalars['Date']['output']>
  id: Scalars['ID']['output']
  instructions?: Maybe<Scalars['String']['output']>
  isShareable: Scalars['Boolean']['output']
  mobile?: Maybe<Scalars['String']['output']>
  orderItems: Array<OrderItem>
  recipientAddress: RecipientAddress
  serviceTarget: DeliveryServiceTarget
  shippingPrice: Money
  /** @deprecated Use deliveryStatus */
  status: OrderStatus
  supportOptions: SupportOptions
}

export type OrderDeliveryInformation = {
  __typename: 'OrderDeliveryInformation'
  courierDetails: CourierDetails
  deliveryMethodId?: Maybe<Scalars['String']['output']>
  deliveryMethodName?: Maybe<Scalars['String']['output']>
  fulfilmentCentre?: Maybe<FulfilmentCentre>
  fullTrackingUrl?: Maybe<Scalars['String']['output']>
  isTracked: Scalars['Boolean']['output']
  /** @deprecated Will be removed in upcoming release, for Id use deliveryMethodId, for human readable version use deliveryMethodName */
  postageType?: Maybe<PostageType>
  trackingNumber?: Maybe<Scalars['String']['output']>
  /** @deprecated Use `fullTrackingUrl`. */
  trackingUrl?: Maybe<Scalars['String']['output']>
}

export type OrderDeliveryInformationcourierDetailsArgs = {
  excludeFromDisplay?: InputMaybe<Array<Courier>>
}

export type OrderDigitalGift = {
  __typename: 'OrderDigitalGift'
  coverImage?: Maybe<Image>
  id: Scalars['ID']['output']
  sku: Scalars['String']['output']
  title: Scalars['String']['output']
  totalPrice: Money
  unitPrice: Money
}

export type OrderItem = Node & {
  __typename: 'OrderItem'
  addons: Array<Maybe<OrderAddon>>
  /** @deprecated Use 'previewImages' instead. */
  coverImage?: Maybe<Image>
  design?: Maybe<Design>
  digitalGift?: Maybe<OrderDigitalGift>
  id: Scalars['ID']['output']
  packaging?: Maybe<OrderPackaging>
  previewImages: Array<Maybe<Image>>
  productKey?: Maybe<Scalars['String']['output']>
  productSlug?: Maybe<Scalars['String']['output']>
  productType?: Maybe<Scalars['String']['output']>
  quantity: Scalars['Int']['output']
  size?: Maybe<Scalars['String']['output']>
  sku?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  totalDiscount?: Maybe<Money>
  totalPrice: Money
  unitPrice: Money
}

export type OrderPackaging = {
  __typename: 'OrderPackaging'
  coverImage?: Maybe<Image>
  id: Scalars['ID']['output']
  sku: Scalars['String']['output']
  title: Scalars['String']['output']
  totalPrice: Money
  unitPrice: Money
}

export type OrderRecipientData = {
  productIds: Array<Scalars['String']['input']>
  recipientName: Scalars['String']['input']
}

export enum OrderStatus {
  CANCELLED = 'CANCELLED',
  ON_HOLD = 'ON_HOLD',
  PRINTING = 'PRINTING',
  RECEIVED = 'RECEIVED',
  SENT = 'SENT',
}

export type Orders = {
  __typename: 'Orders'
  items: Array<Order>
  totalCount: Scalars['Long']['output']
}

export type OrdersByDeliveryPostcodeInput = {
  deliveryPostcode: Scalars['String']['input']
  limit?: InputMaybe<Scalars['Long']['input']>
  offset?: InputMaybe<Scalars['Long']['input']>
}

export type OrdersByOrderIdInput = {
  limit?: InputMaybe<Scalars['Long']['input']>
  offset?: InputMaybe<Scalars['Long']['input']>
  orderId: Scalars['ID']['input']
}

export type OrdersByOrderReferenceInput = {
  limit?: InputMaybe<Scalars['Long']['input']>
  offset?: InputMaybe<Scalars['Long']['input']>
  orderReference: Scalars['String']['input']
}

export type Packaging = {
  __typename: 'Packaging'
  defaultSku: Scalars['String']['output']
  title: Scalars['String']['output']
  variants: Array<VariantPackaging>
}

export type Page = {
  __typename: 'Page'
  canonicalSubPath: Scalars['String']['output']
  /** @deprecated canonicalUrl is deprecated. Use canonicalSubPath instead */
  canonicalUrl: Scalars['String']['output']
  description: Scalars['String']['output']
  layout: PageLayout
  modules: Array<Module>
  noIndex: Scalars['Boolean']['output']
  openGraph: OpenGraph
  path: Scalars['String']['output']
  structuredData: Array<StructuredData>
  title: Scalars['String']['output']
}

export type PageInfo = {
  __typename: 'PageInfo'
  endCursor?: Maybe<Scalars['String']['output']>
  hasNextPage: Scalars['Boolean']['output']
  hasPreviousPage: Scalars['Boolean']['output']
  startCursor?: Maybe<Scalars['String']['output']>
}

export enum PageLayout {
  AppHomepage = 'AppHomepage',
  BlogCategoryPage = 'BlogCategoryPage',
  BlogHomepage = 'BlogHomepage',
  BlogPost = 'BlogPost',
  Gallery = 'Gallery',
  Homepage = 'Homepage',
  Info = 'Info',
  Landing = 'Landing',
}

export type PageResult = Page | Redirect

export type Payment = {
  __typename: 'Payment'
  amountPlanned: Money
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  paymentMethodInfo?: Maybe<PaymentMethodInfo>
  transactions: Array<Maybe<Transaction>>
  version: Scalars['Int']['output']
}

export type PaymentMethodInfo = {
  __typename: 'PaymentMethodInfo'
  method?: Maybe<Scalars['String']['output']>
  paymentInterface: Scalars['String']['output']
}

export type PaymentProvider = {
  __typename: 'PaymentProvider'
  name: Scalars['String']['output']
}

export type PeakService = {
  __typename: 'PeakService'
  deliveryDate: Scalars['Date']['output']
}

export enum PersonalisationFlow {
  CAN_PERSONALISE = 'CAN_PERSONALISE',
  MUST_PERSONALISE = 'MUST_PERSONALISE',
  NONE = 'NONE',
}

export type PhoneNumberInput = {
  phoneNumber: Scalars['String']['input']
  source: Scalars['String']['input']
}

export type PhysicalDeliveryCompleteStage = DeliveryStage & {
  __typename: 'PhysicalDeliveryCompleteStage'
  label: Scalars['String']['output']
  progress: DeliveryPipelineProgressState
  stageNumber: Scalars['Int']['output']
  timestamp?: Maybe<Scalars['Date']['output']>
}

export type PhysicalDeliveryOverviewStage = DeliveryStage & {
  __typename: 'PhysicalDeliveryOverviewStage'
  label: Scalars['String']['output']
  progress: DeliveryPipelineProgressState
  stageNumber: Scalars['Int']['output']
  timestamp?: Maybe<Scalars['Date']['output']>
}

export type PhysicalFormat = {
  __typename: 'PhysicalFormat'
  name: Scalars['String']['output']
}

export type Placard = {
  __typename: 'Placard'
  cta: CTA
  image: ContentImage
  title: Scalars['String']['output']
}

export type PlaceholderSticker = {
  __typename: 'PlaceholderSticker'
  height: Scalars['Float']['output']
  image: PlaceholderStickerImage
  rotation?: Maybe<Scalars['Float']['output']>
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type PlaceholderStickerImage = {
  __typename: 'PlaceholderStickerImage'
  url: Scalars['String']['output']
}

export enum Platform {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  MOBILE_WEB = 'MOBILE_WEB',
  UNSPECIFIED = 'UNSPECIFIED',
  WEB = 'WEB',
}

export enum PostageType {
  AIR_MAIL_AUSTRAILIA_TO_NEW_ZEALAND = 'AIR_MAIL_AUSTRAILIA_TO_NEW_ZEALAND',
  AIR_MAIL_EUROPE = 'AIR_MAIL_EUROPE',
  AIR_MAIL_OUTSIDE_EUROPE = 'AIR_MAIL_OUTSIDE_EUROPE',
  AUSTRALIAN_EXPRESS_POST_NEXT_DAY_DELIVERY = 'AUSTRALIAN_EXPRESS_POST_NEXT_DAY_DELIVERY',
  AUSTRALIAN_POST = 'AUSTRALIAN_POST',
  DPD_COURIER = 'DPD_COURIER',
  DX_COURIER = 'DX_COURIER',
  EMAIL = 'EMAIL',
  EXPRESS_2ND_DAY = 'EXPRESS_2ND_DAY',
  EXPRESS_OVERNIGHT = 'EXPRESS_OVERNIGHT',
  EXPRESS_POST = 'EXPRESS_POST',
  FEDEX_SATURDAY = 'FEDEX_SATURDAY',
  FEDEX_STANDARD = 'FEDEX_STANDARD',
  FIRST_CLASS = 'FIRST_CLASS',
  FIRST_CLASS_VIA_USPS = 'FIRST_CLASS_VIA_USPS',
  FIRST_CLASS__ORDER_BY_7PM = 'FIRST_CLASS__ORDER_BY_7PM',
  FREE_DELIVERY = 'FREE_DELIVERY',
  INTERLINK = 'INTERLINK',
  MOTHERS_DAY_DELIVERY = 'MOTHERS_DAY_DELIVERY',
  NONE = 'NONE',
  PRINT_SITE_DELIVERY = 'PRINT_SITE_DELIVERY',
  PRINT_SITE_SATURDAY_DELIVERY = 'PRINT_SITE_SATURDAY_DELIVERY',
  RM_TRACKED = 'RM_TRACKED',
  SATURDAY_COURIER = 'SATURDAY_COURIER',
  SECOND_CLASS = 'SECOND_CLASS',
  SPECIAL_DELIVERY = 'SPECIAL_DELIVERY',
  SPECIAL_DELIVERY_SATURDAY = 'SPECIAL_DELIVERY_SATURDAY',
  STANDARD = 'STANDARD',
  STANDARD_COURIER = 'STANDARD_COURIER',
  STANDARD_COURIER_NEXT_BUSINESS_DAY = 'STANDARD_COURIER_NEXT_BUSINESS_DAY',
  STANDARD_PRIORITY = 'STANDARD_PRIORITY',
  TELEGRAM = 'TELEGRAM',
  UK_MAIL = 'UK_MAIL',
  US_POSTAL_SERVICE_STANDARD_DELIVERY = 'US_POSTAL_SERVICE_STANDARD_DELIVERY',
  VALENTINES_DAY_DELIVERY = 'VALENTINES_DAY_DELIVERY',
  YODEL_COURIER = 'YODEL_COURIER',
  YODEL_STANDARD_DELIVERY = 'YODEL_STANDARD_DELIVERY',
}

export type PostcodeLookupError = Error & {
  __typename: 'PostcodeLookupError'
  message: Scalars['String']['output']
}

export type PostcodeLookupResult = LookupAddressesUkResult | PostcodeLookupError

export type PreviewImage = {
  __typename: 'PreviewImage'
  height: Scalars['Int']['output']
  title: Scalars['String']['output']
  url: Scalars['String']['output']
  width: Scalars['Int']['output']
}

export type PreviewImages = {
  __typename: 'PreviewImages'
  images: Array<PreviewImage>
}

export type PreviewImagesResult = PreviewImages | RendererServiceError

export type ProcessBusinessRecipientDataInput = {
  header: Scalars['String']['input']
  rows: Array<Scalars['String']['input']>
}

export type ProcessBusinessRecipientDataResult = {
  __typename: 'ProcessBusinessRecipientDataResult'
  recipients: Array<ProcessBusinessRecipientDataResultRecipient>
  successRatePercentage: Scalars['Long']['output']
}

export type ProcessBusinessRecipientDataResultRecipient = {
  __typename: 'ProcessBusinessRecipientDataResultRecipient'
  addressLine1: Scalars['String']['output']
  city: Scalars['String']['output']
  deliveryDate?: Maybe<Scalars['String']['output']>
  firstName: Scalars['String']['output']
  id: Scalars['String']['output']
  lastName: Scalars['String']['output']
  postcode: Scalars['String']['output']
}

export type Product = {
  __typename: 'Product'
  appliedIntents?: Maybe<Array<AppliedIntent>>
  category: ProductCategory
  clickRankDocumentCount: Scalars['Int']['output']
  customisable: Scalars['Boolean']['output']
  dependencies: Array<Maybe<Dependencies>>
  description: Scalars['String']['output']
  dynamicImages?: Maybe<DynamicImagesResponse>
  editableTextFieldCount: Scalars['Int']['output']
  facets: Array<ProductFacet>
  hasAugmentedReality: Scalars['Boolean']['output']
  hasCollageMaker: Scalars['Boolean']['output']
  id: Scalars['String']['output']
  isFavourited?: Maybe<Scalars['Boolean']['output']>
  isHighFatSaltSugar: Scalars['Boolean']['output']
  isLandscape: Scalars['Boolean']['output']
  isSponsored: Scalars['Boolean']['output']
  masterVariant: ProductVariant
  personalisation: ProductPersonalisationResult
  photoUploadCount: Scalars['Int']['output']
  primaryProductPill?: Maybe<ProductPill>
  productPills: Array<ProductPill>
  publishDate?: Maybe<Scalars['DateTime']['output']>
  rating?: Maybe<ProductRating>
  recommendations: Recommendations
  relatedTerms?: Maybe<RelatedTerms>
  slug: Scalars['String']['output']
  title: Scalars['String']['output']
  variants: Array<ProductVariant>
  voucherOptions?: Maybe<VoucherOptions>
}

export type ProductdynamicImagesArgs = {
  appliedIntents?: InputMaybe<Array<AppliedIntentInput>>
}

export type ProductrecommendationsArgs = {
  algorithmId?: InputMaybe<Scalars['String']['input']>
  facets?: InputMaybe<RecommendationFacets>
}

export type ProductCategory = {
  __typename: 'ProductCategory'
  department: DepartmentsEnum
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  parentDepartment: DepartmentsEnum
  slug: Scalars['String']['output']
}

export type ProductFacet = {
  __typename: 'ProductFacet'
  facetKey?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  /** @deprecated Use 'group' instead. */
  name: Scalars['String']['output']
  /** @deprecated No longer supported */
  path?: Maybe<Scalars['String']['output']>
  /** @deprecated Use 'facetKey' instead as it is language agnostic */
  value: Scalars['String']['output']
}

export type ProductImage = {
  __typename: 'ProductImage'
  extraLarge: SizedImage
  large: SizedImage
  medium: SizedImage
  original: SizedImage
  small: SizedImage
  thumb: SizedImage
}

export type ProductImages = {
  __typename: 'ProductImages'
  images: Array<ProductImage>
  mainImage: ProductImage
}

export type ProductInspiration = {
  __typename: 'ProductInspiration'
  department: DepartmentsEnum
  productSku: Scalars['String']['output']
}

export type ProductList = CategoryListRecommendation & {
  __typename: 'ProductList'
  description?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  products: Array<Maybe<Product>>
}

export type ProductLookupResults = {
  __typename: 'ProductLookupResults'
  count: Scalars['Int']['output']
  products: Array<Product>
}

export type ProductNotFoundError = Error & {
  __typename: 'ProductNotFoundError'
  message: Scalars['String']['output']
}

export type ProductNotPersonalisableError = Error & {
  __typename: 'ProductNotPersonalisableError'
  message: Scalars['String']['output']
}

export type ProductPage = {
  __typename: 'ProductPage'
  department: Scalars['ID']['output']
  modules: Array<ProductPageModule>
}

export type ProductPageInput = {
  parentDepartmentID: Scalars['String']['input']
  preview?: InputMaybe<Scalars['Boolean']['input']>
  subDepartmentID: Scalars['String']['input']
}

export type ProductPageModule = ModulePromotionalCard | ModuleUspCarousel

export type ProductPersonalisation = {
  __typename: 'ProductPersonalisation'
  requiresEditing: Scalars['Boolean']['output']
}

export type ProductPersonalisationResult =
  | DesignServiceError
  | ProductNotPersonalisableError
  | ProductPersonalisation

export type ProductPill = {
  __typename: 'ProductPill'
  displayLabel: Scalars['String']['output']
  displayVariant: ProductPillType
}

export enum ProductPillType {
  ECO = 'ECO',
  MARKETING = 'MARKETING',
  PLUS = 'PLUS',
  PRICE = 'PRICE',
  UNIQUE_SELLING_POINT = 'UNIQUE_SELLING_POINT',
}

export type ProductRating = {
  __typename: 'ProductRating'
  count: Scalars['Int']['output']
  score: Scalars['Float']['output']
}

export type ProductSearchResults = {
  __typename: 'ProductSearchResults'
  appliedIntents: Array<AppliedIntent>
  count: Scalars['Int']['output']
  departmentCounts: Array<AlternativeSearchDepartmentCount>
  products: Array<Product>
  redirectedDepartment?: Maybe<DepartmentsEnum>
  spellingCorrection?: Maybe<SpellingCorrection>
  suggestions: Array<Product>
  supportedSortOrders: Array<SortOrderDescriptor>
  totalClickRankDocumentCount: Scalars['Int']['output']
}

export type ProductVariant = {
  __typename: 'ProductVariant'
  addons?: Maybe<Array<Addon>>
  availablePackaging?: Maybe<Packaging>
  bundles: Array<ProductVariantBundle>
  capabilities?: Maybe<Capabilities>
  content?: Maybe<ProductVariantContentResult>
  dimensions?: Maybe<ProductVariantDimensions>
  discountedPercentage?: Maybe<Scalars['Float']['output']>
  flows: ProductVariantFlow
  format: ProductVariantFormat
  fullPrice: Money
  /** @deprecated Use new productImages fields */
  images: Array<Image>
  inStock: Scalars['Boolean']['output']
  key: Scalars['String']['output']
  locations?: Maybe<Array<Location>>
  /** @deprecated Use new productImages fields */
  masterImage: Image
  memberPrices?: Maybe<MemberPrices>
  /** @deprecated Use 'quantity' instead. */
  minimumQuantity: Scalars['Int']['output']
  price: Money
  productImages: ProductImages
  quantityOption?: Maybe<QuantityOption>
  sizeId: Scalars['Int']['output']
  sku?: Maybe<Scalars['String']['output']>
  subtitle?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type ProductVariantaddonsArgs = {
  clientUsesDescription?: InputMaybe<Scalars['Boolean']['input']>
}

export type ProductVariantBundle = {
  __typename: 'ProductVariantBundle'
  description: Scalars['String']['output']
  discountPercentage: Scalars['Float']['output']
  fullPrice: Money
  price: Money
  size: Scalars['Int']['output']
}

export type ProductVariantContent = {
  __typename: 'ProductVariantContent'
  modules: Array<ProductVariantContentModule>
}

export type ProductVariantContentModule = ProductVariantContentModuleDetails

export type ProductVariantContentModuleDetails = {
  __typename: 'ProductVariantContentModuleDetails'
  items: Array<ProductVariantContentModuleDetailsItem>
}

export type ProductVariantContentModuleDetailsItem = {
  __typename: 'ProductVariantContentModuleDetailsItem'
  key: Scalars['String']['output']
  title: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type ProductVariantContentNotFoundError = Error & {
  __typename: 'ProductVariantContentNotFoundError'
  message: Scalars['String']['output']
}

export type ProductVariantContentResult =
  | ProductVariantContent
  | ProductVariantContentNotFoundError

export type ProductVariantDimensions = {
  __typename: 'ProductVariantDimensions'
  description: Scalars['String']['output']
  height: Scalars['Int']['output']
  width: Scalars['Int']['output']
}

export type ProductVariantFlow = {
  __typename: 'ProductVariantFlow'
  addToBasket: AddToBasketFlow
  personalisation: PersonalisationFlow
}

export type ProductVariantFormat = DigitalFormat | PhysicalFormat

export type PromoValidation = BasketValidation & {
  __typename: 'PromoValidation'
  isBlocking: Scalars['Boolean']['output']
  message: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type QuantityOption = FixedQuantity | RangeQuantity

export type Query = {
  __typename: 'Query'
  addressLookup: AddressLookupResult
  addressRequest: AddressRequestResult
  addressSchemas: AddressSchemasResult
  addressesSchemaIsOk: Scalars['Boolean']['output']
  announcement?: Maybe<Announcement>
  appBanner?: Maybe<AppBanner>
  autocompleteAddress: AutocompleteAddressResult
  basketSchemaIsOk: Scalars['Boolean']['output']
  businessAvailableSubstitutions: Array<BusinessAvailableSubstitution>
  businessProductVariant?: Maybe<BusinessProductVariantResponse>
  businessSchemaIsOk: Scalars['Boolean']['output']
  colors: ColorsResult
  contactPreferencesSchemaIsOk: Scalars['Boolean']['output']
  content: Content
  contentDepartments: Array<ContentDepartment>
  contentSchemaIsOk: Scalars['Boolean']['output']
  countries: Array<Country>
  customFontSubmission: CustomerCreationsCustomFontSubmissionResponse
  customFonts: CustomerCreationsCustomFontResponse
  customerCreationsSchemaIsOk: Scalars['Boolean']['output']
  customerSatisfactionSchemaIsOk: Scalars['Boolean']['output']
  customerSchemaIsOk: Scalars['Boolean']['output']
  defaultPackaging?: Maybe<DefaultPackagingResult>
  design: DesignResult
  designCollageGrids: DesignCollageGridsResult
  designDefault: DesignResult
  designImageConfig: DesignImageConfig
  designIsValid: DesignIsValidResult
  designSceneLayouts: DesignSceneLayoutsResult
  designSchemaIsOk: Scalars['Boolean']['output']
  /** Request a SmartText message to be used in a design. */
  designSmartText: DesignSmartTextResult
  /** Returns either the smart text config or design service error indicating something has gone wrong. */
  designSmartTextConfig: DesignSmartTextConfigResult
  /** Returns a list of stickers or an error indicating something went wrong. */
  designStickerAIConfig: DesignStickerAIConfigResult
  designs: DesignsResult
  dynamicImages: Array<Product>
  dynamicImagesSchemaIsOk: Scalars['Boolean']['output']
  favouritesSchemaIsOk: Scalars['Boolean']['output']
  /** Fetch a Sticker AI task. */
  fetchStickerAITask: FetchStickerAITaskResult
  filters: FilterResults
  fonts: FontsResult
  getBasketById?: Maybe<Basket>
  getBusinessDeliveryOptions: BusinessDeliveryOptions
  groupCardAddMessageState: AddMessageStateResult
  groupCardAddMessageStateV2: AddMessageStateResultV2
  groupCardConfig: GroupCardConfig
  groupCardConfigV2: GroupCardConfigV2
  groupCardOccasions: GroupCardOccasionsResult
  groupCardTestCustomer: Customer
  groupCardsSchemaIsOk: Scalars['Boolean']['output']
  infoBanner?: Maybe<InfoBanner>
  inlay: InlayResult
  inlaysSchemaIsOk: Scalars['Boolean']['output']
  masks: MasksResult
  me: Me
  media: MediaResult
  mediaConfig: MediaConfig
  mediaRecipient: MediaRecipientResult
  mediaSchemaIsOk: Scalars['Boolean']['output']
  membershipsSchemaIsOk?: Maybe<Scalars['Boolean']['output']>
  nationalOccasionDates: Array<NationalOccasionDateResult>
  navigation: Navigation
  nextUnfulfilledReminder?: Maybe<Reminder>
  ordersByDeliveryPostcode?: Maybe<Orders>
  ordersByOrderId?: Maybe<Orders>
  ordersByOrderReference?: Maybe<Orders>
  ordersSchemaIsOk: Scalars['Boolean']['output']
  page?: Maybe<PageResult>
  paymentsSchemaIsOk: Scalars['Boolean']['output']
  postcodeLookup: PostcodeLookupResult
  productAddon?: Maybe<Addon>
  productAddons?: Maybe<Array<Addon>>
  productLookup: ProductLookupResults
  productSearch: ProductSearchResults
  productsLookupSchemaIsOk: Scalars['Boolean']['output']
  productsSchemaIsOk: Scalars['Boolean']['output']
  purchaseIsForReminder: Scalars['Boolean']['output']
  recipientsSchemaIsOk: Scalars['Boolean']['output']
  recommendations: Array<Recommendation>
  recommendationsBySearchCriteria: Array<Product>
  recommendationsSchemaIsOk: Scalars['Boolean']['output']
  redemption: RedemptionResult
  redemptionSchemaIsOk: Scalars['Boolean']['output']
  reminder: GetReminderResult
  reminderOccasions: Array<ReminderOccasion>
  reminderRelationships: Array<ReminderRelationship>
  reminders: Array<Reminder>
  remindersSchemaIsOk: Scalars['Boolean']['output']
  /** @deprecated This feature has been decomissioned and will now always return an error result */
  rendererDynamicImage: RendererDynamicImageResult
  rendererSchemaIsOk: Scalars['Boolean']['output']
  rendererShareableImages: RendererShareableImagesResult
  searchInspirations: SearchInspirationsResults
  searchSchemaIsOk: Scalars['Boolean']['output']
  searchSuggest: SearchSuggestResults
  segmentationSchemaIsOk: Scalars['Boolean']['output']
  sharedReminder: SharedReminderResult
  stickers: StickersResult
  suggestQuickAdds: Array<SuggestedReminder>
  suggestReminders: Array<SuggestedReminder>
  suggestedMessages: Array<SuggestedMessage>
  suggestions: Suggestions
  suggestionsSchemaIsOk: Scalars['Boolean']['output']
  trackingInformation?: Maybe<TrackingInformationResult>
}

export type QueryaddressLookupArgs = {
  input: AddressLookupInput
}

export type QueryaddressRequestArgs = {
  id: Scalars['String']['input']
}

export type QueryannouncementArgs = {
  name: Scalars['String']['input']
  preview?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryappBannerArgs = {
  preview?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryautocompleteAddressArgs = {
  input: AutocompleteAddressInput
}

export type QuerybusinessProductVariantArgs = {
  input: BusinessProductVariantInput
}

export type QuerycolorsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  filter: ColorsFilterInput
  first?: InputMaybe<Scalars['Int']['input']>
}

export type QuerycontentDepartmentsArgs = {
  filter?: InputMaybe<Array<Scalars['ID']['input']>>
  platform?: InputMaybe<ContentPlatform>
  preview?: InputMaybe<Scalars['Boolean']['input']>
  region?: InputMaybe<Region>
}

export type QuerycustomFontSubmissionArgs = {
  submissionId: Scalars['ID']['input']
}

export type QuerydefaultPackagingArgs = {
  input?: InputMaybe<DefaultPackagingInput>
}

export type QuerydesignArgs = {
  filter?: InputMaybe<DesignFilterInput>
  id: Scalars['ID']['input']
}

export type QuerydesignDefaultArgs = {
  capabilities?: InputMaybe<Array<DesignCapability>>
  filter?: InputMaybe<DesignFilterInput>
  intents?: InputMaybe<Array<DesignIntent>>
  productKey: Scalars['String']['input']
}

export type QuerydesignIsValidArgs = {
  input: DesignIsValidInput
}

export type QuerydesignSmartTextArgs = {
  input: DesignSmartTextInput
}

export type QuerydesignsArgs = {
  filter?: InputMaybe<DesignsFilterInput>
}

export type QuerydynamicImagesArgs = {
  appliedIntents: Array<AppliedIntentInput>
  productIds: Array<Scalars['String']['input']>
}

export type QueryfetchStickerAITaskArgs = {
  input: FetchStickerAITaskInput
}

export type QueryfiltersArgs = {
  department?: InputMaybe<Array<InputMaybe<DepartmentsEnum>>>
  experimentValues?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<CriteriaInput>
  isInitialQuery?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  nbaAlgorithm?: InputMaybe<Scalars['String']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  store?: InputMaybe<StoresEnumType>
  useImprovedRecall?: InputMaybe<Scalars['Boolean']['input']>
  useStemming?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryfontsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  filter: FontsFilterInput
  first?: InputMaybe<Scalars['Int']['input']>
}

export type QuerygetBasketByIdArgs = {
  id: Scalars['ID']['input']
}

export type QuerygroupCardAddMessageStateArgs = {
  addMessageToken: Scalars['String']['input']
}

export type QuerygroupCardAddMessageStateV2Args = {
  addMessageToken: Scalars['String']['input']
}

export type QueryinfoBannerArgs = {
  preview?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryinlayArgs = {
  height: Scalars['Float']['input']
  id: Scalars['ID']['input']
  width: Scalars['Float']['input']
}

export type QuerymasksArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
}

export type QuerymediaArgs = {
  activated?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['ID']['input']
  interactive?: InputMaybe<Scalars['Boolean']['input']>
}

export type QuerymediaRecipientArgs = {
  key: Scalars['String']['input']
}

export type QuerynavigationArgs = {
  capabilities?: InputMaybe<Array<NavigationCapability>>
  name: Scalars['String']['input']
  preview?: InputMaybe<Scalars['Boolean']['input']>
  region?: InputMaybe<Region>
}

export type QuerynextUnfulfilledReminderArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>
}

export type QueryordersByDeliveryPostcodeArgs = {
  input: OrdersByDeliveryPostcodeInput
}

export type QueryordersByOrderIdArgs = {
  input: OrdersByOrderIdInput
}

export type QueryordersByOrderReferenceArgs = {
  input: OrdersByOrderReferenceInput
}

export type QuerypageArgs = {
  path: Scalars['String']['input']
  platform?: InputMaybe<ContentPlatform>
  preview?: InputMaybe<Scalars['Boolean']['input']>
  variations?: InputMaybe<Array<ContentVariationInput>>
}

export type QuerypostcodeLookupArgs = {
  postcode: Scalars['String']['input']
}

export type QueryproductAddonArgs = {
  addonSku: Scalars['String']['input']
}

export type QueryproductAddonsArgs = {
  sku: Scalars['String']['input']
}

export type QueryproductLookupArgs = {
  experimentValues?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<CriteriaInput>
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  store?: InputMaybe<StoresEnumType>
}

export type QueryproductSearchArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>
  department?: InputMaybe<Array<InputMaybe<DepartmentsEnum>>>
  departmentId?: InputMaybe<Scalars['Int']['input']>
  experimentValues?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<CriteriaInput>
  isInitialQuery?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  nbaAlgorithm?: InputMaybe<Scalars['String']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  platform?: InputMaybe<Platform>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  skipSpellingCorrection?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Sorts>
  sortOrder?: InputMaybe<SortOrder>
  sponsoredProducts?: InputMaybe<Array<SponsoredProductInput>>
  store?: InputMaybe<StoresEnumType>
  useImprovedRecall?: InputMaybe<Scalars['Boolean']['input']>
  useStemming?: InputMaybe<Scalars['Boolean']['input']>
}

export type QuerypurchaseIsForReminderArgs = {
  name: Scalars['String']['input']
  occasion: Occasion
}

export type QueryrecommendationsArgs = {
  algorithmId?: InputMaybe<Scalars['String']['input']>
  productId: Scalars['String']['input']
}

export type QueryrecommendationsBySearchCriteriaArgs = {
  facetKeys: Array<Scalars['String']['input']>
  first?: Scalars['Int']['input']
  searchTerm: Scalars['String']['input']
}

export type QueryredemptionArgs = {
  input: RedemptionInput
}

export type QueryreminderArgs = {
  input: GetReminderInput
}

export type QueryremindersArgs = {
  input: GetRemindersInput
}

export type QueryrendererDynamicImageArgs = {
  elementHeight: Scalars['Int']['input']
  elementWidth: Scalars['Int']['input']
  format: RendererDynamicImageFormat
  id: Scalars['ID']['input']
  textParts: Array<Scalars['String']['input']>
}

export type QueryrendererShareableImagesArgs = {
  key: Scalars['String']['input']
}

export type QuerysearchSuggestArgs = {
  experimentValues?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  searchTerm: Scalars['String']['input']
  suggesterType?: InputMaybe<SuggesterType>
}

export type QuerysharedReminderArgs = {
  payload: Scalars['String']['input']
}

export type QuerystickersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  filter: StickersFilterInput
  first?: InputMaybe<Scalars['Int']['input']>
}

export type QuerysuggestRemindersArgs = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type QuerytrackingInformationArgs = {
  input: TrackingInformationInput
}

export type RangeQuantity = {
  __typename: 'RangeQuantity'
  maximum: Scalars['Int']['output']
  minimum: Scalars['Int']['output']
}

export type Recipient = {
  __typename: 'Recipient'
  firstName?: Maybe<Scalars['String']['output']>
  fullName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  lastName?: Maybe<Scalars['String']['output']>
}

export type RecipientAddress = EmailAddress | ShippingAddress

export type RecipientConnection = {
  __typename: 'RecipientConnection'
  edges: Array<RecipientEdge>
  pageInfo: PageInfo
  totalCount: Scalars['Int']['output']
}

export type RecipientEdge = {
  __typename: 'RecipientEdge'
  cursor: Scalars['String']['output']
  node: Recipient
}

export type RecipientsInput = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type RecipientsResult = RecipientConnection

export type Recommendation = {
  __typename: 'Recommendation'
  category: ProductCategory
  customisable: Scalars['Boolean']['output']
  description: Scalars['String']['output']
  id: Scalars['String']['output']
  isLandscape: Scalars['Boolean']['output']
  masterVariant: RecommendedProductVariant
  publishDate?: Maybe<Scalars['DateTime']['output']>
  rating?: Maybe<ProductRating>
  slug: Scalars['String']['output']
  title: Scalars['String']['output']
  variants: Array<RecommendedProductVariant>
}

export type RecommendationCategory = {
  __typename: 'RecommendationCategory'
  categoryName: Scalars['String']['output']
  recommendations: Array<Recommendation>
}

export type RecommendationFacet = {
  __typename: 'RecommendationFacet'
  name: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type RecommendationFacetDetails = {
  __typename: 'RecommendationFacetDetails'
  facetKey?: Maybe<Scalars['String']['output']>
  group: Scalars['String']['output']
  name: Scalars['String']['output']
  path: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type RecommendationFacets = {
  age?: InputMaybe<Scalars['String']['input']>
  occasion?: InputMaybe<Scalars['String']['input']>
  recipient?: InputMaybe<Scalars['String']['input']>
}

export type RecommendationProductCategories = {
  __typename: 'RecommendationProductCategories'
  description?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  products: Array<Maybe<Product>>
}

export type RecommendationSearchCriteria = {
  __typename: 'RecommendationSearchCriteria'
  department: DepartmentsEnum
  facetDetails: Array<RecommendationFacetDetails>
  /** @deprecated use facet details for new IA */
  facets: Array<RecommendationFacet>
}

export enum RecommendationType {
  FALLBACK = 'FALLBACK',
  PERSONALISED = 'PERSONALISED',
  TRENDING = 'TRENDING',
  USER_AFFINITY = 'USER_AFFINITY',
}

export type Recommendations = {
  __typename: 'Recommendations'
  categories: Array<RecommendationProductCategories>
  categoryList?: Maybe<CategoryListResult>
  products: Array<Maybe<Product>>
  promotion?: Maybe<RecommendedPromotion>
  referenceLineItemId?: Maybe<Scalars['ID']['output']>
}

export type RecommendationscategoriesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

export type RecommendationscategoryListArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
}

export type RecommendationsCategory = {
  __typename: 'RecommendationsCategory'
  /** @deprecated Moving to recommendation type and category enums */
  name: Scalars['String']['output']
  products: Array<Product>
  recommendationCategory?: Maybe<ReminderRecommendationCategory>
  recommendationType: RecommendationType
  searchCriteria: RecommendationSearchCriteria
}

export type RecommendedProductVariant = {
  __typename: 'RecommendedProductVariant'
  images: Array<Image>
  inStock: Scalars['Boolean']['output']
  key: Scalars['String']['output']
  masterImage: Image
  minimumQuantity: Scalars['Int']['output']
  price: Money
  sizeId: Scalars['Int']['output']
  sku?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type RecommendedPromotion = {
  __typename: 'RecommendedPromotion'
  code: Scalars['String']['output']
  message: Scalars['String']['output']
}

export type RedeemableDigitalGift = {
  __typename: 'RedeemableDigitalGift'
  action: RedemptionAction
  customerFacingReference?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  sku: Scalars['String']['output']
}

export type Redemption = {
  __typename: 'Redemption'
  items: Array<RedemptionItem>
}

export type RedemptionAction =
  | ActivateDigitalGift
  | RedirectToSupplier
  | ViewDigitalGift

export type RedemptionActivationFailedError = Error & {
  __typename: 'RedemptionActivationFailedError'
  message: Scalars['String']['output']
}

export type RedemptionExpiredError = Error & {
  __typename: 'RedemptionExpiredError'
  message: Scalars['String']['output']
}

export type RedemptionInput = {
  id: Scalars['ID']['input']
}

export type RedemptionItem = RedeemableDigitalGift | UnredeemableGift

export type RedemptionNotFoundError = Error & {
  __typename: 'RedemptionNotFoundError'
  message: Scalars['String']['output']
}

export type RedemptionResult =
  | Redemption
  | RedemptionActivationFailedError
  | RedemptionExpiredError
  | RedemptionNotFoundError

export type Redirect = {
  __typename: 'Redirect'
  url: Scalars['String']['output']
}

export type RedirectToSupplier = {
  __typename: 'RedirectToSupplier'
  url: Scalars['String']['output']
}

export enum Region {
  au = 'au',
  ie = 'ie',
  nl = 'nl',
  uk = 'uk',
  us = 'us',
}

export type RegisterEmailInput = {
  emailAddress: Scalars['String']['input']
}

export type RegisterEmailResult = InvalidEmailError | RegisterEmailSuccess

export type RegisterEmailSuccess = {
  __typename: 'RegisterEmailSuccess'
  emailAddress: Scalars['String']['output']
}

export type RelatedTerms = {
  __typename: 'RelatedTerms'
  terms: Array<Scalars['String']['output']>
}

export enum Relationship {
  AUNTIE = 'AUNTIE',
  AUNTIEUNCLE = 'AUNTIEUNCLE',
  BOYFRIEND = 'BOYFRIEND',
  BROTHER = 'BROTHER',
  BROTHER_IN_LAW = 'BROTHER_IN_LAW',
  BROTHER_SISTERINLAW = 'BROTHER_SISTERINLAW',
  DAD = 'DAD',
  DATING_COUPLE = 'DATING_COUPLE',
  DAUGHTER = 'DAUGHTER',
  DAUGHTER_SONINLAW = 'DAUGHTER_SONINLAW',
  FEMALE_COLLEAGUE = 'FEMALE_COLLEAGUE',
  FEMALE_COUSIN = 'FEMALE_COUSIN',
  FEMALE_FRIEND = 'FEMALE_FRIEND',
  FEMALE_TEACHER = 'FEMALE_TEACHER',
  FIANCE = 'FIANCE',
  FIANCEE = 'FIANCEE',
  GIRLFRIEND = 'GIRLFRIEND',
  GODDAUGHTER = 'GODDAUGHTER',
  GODSON = 'GODSON',
  GRANDAD = 'GRANDAD',
  GRANDDAUGHTER = 'GRANDDAUGHTER',
  GRANDSON = 'GRANDSON',
  GRANNY = 'GRANNY',
  GRANNYGRANDAD = 'GRANNYGRANDAD',
  HUSBAND = 'HUSBAND',
  MALE_COLLEAGUE = 'MALE_COLLEAGUE',
  MALE_COUSIN = 'MALE_COUSIN',
  MALE_FRIEND = 'MALE_FRIEND',
  MALE_TEACHER = 'MALE_TEACHER',
  MARRIED_COUPLE = 'MARRIED_COUPLE',
  MUM = 'MUM',
  MUMDAD = 'MUMDAD',
  NEWLY_WEDS = 'NEWLY_WEDS',
  NIECE = 'NIECE',
  SISTER = 'SISTER',
  SISTER_IN_LAW = 'SISTER_IN_LAW',
  SON = 'SON',
  SON_DAUGHTERINLAW = 'SON_DAUGHTERINLAW',
  TWINS = 'TWINS',
  UNCLE = 'UNCLE',
  UNCLE_NEPHEW = 'UNCLE_NEPHEW',
  WIFE = 'WIFE',
}

export type Reminder = Node & {
  __typename: 'Reminder'
  addressIds: Array<Scalars['String']['output']>
  created: Scalars['String']['output']
  daysBeforeOccasionToRemind?: Maybe<Scalars['Int']['output']>
  fulfilledThisCalendarYear: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  lastOrder?: Maybe<Order>
  name: Scalars['String']['output']
  nextDate: Scalars['String']['output']
  occasion: Occasion
  recipientId: Scalars['ID']['output']
  recommendations: Array<RecommendationsCategory>
  relationship?: Maybe<Relationship>
  source: Source
}

export type ReminderrecommendationsArgs = {
  store?: InputMaybe<Store>
}

export type ReminderAlreadyExists = Error & {
  __typename: 'ReminderAlreadyExists'
  message: Scalars['String']['output']
}

export type ReminderInput = {
  checkIfReminderExists?: InputMaybe<Scalars['Boolean']['input']>
  daysBeforeOccasionToRemind?: InputMaybe<Scalars['Int']['input']>
  name: Scalars['String']['input']
  occasion: Occasion
  occasionDate: OccasionDateInput
  orderData?: InputMaybe<OrderData>
  orderId?: InputMaybe<Scalars['ID']['input']>
  relationship?: InputMaybe<Relationship>
  source: Source
  store?: InputMaybe<Store>
}

export type ReminderNotFound = Error & {
  __typename: 'ReminderNotFound'
  id: Scalars['ID']['output']
  message: Scalars['String']['output']
}

export type ReminderOccasion = {
  __typename: 'ReminderOccasion'
  defaultDate?: Maybe<OccasionDate>
  defaultRelationship?: Maybe<Relationship>
  facetKeys: Array<Scalars['String']['output']>
  label: Scalars['String']['output']
  occasion: Occasion
}

export enum ReminderRecommendationCategory {
  CARDS = 'CARDS',
  DIGITAL_GIFTS = 'DIGITAL_GIFTS',
  FLOWERS = 'FLOWERS',
  GIFTS = 'GIFTS',
  UNKNOWN = 'UNKNOWN',
}

export type ReminderRelationship = {
  __typename: 'ReminderRelationship'
  label: Scalars['String']['output']
  relationship: Relationship
}

export type RemindersFromProductsInput = {
  orderDate: OccasionDateInput
  orderRecipientData: Array<OrderRecipientData>
  source?: InputMaybe<Source>
}

export type RemoveAddressInput = {
  id: Scalars['String']['input']
}

export type RemoveAddressResult = AddressError | RemoveAddressSuccess

export type RemoveAddressSuccess = {
  __typename: 'RemoveAddressSuccess'
  addressBook?: Maybe<AddressBook>
}

export type RemoveBasketVoucherInput = {
  id: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type RemoveBasketVoucherResult =
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError

export type RemoveCustomerAddressResult =
  | AddressNotFoundError
  | ConcurrentModificationError
  | Customer

export type RemoveFromFavouritesList = {
  __typename: 'RemoveFromFavouritesList'
  products: Array<Maybe<Product>>
}

export type RemoveMembershipFromBasketInput = {
  id: Scalars['ID']['input']
  version: Scalars['Long']['input']
}

export type RemoveMembershipFromBasketResult =
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | UserInputError

export type RemoveSavedCardError = {
  __typename: 'RemoveSavedCardError'
  message: Scalars['String']['output']
}

export type RemoveSavedCardInput = {
  paymentMethodId: Scalars['String']['input']
}

export type RemoveSavedCardResult =
  | RemoveSavedCardError
  | RemoveSavedCardSuccess

export type RemoveSavedCardSuccess = {
  __typename: 'RemoveSavedCardSuccess'
  messageId: Scalars['String']['output']
}

export enum RendererContentType {
  jpeg = 'jpeg',
  png = 'png',
}

export type RendererDynamicImage = {
  __typename: 'RendererDynamicImage'
  height: Scalars['Int']['output']
  url: Scalars['String']['output']
  width: Scalars['Int']['output']
}

export enum RendererDynamicImageFormat {
  JPEG = 'JPEG',
  PNG = 'PNG',
}

export type RendererDynamicImageResult =
  | RendererDynamicImage
  | RendererServiceError

export enum RendererFontFacePreset {
  BOLD = 'BOLD',
  REGULAR = 'REGULAR',
}

export type RendererImage = {
  __typename: 'RendererImage'
  height: Scalars['Int']['output']
  url: Scalars['String']['output']
  width: Scalars['Int']['output']
}

export type RendererImageResult = RendererImage | RendererServiceError

export type RendererImageUrls = {
  __typename: 'RendererImageUrls'
  editor: Scalars['String']['output']
  preview: Scalars['String']['output']
  print: Scalars['String']['output']
}

export type RendererInlayImage = {
  __typename: 'RendererInlayImage'
  height: Scalars['Int']['output']
  url: Scalars['String']['output']
  width: Scalars['Int']['output']
}

export type RendererInlayImageResult = RendererInlayImage | RendererServiceError

export type RendererInteractiveElement = RendererInteractiveElementLink

export type RendererInteractiveElementLink = {
  __typename: 'RendererInteractiveElementLink'
  height: Scalars['Float']['output']
  label: Scalars['String']['output']
  url: Scalars['String']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type RendererNotFoundError = Error & {
  __typename: 'RendererNotFoundError'
  message: Scalars['String']['output']
}

export enum RendererProductCategory {
  LandscapeCard = 'LandscapeCard',
  Mug = 'Mug',
  PortraitCard = 'PortraitCard',
  SquareCard = 'SquareCard',
  TShirt = 'TShirt',
  Unknown = 'Unknown',
}

export type RendererSceneObject =
  | RendererSceneObjectImage
  | RendererSceneObjectLink
  | RendererSceneObjectQRCode
  | RendererSceneObjectText

export type RendererSceneObjectCommon = {
  height: Scalars['Float']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type RendererSceneObjectImage = RendererSceneObjectCommon & {
  __typename: 'RendererSceneObjectImage'
  height: Scalars['Float']['output']
  urls: RendererImageUrls
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

/**
 * Link scene object which will be rendered on eCards for recipients to click on.
 * Generally the position & size should cover the whole of the media element so recipients don't have to click in a specific place.
 */
export type RendererSceneObjectLink = RendererSceneObjectCommon & {
  __typename: 'RendererSceneObjectLink'
  height: Scalars['Float']['output']
  /** Title or accessible name of the link. */
  label: Scalars['String']['output']
  /** URL to send the recipient to when they click on the link. */
  url: Scalars['String']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type RendererSceneObjectQRCode = RendererSceneObjectCommon & {
  __typename: 'RendererSceneObjectQRCode'
  height: Scalars['Float']['output']
  value: Scalars['String']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type RendererSceneObjectText = RendererSceneObjectCommon & {
  __typename: 'RendererSceneObjectText'
  height: Scalars['Float']['output']
  text: Scalars['String']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type RendererServiceError = Error & {
  __typename: 'RendererServiceError'
  message: Scalars['String']['output']
}

export type RendererShareableImage = {
  __typename: 'RendererShareableImage'
  height: Scalars['Int']['output']
  url: Scalars['String']['output']
  width: Scalars['Int']['output']
}

export type RendererShareableImageScene = {
  __typename: 'RendererShareableImageScene'
  height: Scalars['Float']['output']
  image: RendererShareableImage
  interactiveElements: Array<RendererInteractiveElement>
  title: Scalars['String']['output']
  width: Scalars['Float']['output']
}

export type RendererShareableImages = {
  __typename: 'RendererShareableImages'
  layout: RendererShareableImagesLayout
  scenes: Array<RendererShareableImageScene>
}

export enum RendererShareableImagesLayout {
  CARD_LANDSCAPE = 'CARD_LANDSCAPE',
  CARD_PORTRAIT = 'CARD_PORTRAIT',
  GENERIC = 'GENERIC',
}

export type RendererShareableImagesResult =
  | RendererNotFoundError
  | RendererServiceError
  | RendererShareableImages

export type RendererSubstitutionInput = {
  name: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type RenewalFrequency = {
  __typename: 'RenewalFrequency'
  intervalCount: Scalars['Int']['output']
  intervalUnit: RenewalFrequencyIntervalUnit
}

export enum RenewalFrequencyIntervalUnit {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MINUTE = 'MINUTE',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export type RequestOrderCancellationInput = {
  customerId?: InputMaybe<Scalars['String']['input']>
  deliveries?: InputMaybe<Array<Scalars['String']['input']>>
  orderId: Scalars['String']['input']
}

export type RequestOrderCancellationResult =
  | OrderCancellationError
  | OrderCancellationSummary

export enum RequestResendErrorCode {
  ORDER_NOT_ELIGIBLE = 'ORDER_NOT_ELIGIBLE',
  ORDER_NOT_FOUND = 'ORDER_NOT_FOUND',
  RESEND_ALREADY_EXISTS = 'RESEND_ALREADY_EXISTS',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
}

export type RequestResendFailure = RequestResendResult & {
  __typename: 'RequestResendFailure'
  errorCode: RequestResendErrorCode
  message: Scalars['String']['output']
}

export type RequestResendInput = {
  customerId: Scalars['String']['input']
  orderId: Scalars['String']['input']
}

export type RequestResendResult = {
  message: Scalars['String']['output']
}

export type RequestResendSuccess = RequestResendResult & {
  __typename: 'RequestResendSuccess'
  message: Scalars['String']['output']
  orderId: Scalars['String']['output']
}

export type RequiredAge = {
  __typename: 'RequiredAge'
  description: Scalars['String']['output']
  minAge: Scalars['Int']['output']
  title: Scalars['String']['output']
}

export type RevokeMembershipByCustomerIdResponse = {
  __typename: 'RevokeMembershipByCustomerIdResponse'
  success: Scalars['Boolean']['output']
}

export type RichTextBlock = RichTextBlockHTML | RichTextBlockModule

export type RichTextBlockHTML = {
  __typename: 'RichTextBlockHTML'
  html: Scalars['String']['output']
}

export type RichTextBlockModule = {
  __typename: 'RichTextBlockModule'
  module: Module
}

export type SEOBlock = {
  __typename: 'SEOBlock'
  richText?: Maybe<Scalars['String']['output']>
  text: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type SavedCard = {
  __typename: 'SavedCard'
  cardType: Scalars['String']['output']
  /** @deprecated Use `savedCards` on `basket`. */
  cvcRequired: Scalars['Boolean']['output']
  dateAdded: Scalars['String']['output']
  expired: Scalars['Boolean']['output']
  expiry: Scalars['String']['output']
  hasActiveMembership: Scalars['Boolean']['output']
  isNonWallet: Scalars['Boolean']['output']
  lastFourDigits: Scalars['String']['output']
  nameOnCard: Scalars['String']['output']
  paymentMethodId: Scalars['String']['output']
}

export type SavedCards = {
  __typename: 'SavedCards'
  cvcRequired: Scalars['Boolean']['output']
}

export type SceneImage = {
  __typename: 'SceneImage'
  title: Scalars['String']['output']
  variants: SceneImageVariants
}

export type SceneImageVariant = {
  __typename: 'SceneImageVariant'
  height: Scalars['Int']['output']
  url: Scalars['String']['output']
  width: Scalars['Int']['output']
}

export type SceneImageVariants = {
  __typename: 'SceneImageVariants'
  large: SceneImageVariant
  small: SceneImageVariant
}

export type SceneImages = {
  __typename: 'SceneImages'
  images: Array<SceneImage>
}

export type SceneImagesResult = RendererServiceError | SceneImages

export type SearchInspirationsResults = {
  __typename: 'SearchInspirationsResults'
  inspirations: Array<InspirationItem>
}

export type SearchSuggestResults = {
  __typename: 'SearchSuggestResults'
  suggestions: Array<SearchSuggestion>
}

export type SearchSuggestion = {
  __typename: 'SearchSuggestion'
  arguments: SearchSuggestionArguments
  departmentCounts: Array<DepartmentCount>
  departments: Array<DepartmentsEnum>
  score: Scalars['Decimal']['output']
  searchTerm: Scalars['String']['output']
}

export type SearchSuggestionArguments = {
  __typename: 'SearchSuggestionArguments'
  filters?: Maybe<SearchSuggestionFilters>
  searchTerm?: Maybe<Scalars['String']['output']>
}

export type SearchSuggestionFacet = {
  __typename: 'SearchSuggestionFacet'
  facetKey: Scalars['String']['output']
  groups: Array<FacetGroup>
  label?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  path?: Maybe<Scalars['String']['output']>
  value: Scalars['String']['output']
}

export type SearchSuggestionFilters = {
  __typename: 'SearchSuggestionFilters'
  facets?: Maybe<Array<SearchSuggestionFacet>>
}

export type SearchTermInspiration = {
  __typename: 'SearchTermInspiration'
  department: DepartmentsEnum
  searchTerm: Scalars['String']['output']
}

export type SelfServe = {
  canSelfServe: Scalars['Boolean']['output']
}

export type SelfServeCheck = {
  __typename: 'SelfServeCheck'
  ruleName: Scalars['String']['output']
  userFriendlyError: Scalars['String']['output']
}

export type SelfServeFailure = SelfServe & {
  __typename: 'SelfServeFailure'
  canSelfServe: Scalars['Boolean']['output']
  failedChecks?: Maybe<Array<SelfServeCheck>>
}

export type SelfServeSuccess = SelfServe & {
  __typename: 'SelfServeSuccess'
  canSelfServe: Scalars['Boolean']['output']
}

export type SelfValidateAddressInput = {
  id: Scalars['String']['input']
}

export type SelfValidateAddressResult =
  | ConcurrentModificationError
  | SelfValidatedAddressResult

export type SelfValidatedAddressResult = {
  __typename: 'SelfValidatedAddressResult'
  address: ShippingAddress
}

export type SetBusinessProjectSourceInput = {
  source: Scalars['String']['input']
}

export type SetBusinessRecipientsInput = {
  recipients: Array<BusinessRecipientInput>
}

export type SetDesignCustomisationsInput = {
  designId: Scalars['ID']['input']
  scenes: Array<DesignCustomisationsSceneInput>
  /** @deprecated No longer used */
  videoCardId?: InputMaybe<Scalars['String']['input']>
}

export type SetDesignCustomisationsResult =
  | Design
  | DesignAuthorizationError
  | DesignCustomisationsInputError
  | DesignInvalidTokenError
  | DesignNotFoundError
  | DesignServiceError
  | DesignStateError
  | DesignTemplatesServiceError

export type SetDesignInlayInput = {
  designId: Scalars['String']['input']
  inlayId: Scalars['String']['input']
  metadata: DesignInlayMetadata
}

export type SetDesignInlayResult =
  | Design
  | DesignAuthorizationError
  | DesignNotFoundError
  | DesignServiceError
  | DesignSetInlayError
  | DesignStateError
  | DesignTemplatesServiceError

export type ShareReminder = {
  __typename: 'ShareReminder'
  url: Scalars['String']['output']
}

export type ShareReminderInput = {
  id: Scalars['String']['input']
  store?: InputMaybe<Store>
}

export type ShareReminderResult = ReminderNotFound | ShareReminder

export type SharedReminder = {
  __typename: 'SharedReminder'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  nextDate: Scalars['String']['output']
  occasion: Occasion
}

export type SharedReminderResult =
  | BadRequest
  | ReminderNotFound
  | SharedReminder

export type ShippingAddress = {
  __typename: 'ShippingAddress'
  addressFirstLine: Scalars['String']['output']
  city?: Maybe<Scalars['String']['output']>
  country: Scalars['String']['output']
  deliveryPointSuffix?: Maybe<Scalars['String']['output']>
  extraAddressLine?: Maybe<Scalars['String']['output']>
  firstName: Scalars['String']['output']
  houseNumber?: Maybe<Scalars['String']['output']>
  houseNumberExtension?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  isMyAddress: Scalars['Boolean']['output']
  isTypeVerified?: Maybe<Scalars['Boolean']['output']>
  isVerified?: Maybe<Scalars['Boolean']['output']>
  lastName: Scalars['String']['output']
  postcode?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  streetName?: Maybe<Scalars['String']['output']>
  /** @deprecated No longer in use */
  title?: Maybe<Scalars['String']['output']>
}

export type SimpleDeliveryStage = DeliveryStage & {
  __typename: 'SimpleDeliveryStage'
  label: Scalars['String']['output']
  progress: DeliveryPipelineProgressState
  stageNumber: Scalars['Int']['output']
  timestamp?: Maybe<Scalars['Date']['output']>
}

export type SizedImage = {
  __typename: 'SizedImage'
  jpgUrl: Scalars['String']['output']
}

export enum SortOrder {
  NEWNESS = 'NEWNESS',
  POPULARITY = 'POPULARITY',
  PRICE_ASCENDING = 'PRICE_ASCENDING',
  PRICE_DESCENDING = 'PRICE_DESCENDING',
  RATING_DESCENDING = 'RATING_DESCENDING',
}

export type SortOrderDescriptor = {
  __typename: 'SortOrderDescriptor'
  displayText: Scalars['String']['output']
  isDefault: Scalars['Boolean']['output']
  value: SortOrder
}

export enum Sorts {
  WEIGHTED_ADD_TO_BASKET_RANK = 'WEIGHTED_ADD_TO_BASKET_RANK',
  WEIGHTED_ADD_TO_BASKET_RANK_PLATFORM = 'WEIGHTED_ADD_TO_BASKET_RANK_PLATFORM',
  WEIGHTED_ADD_TO_BASKET_RANK_USER_AFFINITY = 'WEIGHTED_ADD_TO_BASKET_RANK_USER_AFFINITY',
  WEIGHTED_ADD_TO_BASKET_RANK_V2 = 'WEIGHTED_ADD_TO_BASKET_RANK_V2',
  WEIGHTED_CLICK_RANK = 'WEIGHTED_CLICK_RANK',
  WEIGHTED_PERSONALISED_RANK = 'WEIGHTED_PERSONALISED_RANK',
}

export enum Source {
  ANDROID_BACK_TO_ME = 'ANDROID_BACK_TO_ME',
  ANDROID_CREATE_ADDRESS = 'ANDROID_CREATE_ADDRESS',
  ANDROID_INFLOW_QUICK_ADD = 'ANDROID_INFLOW_QUICK_ADD',
  ANDROID_REMINDERS_TAB = 'ANDROID_REMINDERS_TAB',
  ANDROID_SEND_DIRECT = 'ANDROID_SEND_DIRECT',
  ANDROID_SOFT_OPT_IN_QUICK_ADD = 'ANDROID_SOFT_OPT_IN_QUICK_ADD',
  ANDROID_SOFT_OPT_IN_REMINDERS = 'ANDROID_SOFT_OPT_IN_REMINDERS',
  EMAIL_UNKNOWN = 'EMAIL_UNKNOWN',
  FACEBOOK_UNKNOWN = 'FACEBOOK_UNKNOWN',
  IOS_BACK_TO_ME_INFLOW_REMINDER = 'IOS_BACK_TO_ME_INFLOW_REMINDER',
  IOS_BULK_IMPORT = 'IOS_BULK_IMPORT',
  IOS_CREATE_ADDRESS = 'IOS_CREATE_ADDRESS',
  IOS_INCENTIVISED_REMINDER_MODAL = 'IOS_INCENTIVISED_REMINDER_MODAL',
  IOS_INFLOW_QUICK_ADD = 'IOS_INFLOW_QUICK_ADD',
  IOS_ORDER_CONFIRMATION = 'IOS_ORDER_CONFIRMATION',
  IOS_REMINDERS_TAB = 'IOS_REMINDERS_TAB',
  IOS_SEND_DIRECT = 'IOS_SEND_DIRECT',
  IOS_SOFT_OPT_IN_QUICK_ADD = 'IOS_SOFT_OPT_IN_QUICK_ADD',
  IOS_SOFT_OPT_IN_REMINDERS = 'IOS_SOFT_OPT_IN_REMINDERS',
  UNKNOWN = 'UNKNOWN',
  WEB_INCENTIVISED_REMINDER_MODAL = 'WEB_INCENTIVISED_REMINDER_MODAL',
  WEB_INCENTIVISED_REMINDER_MODAL_QUICK_ADD = 'WEB_INCENTIVISED_REMINDER_MODAL_QUICK_ADD',
  WEB_INFLOW_MODAL = 'WEB_INFLOW_MODAL',
  WEB_INFLOW_QUICK_ADD = 'WEB_INFLOW_QUICK_ADD',
  WEB_LOAD_TEST = 'WEB_LOAD_TEST',
  WEB_MIGRATED_REMINDER_FLOW = 'WEB_MIGRATED_REMINDER_FLOW',
  WEB_MULTI_INFLOW_MODAL = 'WEB_MULTI_INFLOW_MODAL',
  WEB_ORDER_CONFIRMATION = 'WEB_ORDER_CONFIRMATION',
  WEB_REMINDER_MODAL = 'WEB_REMINDER_MODAL',
  WEB_REMINDER_MODAL_QUICK_ADD = 'WEB_REMINDER_MODAL_QUICK_ADD',
  WEB_REMINDER_PAGE = 'WEB_REMINDER_PAGE',
  WEB_SHARED_REMINDER = 'WEB_SHARED_REMINDER',
  WEB_SOFT_OPT_IN_QUICK_ADD = 'WEB_SOFT_OPT_IN_QUICK_ADD',
  WEB_SOFT_OPT_IN_REMINDERS = 'WEB_SOFT_OPT_IN_REMINDERS',
  WEB_UNKNOWN = 'WEB_UNKNOWN',
}

export type SpellingCorrection = {
  __typename: 'SpellingCorrection'
  correctedSearchTerm: Scalars['String']['output']
  initialSearchTerm: Scalars['String']['output']
}

export type SplitLineItemQuantityInput = {
  lineItemId: Scalars['ID']['input']
}

export type SplitLineItemQuantityResult =
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | LineItemNotFoundError

export type SplitMultiCardsInput = {
  id: Scalars['ID']['input']
}

export type SplitMultiCardsResult = Basket

export type SponsoredProduct = {
  __typename: 'SponsoredProduct'
  internallyPromoted: Scalars['Boolean']['output']
  productKey: Scalars['String']['output']
}

export type SponsoredProductInput = {
  internallyPromoted: Scalars['Boolean']['input']
  productKey: Scalars['String']['input']
}

export type StandardLineItemPrice = {
  __typename: 'StandardLineItemPrice'
  value: Money
}

export type Sticker = {
  __typename: 'Sticker'
  id: Scalars['ID']['output']
  urls: StickerUrls
}

export type StickerEdge = {
  __typename: 'StickerEdge'
  cursor: Scalars['ID']['output']
  node: Sticker
}

export type StickerEdges = {
  __typename: 'StickerEdges'
  edges: Array<StickerEdge>
  pageInfo: StickerPageInfo
  totalCount: Scalars['Int']['output']
}

export type StickerPageInfo = {
  __typename: 'StickerPageInfo'
  endCursor?: Maybe<Scalars['ID']['output']>
  hasNextPage: Scalars['Boolean']['output']
}

export type StickerUrls = {
  __typename: 'StickerUrls'
  editor: Scalars['String']['output']
  editorThumbnail: Scalars['String']['output']
  preview: Scalars['String']['output']
  print: Scalars['String']['output']
}

export type StickersFilterInput = {
  stickerSetIds: Array<Scalars['ID']['input']>
}

export type StickersResult =
  | DesignInvalidCursorError
  | DesignServiceError
  | StickerEdges

export type StockValidation = BasketValidation & {
  __typename: 'StockValidation'
  isBlocking: Scalars['Boolean']['output']
  message: Scalars['String']['output']
  title: Scalars['String']['output']
}

export enum Store {
  AU = 'AU',
  IE = 'IE',
  UK = 'UK',
  US = 'US',
}

export enum StoresEnumType {
  AU = 'AU',
  IE = 'IE',
  UK = 'UK',
  US = 'US',
}

export type StructuredData = {
  __typename: 'StructuredData'
  json: Scalars['String']['output']
}

export type SuggestedAddress = {
  __typename: 'SuggestedAddress'
  addressFirstLine: Scalars['String']['output']
  addressId: Scalars['String']['output']
  city?: Maybe<Scalars['String']['output']>
  country: Scalars['String']['output']
  extraAddressLine?: Maybe<Scalars['String']['output']>
  firstName: Scalars['String']['output']
  houseNumber?: Maybe<Scalars['String']['output']>
  houseNumberExtension?: Maybe<Scalars['String']['output']>
  isMyAddress: Scalars['Boolean']['output']
  lastName: Scalars['String']['output']
  postcode?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
}

export type SuggestedCustomerAddressLine = {
  __typename: 'SuggestedCustomerAddressLine'
  hasChanges: Scalars['Boolean']['output']
  value: Scalars['String']['output']
}

export type SuggestedCustomerAddressResult = {
  __typename: 'SuggestedCustomerAddressResult'
  address: SuggestedAddress
  original: Array<SuggestedCustomerAddressLine>
  suggested: Array<SuggestedCustomerAddressLine>
}

export type SuggestedDeliveryMethod = {
  __typename: 'SuggestedDeliveryMethod'
  deliveryDate: Scalars['Date']['output']
  methodId: Scalars['String']['output']
}

export type SuggestedDeliveryOption = {
  __typename: 'SuggestedDeliveryOption'
  dateDisplay?: Maybe<Scalars['String']['output']>
  deliveryGuarantee?: Maybe<DeliveryGuarantee>
  description?: Maybe<Scalars['String']['output']>
  method: SuggestedDeliveryMethod
  price: Scalars['String']['output']
  title: Scalars['String']['output']
  trackingTag: Scalars['String']['output']
  type: SuggestedDeliveryOptionType
}

export enum SuggestedDeliveryOptionType {
  ASAP = 'ASAP',
  SCHEDULED = 'SCHEDULED',
}

export type SuggestedMessage = {
  __typename: 'SuggestedMessage'
  category: Scalars['String']['output']
  messages: Array<Scalars['String']['output']>
}

export enum SuggestedMessageLength {
  LONG = 'LONG',
  MEDIUM = 'MEDIUM',
  SHORT = 'SHORT',
}

export type SuggestedMessages = {
  __typename: 'SuggestedMessages'
  values: Array<Scalars['String']['output']>
}

export type SuggestedMessagesError = Error & {
  __typename: 'SuggestedMessagesError'
  message: Scalars['String']['output']
}

export type SuggestedMessagesInput = {
  details?: InputMaybe<Scalars['String']['input']>
  length?: InputMaybe<SuggestedMessageLength>
  occasion: Scalars['String']['input']
  relationship?: InputMaybe<Scalars['String']['input']>
  tone?: InputMaybe<Scalars['String']['input']>
}

export type SuggestedMessagesModeratedError = Error & {
  __typename: 'SuggestedMessagesModeratedError'
  message: Scalars['String']['output']
}

export type SuggestedMessagesOption = {
  __typename: 'SuggestedMessagesOption'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type SuggestedMessagesOptions = {
  __typename: 'SuggestedMessagesOptions'
  occasions: Array<SuggestedMessagesOption>
  relationships: Array<SuggestedMessagesOption>
  tones: Array<SuggestedMessagesOption>
}

export type SuggestedMessagesOptionsResult =
  | SuggestedMessagesError
  | SuggestedMessagesOptions

export type SuggestedMessagesResult =
  | SuggestedMessages
  | SuggestedMessagesError
  | SuggestedMessagesModeratedError

export type SuggestedReminder = {
  __typename: 'SuggestedReminder'
  date: OccasionDate
  occasion: Occasion
  relationship?: Maybe<Relationship>
}

export enum SuggesterType {
  DYNAMIC = 'DYNAMIC',
  FACETS = 'FACETS',
  STATIC = 'STATIC',
}

export type Suggestions = {
  __typename: 'Suggestions'
  messages?: Maybe<SuggestedMessagesResult>
  messagesOptions: SuggestedMessagesOptionsResult
}

export type SuggestionsmessagesArgs = {
  input: SuggestedMessagesInput
}

export type SupportOptions = {
  __typename: 'SupportOptions'
  amend: Scalars['Boolean']['output']
  resend: Scalars['Boolean']['output']
}

export type TermsAndConditions = {
  __typename: 'TermsAndConditions'
  copy: Scalars['String']['output']
  headingCopy: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type Tile = {
  __typename: 'Tile'
  image: ContentImage
  label?: Maybe<TileLabel>
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type TileLabel = LabelPromo | LabelRoundel

export enum TileLabelVariant {
  Default = 'Default',
  Promo = 'Promo',
}

export type ToggleFilter = {
  __typename: 'ToggleFilter'
  facetKey: Scalars['String']['output']
  group: Scalars['String']['output']
  icon?: Maybe<Scalars['String']['output']>
  isAutoApplied?: Maybe<Scalars['Boolean']['output']>
  isQuickFilter?: Maybe<Scalars['Boolean']['output']>
  isSelected: Scalars['Boolean']['output']
  isUserSelected: Scalars['Boolean']['output']
  label: Scalars['String']['output']
  toggleType: ToggleType
}

export enum ToggleType {
  EDITABLE_NUMBER = 'EDITABLE_NUMBER',
  NOT_RUDE = 'NOT_RUDE',
  PERSONALISABLE = 'PERSONALISABLE',
  PHOTO_CARDS = 'PHOTO_CARDS',
}

export type TrackRecipientInput = {
  trackingId: Scalars['ID']['input']
}

export type TrackRecipientResult = {
  message: Scalars['String']['output']
}

export type TrackRecipientResultFailed = TrackRecipientResult & {
  __typename: 'TrackRecipientResultFailed'
  message: Scalars['String']['output']
}

export type TrackRecipientResultSuccess = TrackRecipientResult & {
  __typename: 'TrackRecipientResultSuccess'
  message: Scalars['String']['output']
}

export type TrackingInformation = {
  __typename: 'TrackingInformation'
  deliveryDate?: Maybe<Scalars['String']['output']>
  fullTrackingUrl?: Maybe<Scalars['String']['output']>
}

export type TrackingInformationInput = {
  trackingId: Scalars['ID']['input']
}

export type TrackingInformationInvalidTrackingId = Error & {
  __typename: 'TrackingInformationInvalidTrackingId'
  message: Scalars['String']['output']
}

export type TrackingInformationResult =
  | TrackingInformation
  | TrackingInformationInvalidTrackingId

export type Transaction = {
  __typename: 'Transaction'
  amount: Money
  id: Scalars['ID']['output']
  interactionId: Scalars['String']['output']
  state: TransactionState
  type: TransactionType
}

export enum TransactionState {
  Failure = 'Failure',
  Initial = 'Initial',
  Pending = 'Pending',
  Success = 'Success',
}

export enum TransactionType {
  Authorization = 'Authorization',
  CancelAuthorization = 'CancelAuthorization',
  Charge = 'Charge',
  Chargeback = 'Chargeback',
  Refund = 'Refund',
}

export type USP = {
  __typename: 'USP'
  description: Scalars['String']['output']
  icon?: Maybe<ContentImage>
  title: Scalars['String']['output']
}

export type UnlinkReminderFromOrderResult = Reminder | ReminderNotFound

export type UnredeemableGift = {
  __typename: 'UnredeemableGift'
  customerFacingReference?: Maybe<Scalars['String']['output']>
  giftSku?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
}

export type UpdateAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  country: Scalars['String']['input']
  extraAddressLine?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  houseNumber?: InputMaybe<Scalars['String']['input']>
  houseNumberExtension?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
  isMyAddress?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  streetName: Scalars['String']['input']
}

export type UpdateAddressPackagingInput = {
  addressId: Scalars['String']['input']
  id: Scalars['ID']['input']
  requiresPackaging: Scalars['Boolean']['input']
}

export type UpdateAddressPackagingResult =
  | AddressNotFoundError
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryAddressInvalidError
  | DeliveryCountryInvalidError
  | DeliveryRestrictedError

export type UpdateAddressResult = AddressError | UpdateAddressSuccess

export type UpdateAddressSuccess = {
  __typename: 'UpdateAddressSuccess'
  address: ShippingAddress
  addressBook?: Maybe<AddressBook>
}

export type UpdateAddressTypeInput = {
  id: Scalars['ID']['input']
  isMyAddress: Scalars['Boolean']['input']
}

export type UpdateAddressTypeResult = AddressError | UpdateAddressTypeSuccess

export type UpdateAddressTypeSuccess = {
  __typename: 'UpdateAddressTypeSuccess'
  address: ShippingAddress
  addressBook?: Maybe<AddressBook>
}

export type UpdateContactPreferencesInput = {
  preferences: Array<ContactPreferenceInput>
  source: ContactSource
}

export type UpdateCustomerAddressResult =
  | ConcurrentModificationError
  | Customer
  | CustomerAddressInvalidCountry
  | CustomerAddressInvalidError
  | UserInputError

export type UpdateCustomerDetailsInput = {
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  title?: InputMaybe<Scalars['String']['input']>
  version: Scalars['Long']['input']
}

export type UpdateCustomerDetailsResult =
  | ConcurrentModificationError
  | Customer
  | UserInputError

export type UpdateCustomerMarketingConsentPositionInput = {
  position: ConsentPosition
  source: MarketingConsentSource
}

export type UpdateCustomerMarketingConsentPositionResult = Customer

export type UpdateEmailExistingEmail = Error & {
  __typename: 'UpdateEmailExistingEmail'
  message: Scalars['String']['output']
}

export type UpdateEmailFailed = Error & {
  __typename: 'UpdateEmailFailed'
  message: Scalars['String']['output']
}

export type UpdateEmailInvalidEmail = Error & {
  __typename: 'UpdateEmailInvalidEmail'
  message: Scalars['String']['output']
}

export type UpdateEmailResult =
  | Customer
  | UpdateEmailExistingEmail
  | UpdateEmailFailed
  | UpdateEmailInvalidEmail

export type UpdateLineItemInput = {
  id: Scalars['ID']['input']
  lineItemId: Scalars['ID']['input']
  packagingSku?: InputMaybe<Scalars['String']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
  variantSku?: InputMaybe<Scalars['String']['input']>
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type UpdateLineItemQuantityInput = {
  id: Scalars['ID']['input']
  lineItemId: Scalars['ID']['input']
  quantity: Scalars['Int']['input']
  version: Scalars['Long']['input']
}

export type UpdateLineItemQuantityResult =
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError

export type UpdateLineItemResult =
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryRestrictedError
  | ProductNotFoundError
  | UserInputError

export type UpdateLineItemVariantInput = {
  id: Scalars['ID']['input']
  lineItemId: Scalars['ID']['input']
  /** @deprecated Non-functional, replaced by updateLineItem mutation */
  packagingSku?: InputMaybe<Scalars['String']['input']>
  sku: Scalars['String']['input']
  variantId?: InputMaybe<Scalars['Int']['input']>
  version: Scalars['Long']['input']
}

export type UpdateLineItemVariantResult =
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryRestrictedError
  | ProductNotFoundError
  | UserInputError

export enum UpdatePhoneNumberErrorCode {
  CONFLICT = 'CONFLICT',
  INVALID_INPUT = 'INVALID_INPUT',
}

export type UpdatePhoneNumberFailed = Error & {
  __typename: 'UpdatePhoneNumberFailed'
  code: UpdatePhoneNumberErrorCode
  message: Scalars['String']['output']
}

export type UpdatePhoneNumberResult = Customer | UpdatePhoneNumberFailed

export type UpdateReminderInput = {
  name?: InputMaybe<Scalars['String']['input']>
  occasion?: InputMaybe<Occasion>
  occasionDate?: InputMaybe<OccasionDateInput>
  relationship?: InputMaybe<Relationship>
  store?: InputMaybe<Store>
}

export type UpdateReminderResult =
  | BadRequest
  | ReminderNotFound
  | UpdatedReminder

export type UpdatedReminder = Node & {
  __typename: 'UpdatedReminder'
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  occasion?: Maybe<Occasion>
  occasionDate?: Maybe<OccasionDate>
  relationship?: Maybe<Relationship>
  store?: Maybe<Store>
}

export type UserInputError = Error & {
  __typename: 'UserInputError'
  message: Scalars['String']['output']
}

export type UserNotFound = Error & {
  __typename: 'UserNotFound'
  email: Scalars['String']['output']
  message: Scalars['String']['output']
}

export type ValidCustomerAddressResult = {
  __typename: 'ValidCustomerAddressResult'
  address: ShippingAddress
}

export type ValidateBasketInput = {
  id: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type ValidateBasketResult =
  | BasketNotFoundError
  | BasketOrderedError
  | BasketValidatedResult
  | ConcurrentModificationError

export type ValidateCustomerAddressInput = {
  id: Scalars['String']['input']
}

export type ValidateCustomerAddressResult =
  | ConcurrentModificationError
  | InvalidCustomerAddressResult
  | SuggestedCustomerAddressResult
  | ValidCustomerAddressResult

export type VariantAvailability = {
  __typename: 'VariantAvailability'
  isInStock: Scalars['Boolean']['output']
}

export type VariantPackaging = {
  __typename: 'VariantPackaging'
  image: Image
  inStock: Scalars['Boolean']['output']
  price: Money
  sku: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type Versioned = {
  version: Scalars['Long']['output']
}

export type ViewDigitalGift = {
  __typename: 'ViewDigitalGift'
  url: Scalars['String']['output']
}

export type VoucherCode = {
  __typename: 'VoucherCode'
  code: Scalars['String']['output']
  isActive: Scalars['Boolean']['output']
  name?: Maybe<Scalars['String']['output']>
  stateErrorMessage?: Maybe<Scalars['String']['output']>
}

export type VoucherInlay = Inlay & {
  __typename: 'VoucherInlay'
  id: Scalars['ID']['output']
  scene: InlayScene
  sceneObjects: Array<InlaySceneObject>
}

export type VoucherOptions = {
  __typename: 'VoucherOptions'
  defaultCard: Product
}

export type VoucherValidation = BasketValidation & {
  __typename: 'VoucherValidation'
  isBlocking: Scalars['Boolean']['output']
  message: Scalars['String']['output']
  title: Scalars['String']['output']
}
